"use client"

/* eslint-disable */
import { useEffect, useState, useMemo, useRef, useCallback } from "react"
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  NumberInput,
  NumberInputField,
  useToast,
  useColorModeValue,
  Divider,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  IconButton,
  Spinner,
  Select as ChakraSelect,
  HStack,
  Badge,
  Container,
  VStack,
  SimpleGrid,
  Collapse,
  useBreakpointValue,
  Input,
  Select,
  Portal,
  FormControl,
  FormLabel,
  Textarea,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Checkbox,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Stack,
  AspectRatio,
  Image,
  Tooltip,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  CircularProgressLabel,
  CircularProgress,
  Circle,
  GridItem,
  usePrefersReducedMotion,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Wrap,
  WrapItem,
  Radio,
  RadioGroup,
  List,
  ListItem,
  Progress,
  Tag,
  TagLabel,
  Stat,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react"
import { ChevronLeftIcon, ChevronRightIcon, ArrowBackIcon, CheckIcon , EditIcon, RepeatIcon, ChevronDownIcon, ChevronUpIcon, SearchIcon, CloseIcon, DownloadIcon } from "@chakra-ui/icons"
import { AnimatePresence, motion } from "framer-motion"
import {
  listTraindata,
  updateTraindata,
  createTrainingRequest,
  listTrainingRequests,
  getTrainingRequestDetail,
  listTrainingRequestNewData,
  approveTrainingRequest,
  rejectTrainingRequest,
  listMyTrainingRequests,
  listRuns,
  getRunDetail,
  createTraindata,
  importTraindata,
  listPredictions,
  deleteTraindata,
  downloadTraindataTemplate,
} from "services/training"
import { FiFilePlus, FiUpload } from "react-icons/fi"
import { getPredictMeta } from "services/predict"
import { useAuth } from "contexts/AuthContext"; // 경로는 프로젝트 구조에 맞게
import { useDropzone } from "react-dropzone"

// 유형별 썸네일 프리셋 (이모지 + 배경)
const TYPE_THUMBS = {
  "아파트":         { emoji: "🏢", bg: "linear(to-br, blue.50, blue.200)" },
  "오피스텔":       { emoji: "🏨", bg: "linear(to-br, purple.50, purple.200)" },
  "주상복합":       { emoji: "🏙️", bg: "linear(to-br, indigo.50, indigo.200)" },
  "도시형생활주택": { emoji: "🏘️", bg: "linear(to-br, teal.50, teal.200)" },
  "문화시설":       { emoji: "🎭", bg: "linear(to-br, pink.50, pink.200)" },
  "물류센터":       { emoji: "📦", bg: "linear(to-br, orange.50, orange.200)" },
  "생활형숙박시설": { emoji: "🛎️", bg: "linear(to-br, yellow.50, yellow.200)" },
  "업무시설":       { emoji: "🏢", bg: "linear(to-br, cyan.50, cyan.200)" },
  "지식산업센터":   { emoji: "🧠", bg: "linear(to-br, cyan.50, blue.200)" },
  "테라스":         { emoji: "🌿", bg: "linear(to-br, green.50, green.200)" },
  "기타":           { emoji: "🏗️", bg: "linear(to-br, gray.50, gray.200)" },
};

const TYPE_BADGE_COLOR = {
  아파트: "teal",
  오피스텔: "purple",
  주상복합: "pink",
  도시형생활주택: "cyan",
  문화시설: "orange",
  물류센터: "orange",
  생활형숙박시설: "yellow",
  업무시설: "blue",
  지식산업센터: "purple",
  테라스: "green",
  기타: "gray",
};

const getTypeBadgeColor = (type) => {
  const key = type?.trim();
  return TYPE_BADGE_COLOR[key] || "blue";
};

// (선택) 실제 이미지 파일을 쓰고 싶으면 경로를 여기에 채워서 사용
const TYPE_IMAGES = {
  // "아파트": "/thumbs/apartment.jpg",
  // "오피스텔": "/thumbs/officetel.jpg",
  // ...
};
const formatDateTimeLabel = (value) => {
  if (!value) return "-"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString("ko-KR")
}

const getFriendlyErrorMessage = (error) => {
  if (!error) return "알 수 없는 오류"
  const raw = typeof error === "string" ? error : error?.message || ""
  const text = raw || String(error)
  const cleaned = text.replace(/^error:\s*/i, "").trim()
  return cleaned || "알 수 없는 오류"
}

// 고정 비율만 사용 (원하면 16/9 로 바꿔도 됨)
const THUMB_RATIO = 4 / 3;
const TITLE_LINES = 2;           // 제목 2줄 클램프
const TITLE_LH = 1.3;            // 제목 줄간격
const TITLE_H = `${TITLE_LINES * TITLE_LH}em`;

const DEFAULT_STRUCTURE_OPTIONS = {
  parking: ["O", "X"],
  ground: ["O", "X"],
  standard: ["O", "X"],
};
const DEFAULT_STRUCTURE_VISIBILITY = {
  parking: true,
  ground: true,
  standard: true,
};
const DEFAULT_HOUSEHOLD_WINDOW_OPTIONS = ["이중창", "입면분할이중창", "유리난간이중창"];
const STRUCTURE_FIELD_META = {
  structure_parking: { label: "주차장", optionKey: "parking" },
  structure_ground: { label: "지상층", optionKey: "ground" },
  structure_standard: { label: "기준층", optionKey: "standard" },
};
const STRUCTURE_FIELD_KEYS = Object.keys(STRUCTURE_FIELD_META);
const SLOPE_OPTION_LABELS = {
  FLAT: "택지 부지 (FLAT)",
  SLOPE: "경사지 부지 (SLOPE)",
};

const STATUS_LABEL_KO = {
  PENDING: "승인 대기",
  APPROVED: "승인됨",
  REJECTED: "반려됨",
  RUNNING: "진행 중",
  SUCCEEDED: "성공",
  FAILED: "실패",
}
const STATUS_COLOR = {
  PENDING: "orange",
  APPROVED: "green",
  RUNNING: "blue",
  SUCCEEDED: "purple",
  REJECTED: "red",
  FAILED: "red",
}

const formatCurrency = (value) =>
  value == null ? "-" : `${Number(value).toLocaleString()}원`

const formatNumber = (value) =>
  value == null ? "-" : Number(value).toLocaleString()

const UPLOAD_MAX_BYTES = 20 * 1024 * 1024
const HEADER_CHIP_LIMIT = 16

const formatFileSize = (bytes = 0) => {
  if (!bytes) return "-"
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)}MB`
  return `${(bytes / 1024).toFixed(2)}KB`
}

const parseCsvPreview = (text) => {
  if (!text) return []
  const rows = []
  let currentRow = []
  let currentValue = ""
  let inQuotes = false

  const pushRow = () => {
    currentRow.push(currentValue)
    rows.push(currentRow)
    currentRow = []
    currentValue = ""
  }

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i]
    const next = text[i + 1]
    if (char === '"') {
      if (inQuotes && next === '"') {
        currentValue += '"'
        i += 1
      } else {
        inQuotes = !inQuotes
      }
    } else if (!inQuotes && char === ",") {
      currentRow.push(currentValue)
      currentValue = ""
    } else if (!inQuotes && (char === "\n" || char === "\r")) {
      if (char === "\r" && next === "\n") {
        i += 1
      }
      pushRow()
    } else {
      currentValue += char
    }
  }

  if ((currentValue || currentRow.length)) {
    pushRow()
  }
  return rows
}

const normalizeRequestNewDataItems = (items = []) =>
  (Array.isArray(items) ? items : []).map((item) => ({
    ...item,
    project_name: item.project_name ?? item.projectName ?? null,
    region: item.region ?? null,
    district: item.district ?? null,
    received_date: item.received_date ?? item.receivedDate ?? null,
    total_cost: item.total_cost ?? item.totalCost ?? null,
    building_cost: item.building_cost ?? null,
    civil_cost: item.civil_cost ?? null,
    electrical_cost: item.electrical_cost ?? null,
    facility_cost: item.facility_cost ?? null,
    opex_cost: item.opex_cost ?? null,
    etc_cost: item.etc_cost ?? null,
    common_cost: item.common_cost ?? null,
    total_area_py: item.total_area_py ?? null,
    supply_area: item.supply_area ?? null,
    avg_area_py: item.avg_area_py ?? null,
    duration_months: item.duration_months ?? null,
    floors_above: item.floors_above ?? null,
    floors_below: item.floors_below ?? null,
    rock_ratio: item.rock_ratio ?? null,
    heating: item.heating ?? null,
    external_work: item.external_work ?? null,
    excluded_items: item.excluded_items ?? null,
    households: item.households ?? null,
    construction_method: item.construction_method ?? null,
    slope_type: item.slope_type ?? null,
    building_count: item.building_count ?? null,
    site_area: item.site_area ?? null,
    is_coastal: item.is_coastal ?? null,
    round_label: item.round_label ?? null,
    manager: item.manager ?? null,
    note: item.note ?? null,
  }))

const GENERAL_INFO_FIELDS = [
  { key: "type", label: "유형" },
  { key: "round_label", label: "회차" },
  { key: "manager", label: "관리자" },
  { key: "region", label: "지역" },
  { key: "district", label: "행정구" },
  { key: "received_date", label: "접수일" },
]

const DIMENSION_FIELDS = [
  { key: "supply_area", label: "공급면적(㎡)" },
  { key: "total_area_py", label: "총면적(평)" },
  { key: "avg_area_py", label: "평균층당(평)" },
  { key: "building_count", label: "동수" },
  { key: "floors_above", label: "지상 층수" },
  { key: "floors_below", label: "지하 층수" },
  { key: "slope_type", label: "경사" },
  { key: "is_coastal", label: "해안 여부" },
  { key: "households", label: "세대수" },
]

const COST_FIELDS = [
  { key: "total_cost", label: "총공사비" },
  { key: "building_cost", label: "건축비" },
  { key: "civil_cost", label: "토목비" },
  { key: "electrical_cost", label: "전기비" },
  { key: "facility_cost", label: "설비비" },
  { key: "opex_cost", label: "경상비" },
  { key: "etc_cost", label: "기타비" },
  { key: "common_cost", label: "공통비" },
]

const META_FIELDS = [
  { key: "structure_parking", label: "구조(주차)" },
  { key: "structure_ground", label: "구조(지상)" },
  { key: "structure_standard", label: "구조(기준)" },
  { key: "rock_ratio", label: "암반비율" },
  { key: "heating", label: "난방" },
  { key: "external_work", label: "외부공사" },
  { key: "excluded_items", label: "제외 항목" },
  { key: "construction_method", label: "공법" },
  { key: "household_window", label: "세대 창호" },
  { key: "duration_months", label: "공사기간(월)" },
  { key: "note", label: "비고" },
]

const formatFieldValue = (item, field) => {
  const value = item[field.key]
  if (field.key === "is_coastal") {
    return value === true ? "예" : value === false ? "아니오" : "-"
  }
  if (COST_FIELDS.some((f) => f.key === field.key)) {
    return formatCurrency(value)
  }
  if (["supply_area", "site_area"].includes(field.key)) {
    return value == null ? "-" : `${formatNumber(value)}㎡`
  }
  if (["total_area_py", "avg_area_py"].includes(field.key)) {
    return value == null ? "-" : `${formatNumber(value)}평`
  }
  if (field.key === "duration_months") {
    return value == null ? "-" : `${formatNumber(value)}개월`
  }
  return value || value === 0 ? String(value) : "-"
}

const renderFieldsGrid = (fields, item) => (
  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2} mt={2}>
    {fields.map((field) => (
      <Box key={`${item.id}-${field.key}`}>
        <Text fontSize="xs" color="gray.500">
          {field.label}
        </Text>
        <Text fontSize="sm" fontWeight="semibold">
          {formatFieldValue(item, field)}
        </Text>
      </Box>
    ))}
  </SimpleGrid>
)

const renderTypeThumb = (typeLabel, projectName) => {
  const key = TYPE_THUMBS[typeLabel?.trim()] ? typeLabel.trim() : "기타";
  const preset = TYPE_THUMBS[key];
  const url = TYPE_IMAGES[key];

  if (url) {
    return (
      <AspectRatio ratio={THUMB_RATIO}>
        <Image src={url} alt={`${key} - ${projectName || "thumbnail"}`} objectFit="cover" />
      </AspectRatio>
    );
  }
  return (
    <AspectRatio ratio={THUMB_RATIO}>
      <Flex align="center" justify="center" bgGradient={preset.bg} position="relative">
        <Text fontSize="3xl">{preset.emoji}</Text>
        <Badge position="absolute" bottom={2} right={2} colorScheme="blackAlpha" rounded="full" variant="subtle">
          {key}
        </Badge>
      </Flex>
    </AspectRatio>
  );
};

const NewDataDetailCard = ({ item, borderColor, bgColor, collapseOnMobile = false }) => {
  const sectionInitiallyOpen = !collapseOnMobile
  const dimensionDisclosure = useDisclosure({ defaultIsOpen: sectionInitiallyOpen })
  const costDisclosure = useDisclosure({ defaultIsOpen: sectionInitiallyOpen })
  const metaDisclosure = useDisclosure({ defaultIsOpen: sectionInitiallyOpen })

  if (!item) return null

  const SectionBox = ({ title, action, children }) => (
    <Box border="1px solid" borderColor={borderColor} rounded="2xl" bg={bgColor} p={5} shadow="md">
      <Flex justify="space-between" align="center" mb={3}>
        <Text fontSize="sm" fontWeight="600">
          {title}
        </Text>
        {action}
      </Flex>
      {children}
    </Box>
  )

  return (
    <VStack spacing={4} align="stretch">
      <Box border="1px solid" borderColor={borderColor} rounded="2xl" bg={bgColor} p={5} shadow="md">
        <Flex justify="space-between" align="center" mb={3}>
          <VStack align="start" spacing={0}>
            <Heading size="md">{item.project_name || "프로젝트 상세"}</Heading>
            <Text fontSize="xs" color="gray.500">
              ID {item.id}
            </Text>
          </VStack>
          <Badge colorScheme="blue" variant="subtle" rounded="full">
            {item.type || "-"}
          </Badge>
        </Flex>
        <Wrap spacing={2} mb={3}>
          {(item.region || item.district) && (
            <Badge variant="subtle" colorScheme="gray" rounded="full" px={2}>
              {item.region || item.district}
            </Badge>
          )}
          {item.received_date && (
            <Badge variant="subtle" colorScheme="purple" rounded="full" px={2}>
              접수일 {item.received_date}
            </Badge>
          )}
        </Wrap>
        <Text fontSize="xs" color="gray.500">
          관리자: {item.manager || "미정"} · 총공사비: {item.total_cost ? formatCurrency(item.total_cost) : "-"}
        </Text>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <SectionBox title="기본 정보">
          {renderFieldsGrid(GENERAL_INFO_FIELDS, item)}
        </SectionBox>
        <SectionBox
          title="면적 / 구조 정보"
          action={
            <Button
              size="xs"
              variant="ghost"
              rightIcon={dimensionDisclosure.isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={dimensionDisclosure.onToggle}
            >
              {dimensionDisclosure.isOpen ? "접기" : "펼치기"}
            </Button>
          }
        >
          <Collapse in={dimensionDisclosure.isOpen}>
            {renderFieldsGrid(DIMENSION_FIELDS, item)}
          </Collapse>
        </SectionBox>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <SectionBox
          title="비용 내역"
          action={
            <Button
              size="xs"
              variant="ghost"
              rightIcon={costDisclosure.isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={costDisclosure.onToggle}
            >
              {costDisclosure.isOpen ? "접기" : "펼치기"}
            </Button>
          }
        >
          <Collapse in={costDisclosure.isOpen}>{renderFieldsGrid(COST_FIELDS, item)}</Collapse>
        </SectionBox>
        <SectionBox
          title="기타 메타"
          action={
            <Button
              size="xs"
              variant="ghost"
              rightIcon={metaDisclosure.isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={metaDisclosure.onToggle}
            >
              {metaDisclosure.isOpen ? "접기" : "펼치기"}
            </Button>
          }
        >
          <Collapse in={metaDisclosure.isOpen}>{renderFieldsGrid(META_FIELDS, item)}</Collapse>
        </SectionBox>
      </SimpleGrid>
    </VStack>
  )
}

const SectionBackButton = ({ onClick, ...props }) => (
  <Button
    leftIcon={<ArrowBackIcon />}
    size="sm"
    variant="outline"
    rounded="full"
    px={4}
    py={1}
    mt={2}
    mb={4}
    fontWeight="500"
    colorScheme="blue"
    borderColor="blue.300"
    bg="white"
    fontSize="sm"
    _hover={{ bg: "blue.50" }}
    onClick={onClick}
    {...props}
  >
    이전
  </Button>
)

/** 기존: 비율값을 0~100으로 보정 */
function toPercent(v) {
  const n = Number(v ?? 0);
  const p = n <= 1 ? n * 100 : n;
  return Math.max(0, Math.min(100, p));
}

/** 기존: 링 카드 */

function RingStat({ label, value, size }) {
  const track = useColorModeValue("gray.100", "gray.700");
  const pct = toPercent(value); // 0~100 변환
  const color = getRingColor(pct);

  return (
    <VStack spacing={2} align="center" minW={0}>
      <CircularProgress
        value={pct}
        size={size ?? { base: "70px", md: "90px" }}
        thickness="10px"
        color={color}
        trackColor={track}
      >
        <CircularProgressLabel>
          <Text fontSize={{ base: "xs", md: "sm" }} fontWeight="bold">
            {Math.round(pct)}%
          </Text>
        </CircularProgressLabel>
      </CircularProgress>
      <Text fontSize={{ base: "xs", md: "sm" }} textAlign="center" noOfLines={2}>
        {label}
      </Text>
    </VStack>
  );
}

function getAccuracyColor(pct) {
  if (pct >= 90) return "green.500";   // 90~100
  if (pct >= 80) return "yellow.400";  // 80~89
  if (pct >= 70) return "orange.500";  // 70~79
  return "red.500";                    // 0~69
}

function getRingColor(pct) {
  if (pct >= 90) return "green.500";    // 90~100: 초록
  if (pct >= 80) return "yellow.400";   // 80~89: 노랑
  if (pct >= 70) return "orange.500";   // 70~79: 주황
  return "red.500";                     // ~69: 빨강
}

function CountAndTypesCard({ total, counts = [] }) {
  const items = counts; // 전체 다 보여줌
  const bg = useColorModeValue("white", "navy.700");
  const border = useColorModeValue("gray.100", "whiteAlpha.200");
  const subtle = useColorModeValue("gray.600", "gray.300");
  const totalColor = useColorModeValue("gray.900", "white");

  return (
    <Box
      position="relative"
      borderWidth="1px"
      borderColor={border}
      bg={bg}
      rounded="2xl"
      p={{ base: 4, md: 5 }}
      boxShadow="sm"
    >
      {/* 총 건수 → 우측 상단 */}
      <Box position="relative" top={{ base: 3, md: 4 }} right={{ base: 3, md: 4 }} bottom={{ base: 4, md: 6 }} textAlign="right">
        <Text fontSize={{ base: "10px", md: "sm" }} color={subtle}>총 건수</Text>
        <HStack spacing={1} justify="flex-end">
          <Text fontWeight="extrabold" fontSize={{ base: "xl", md: "2xl" }} color={totalColor}>
            {Number(total ?? 0).toLocaleString()}
          </Text>
          <Text fontSize={{ base: "10px", md: "sm" }} color={subtle}>건</Text>
        </HStack>
      </Box>

      {/* 유형별 건수 */}
      <Box pt={{ base: 8, md: 10 }}>
        {/* 모바일=2열, 데스크탑=3열 */}
        <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
          {items.map((t) => {
            const pct = total ? Math.round((t.count / total) * 100) : 0;
            return (
              <Box
                key={t.type}
                borderWidth="1px"
                borderColor={border}
                rounded="lg"
                p={3}
                bg={useColorModeValue("gray.50", "whiteAlpha.100")}
              >
                <HStack justify="space-between" mb={1} spacing={2}>
                  <Text fontSize="xs" color={subtle} noOfLines={1} title={t.type}>{t.type}</Text>
                  <Badge variant="subtle" colorScheme="blue" fontSize="9px">{pct}%</Badge>
                </HStack>
                <Text fontWeight="semibold" fontSize="sm">
                  {t.count.toLocaleString()} 건
                </Text>
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>
    </Box>
  );
}

/** 기존: 총 건수 카드 (아이콘 제거 버전) */
function CountCard({ label = "총 건수", value = 0 }) {
  const bg = useColorModeValue("white", "navy.700");
  const border = useColorModeValue("gray.100", "whiteAlpha.200");
  const labelColor = useColorModeValue("gray.600", "gray.300");
  const valueColor = useColorModeValue("gray.900", "white");

  return (
    <Box
      borderWidth="1px" borderColor={border} bg={bg} rounded="2xl"
      p={{ base: 4, md: 5 }} boxShadow="sm"
      _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
      transition="all 0.15s ease"
    >
      <VStack align="flex-start" spacing={1}>
        <Text fontSize={{ base: "xs", md: "sm" }} color={labelColor}>{label}</Text>
        <HStack spacing={2}>
          <Text fontWeight="extrabold" fontSize={{ base: "2xl", md: "3xl" }} lineHeight="1" color={valueColor}>
            {Number(value ?? 0).toLocaleString()}
          </Text>
          <Text fontSize={{ base: "xs", md: "sm" }} color={labelColor}>건</Text>
        </HStack>
      </VStack>
    </Box>
  );
}

/** 신규: 유형별 건수 카드 */
function TypeCountCard({ type, count, total }) {
  const bg = useColorModeValue("white", "navy.700");
  const border = useColorModeValue("gray.100", "whiteAlpha.200");
  const subtle = useColorModeValue("gray.600", "gray.300");
  const pct = total ? Math.round((count / total) * 100) : 0;

  return (
    <Box
      borderWidth="1px" borderColor={border} bg={bg} rounded="xl"
      p={{ base: 3, md: 4 }} boxShadow="sm"
      _hover={{ boxShadow: "md", transform: "translateY(-1px)" }}
      transition="all 0.15s ease"
    >
      <HStack justify="space-between" mb={1}>
        <Text fontSize={{ base: "xs", md: "sm" }} color={subtle}>{type}</Text>
        <Badge variant="subtle" colorScheme="blue" fontSize={{ base: "9px", md: "10px" }}>
          {pct}%
        </Badge>
      </HStack>
      <HStack spacing={1}>
        <Text fontWeight="bold" fontSize={{ base: "lg", md: "xl" }}>
          {Number(count ?? 0).toLocaleString()}
        </Text>
        <Text fontSize={{ base: "xs", md: "sm" }} color={subtle}>건</Text>
      </HStack>
    </Box>
  );
}

// 유틸: 제목 길이에 따른 폰트 자동 축소
const getTitleFontSize = (name = "") => {
  if (!name) return "md";
  if (name.length > 60) return "xs";
  if (name.length > 36) return "sm";
  return "md";
};

/** 신규: 유형별 카드 섹션 (정렬/반응형 포함) */
function TypeCountsSection({ counts, total, title = "유형별 건수" }) {
  // normalize => [{ type, count }]
  let items = [];
  if (Array.isArray(counts)) {
    items = counts.map((x) => ({ type: x?.type ?? "-", count: Number(x?.count ?? 0) }));
  } else if (counts && typeof counts === "object") {
    items = Object.entries(counts).map(([k, v]) => ({ type: k ?? "-", count: Number(v ?? 0) }));
  }

  items.sort((a, b) => (b.count ?? 0) - (a.count ?? 0)); // desc
  const totalAuto = items.reduce((s, x) => s + (x.count || 0), 0);
  const totalFinal = Number.isFinite(total) ? Number(total) : totalAuto;

  if (!items.length) return null;

  const bg = useColorModeValue("white", "navy.700");
  const border = useColorModeValue("gray.100", "whiteAlpha.200");
  const subtle = useColorModeValue("gray.600", "gray.300");
  const titleColor = useColorModeValue("gray.800", "white");

  return (
    <VStack align="stretch" spacing={3} mt={2}>
      <Text fontWeight="semibold" fontSize={{ base: "sm", md: "md" }} color={titleColor}>
        {title}
      </Text>
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={3}>
        {items.map(({ type, count }) => {
          const pct = totalFinal ? Math.round((count / totalFinal) * 100) : 0;
          return (
            <Box
              key={type}
              borderWidth="1px"
              borderColor={border}
              bg={bg}
              rounded="xl"
              p={{ base: 3, md: 4 }}
              boxShadow="sm"
              _hover={{ boxShadow: "md", transform: "translateY(-1px)" }}
              transition="all 0.15s ease"
            >
              <HStack justify="space-between" mb={1}>
                <Text fontSize={{ base: "xs", md: "sm" }} color={subtle}>
                  {type}
                </Text>
                <Badge variant="subtle" colorScheme="blue" fontSize={{ base: "9px", md: "10px" }}>
                  {pct}%
                </Badge>
              </HStack>
              <HStack spacing={1}>
                <Text fontWeight="bold" fontSize={{ base: "lg", md: "xl" }}>
                  {count.toLocaleString()}
                </Text>
                <Text fontSize={{ base: "xs", md: "sm" }} color={subtle}>
                  건
                </Text>
              </HStack>
              {/* 미니 진행바 (선택) */}
              <Box mt={2} h="1.5" rounded="full" bg="gray.100" overflow="hidden">
                <Box h="100%" w={`${pct}%`} bg="blue.400" />
              </Box>
            </Box>
          );
        })}
      </SimpleGrid>
    </VStack>
  );
}


/** 숫자 포맷 표시용 */
function Num({ v }) {
  const n = Number(v)
  return <>{Number.isFinite(n) ? n.toLocaleString() : "-"}</>
}

function getCostDetails(row) {
  const parsedTotalCost = Number(row.total_cost ?? 0)
  const parsedArea = Number(row.total_area_py ?? 0)
  const avgCostPerPyeong =
    parsedArea > 0 ? Math.round((parsedTotalCost * 1_000_000) / parsedArea) : undefined

  const summary = [
    { label: "전체공사비", value: row.total_cost, color: "black" },
    { label: "평당 공사비", value: avgCostPerPyeong, color: "black" },
  ]

  const components = [
    { label: "건축비", value: row.building_cost, color: "black" },
    { label: "토목", value: row.civil_cost, color: "black" },
    { label: "전기", value: row.electrical_cost, color: "black" },
    { label: "설비", value: row.facility_cost, color: "black" },
    { label: "경상비", value: row.opex_cost, color: "black" },
    { label: "공통", value: row.common_cost, color: "black" },
    { label: "기타", value: row.etc_cost, color: "black" },
  ]

  const componentTotal = components.reduce((sum, item) => {
    const n = Number(item.value ?? 0)
    return sum + (Number.isFinite(n) ? n : 0)
  }, 0)

  return { summary, components, componentTotal }
}

function CostDetailsPanel({ costDetails, receivedDate }) {
  const borderColor = useColorModeValue("gray.200", "gray.600")
  const sectionBg = useColorModeValue("gray.50", "gray.700")

  return (
    <VStack spacing={4} align="stretch">
      <Text fontSize="sm" fontWeight="bold" color="gray.600">
        비용
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
        {costDetails.summary.map((item) => (
          <Box
            key={item.label}
            p={3}
            rounded="md"
            border="1px solid"
            borderColor={borderColor}
            bg={sectionBg}
          >
            <Text fontSize="xs" color="gray.500">
              {item.label}
            </Text>
            <Text fontWeight="semibold" fontSize="lg">
              <Num v={item.value} />
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      <Divider />

      <Box>
        <Text fontSize="sm" fontWeight="bold" color="gray.600" mb={2}>
          참고 비용
        </Text>
        <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
          {costDetails.components.map((item) => (
            <Box
              key={item.label}
              p={3}
              rounded="md"
              border="1px solid"
              borderColor={borderColor}
              bg={sectionBg}
            >
              <Text fontSize="xs" color="gray.500">
                {item.label}
              </Text>
              <Text fontWeight="semibold">
                <Num v={item.value} />
              </Text>
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      <Divider />

      <Box textAlign="center">
        <Text fontSize="xs" color="gray.500">
          참고 비용 합계
        </Text>
          <Text fontWeight="bold" fontSize="lg">
            <Num v={costDetails.componentTotal} />
          </Text>
      </Box>
    </VStack>
  )
}

/** 퍼센트 포맷 */
function Pct({ v }) {
  if (v === null || v === undefined) return <>-</>
  const n = Number(v)
  return <>{Number.isFinite(n) ? `${n.toFixed(2)}%` : "-"}</>
}

/** 모바일용 예측 카드 */
function PredictionCardMobile({ p, onApply, onOpenEdit, isAdmin }) {
  const compPairs = [
    ["토목", p.civil_cost],
    ["전기", p.electrical_cost],
    ["설비", p.facility_cost],
    ["경상비", p.opex_cost],
    ["기타", p.etc_cost],
    ["공통", p.common_cost],
  ].filter(([, v]) => v !== null && v !== undefined)

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      rounded="lg"
      p={4}
      shadow="sm"
      _hover={{ shadow: "md" }}
      transition="all 0.2s"
    >
      <HStack justify="space-between" align="start" mb={2}>
        <HStack spacing={3}>
          <Badge colorScheme="blue" variant="subtle" rounded="full">
            {p.type || "-"}
          </Badge>
          <Text fontWeight="bold" color="blue.600">#{p.id}</Text>
        </HStack>
        {isAdmin && (
          <HStack spacing={2}>
            <Button size="xs" variant="outline" colorScheme="blue" onClick={() => onOpenEdit?.(p, "pred")}>수정</Button>
            <Button size="xs" colorScheme="blue" onClick={() => onApply(p)}>적용</Button>
          </HStack>
        )}
      </HStack>

      <VStack align="stretch" spacing={3}>
        <Box>
         <Text fontSize="xs" color="gray.500">프로젝트</Text>
         <Button
           variant="link"
           colorScheme="blue"
           onClick={() => onOpenEdit?.(p, "pred")}
           p={0}
           h="auto"
           justifyContent="flex-start"
           display="block"
           textAlign="left"
           minW={0}
           maxW="100%"
           whiteSpace="normal"
           wordBreak="break-word"
            sx={{
              overflowWrap: "anywhere",
              textDecoration: "underline",        // 항상 밑줄
              textUnderlineOffset: "2px",         // 조금 여백 주면 깔끔
            }}
            _hover={{
              color: "blue.700",
              textDecoration: "underline",        // hover 시 강조
            }}
         >
           <Text
             as="span"
             fontSize={{ base: "sm", md: "md" }}
             noOfLines={{ base: 3, md: 2 }}  // 모바일 3줄까지
           >
             {p.project_name}
           </Text>
         </Button>
        </Box>
        <SimpleGrid columns={2} spacing={3}>
          <Box>
            <Text fontSize="xs" color="gray.500">연면적(평)</Text>
            <Text><Num v={p.area_pyeong} /></Text>
          </Box>
          <Box>
            <Text fontSize="xs" color="gray.500">세대</Text>
            <Text><Num v={p.households} /></Text>
          </Box>
          <Box>
            <Text fontSize="xs" color="gray.500">층수(지상/지하)</Text>
            <Text>{p.floor_above ?? "-"} / {p.floor_below ?? "-"}</Text>
          </Box>
          <Box>
            <Text fontSize="xs" color="gray.500">지역</Text>
            <Text noOfLines={1}>
              {[p.region, p.district].filter(Boolean).join(" ") || "-"}
            </Text>
          </Box>
        </SimpleGrid>
      </VStack>
    </Box>
  )
}

/**  화면 전체 로딩 오버레이 */
function FullscreenLoader({ message = "작업을 진행 중입니다..." }) {
  return (
    <Portal>
      <Box
        position="fixed"
        inset="0"
        zIndex={9999}
        bg="rgba(0,0,0,0.5)"
        backdropFilter="blur(4px)"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <VStack
          spacing={4}
          bg="white"
          rounded="2xl"
          p={8}
          shadow="2xl"
          border="1px solid"
          borderColor="gray.200"
          maxW="90vw"
        >
          <Spinner thickness="4px" size="xl" />
          <Heading size="md" color="gray.700">{message}</Heading>
          <Text color="gray.500" fontSize="sm">
            브라우저를 닫지 말고 잠시만 기다려 주세요.
          </Text>
        </VStack>
      </Box>
    </Portal>
  )
}

const MotionBox = motion(Box)

function FlipCard({ isFlipped, children }) {
  return (
    <Box position="relative" w="100%" perspective="1200px">
      <MotionBox
        position="relative"
        transformStyle="preserve-3d"
        animate={{ rotateY: isFlipped ? 180 : 0 }}
        transition={{ duration: 0.55, ease: [0.4, 0.0, 0.2, 1] }}
      >
        {children}
      </MotionBox>
    </Box>
  );
}
FlipCard.Front = function Front({ children }) {
  return <Box backfaceVisibility="hidden">{children}</Box>;
};
FlipCard.Back = function Back({ children }) {
  return (
    <Box
      position="absolute"
      inset={0}
      transform="rotateY(180deg)"
      backfaceVisibility="hidden"
    >
      {children}
    </Box>
  );
};

export function CenterBodyOverlayMessage({
  message = "쓸어 넘겨 보세요",
  sub = "좌우로 스와이프하면 화면이 전환됩니다.",
  duration = 2200,
}) {
const isMobiles = useBreakpointValue({ base: true, md: false });
const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true); // 모달 열릴 때마다 항상 노출
    const t = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(t);
  }, [duration]);

  return (
    <AnimatePresence>
      {show && (
        <MotionBox
          position="absolute"
          inset={0}
          zIndex={10}
          bg="blackAlpha.200"
          backdropFilter="blur(6px)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <MotionBox
            color="black"
            textAlign="center"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <Text fontSize="lg" fontWeight="bold">
              {message}
            </Text>
            {sub && (
              <Text fontSize="sm" opacity={0.8} mt={2}>
                {sub}
              </Text>
            )}
          </MotionBox>
        </MotionBox>
      )}
    </AnimatePresence>
  );
}

export default function Training() {
  
// 상단에 상태 추가
const [showAll, setShowAll] = useState(false);

// 한 번에 유형 뱃지 보여줄 기본 개수
const VISIBLE_COUNT = 3;

// 실행 상세 모달 패널 라벨
const RUN_TAB_LABELS = ["총 평균 정확도", "유형별 평균 정확도", "개별 데이터 정확도"];
const RUN_LAST_INDEX = RUN_TAB_LABELS.length - 1;

const { user = {} } = useAuth?.() || {};
const isAdmin = ["admin", "super_admin"].includes(user?.role);
const isSuperAdmin = user?.role === "super_admin";

useEffect(() => {
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, left: 0 });
  }
}, []);

const isAdminOrSuper = isAdmin;

// 현재 패널 인덱스
const [runTab, setRunTab] = useState(0);

// 애니메이션 방향: 'left' | 'right'
const [slideDir, setSlideDir] = useState('left'); // 'left' | 'right'

// 스와이프(모바일)
const swipeStartRef = useRef(null); // { x, y, t } or null
const swipeLockRef  = useRef(null); // 'x' | 'y' | null

const canEdit = !!isAdmin; // 관리자만 true
const toast = useToast()

  const [selectedFile, setSelectedFile] = useState(null)
  const [previewHeaders, setPreviewHeaders] = useState([])
  const [previewRows, setPreviewRows] = useState([])
  const [parsingError, setParsingError] = useState("")
  const [uploading, setUploading] = useState(false)
  const [uploadResult, setUploadResult] = useState(null)
  const [validationResult, setValidationResult] = useState(null)
  const [isValidating, setIsValidating] = useState(false)
  const [validationPassed, setValidationPassed] = useState(false)
  const [templateDownloading, setTemplateDownloading] = useState(false)

  const [addMode, setAddMode] = useState(null)

  const resetUploadState = () => {
    setSelectedFile(null)
    setPreviewHeaders([])
    setPreviewRows([])
    setParsingError("")
    setUploadResult(null)
    setValidationResult(null)
    setValidationPassed(false)
    setUploading(false)
  }

  const handleDownloadTemplate = async () => {
    setTemplateDownloading(true)
    try {
      const blob = await downloadTraindataTemplate()
      const url = URL.createObjectURL(blob)
      const anchor = document.createElement("a")
      anchor.href = url
      anchor.download = "traindata-template.csv"
      document.body.appendChild(anchor)
      anchor.click()
      anchor.remove()
      URL.revokeObjectURL(url)
    } catch (error) {
      toast({
        status: "error",
        title: "양식 다운로드 실패",
        description: String(error?.message || error),
      })
    } finally {
      setTemplateDownloading(false)
    }
  }

  const handleCreateCloseWithReset = () => {
    resetUploadState()
    onCreateClose()
  }

  const uploadInfoDisclosure = useDisclosure()
  const uploadInfoCancelRef = useRef(null)
  const resultToDisplay = uploadResult ?? validationResult
  const resultLabel = uploadResult
    ? "실제 업로드 결과"
    : validationResult
      ? "검증 결과"
      : null

  const handleFileSelect = useCallback(async (file) => {
    setUploadResult(null)
    setValidationResult(null)
    setValidationPassed(false)
    setParsingError("")
    setPreviewHeaders([])
    setPreviewRows([])
    if (!file) {
      setSelectedFile(null)
      return
    }
    const normalizedFilename = file.name?.toLowerCase() || ""
    if (!normalizedFilename.endsWith(".csv")) {
      setParsingError("CSV(.csv) 파일만 업로드 가능합니다.")
      setSelectedFile(null)
      return
    }
    if (file.size > UPLOAD_MAX_BYTES) {
      setParsingError("20MB 이하의 CSV만 업로드 가능합니다.")
      setSelectedFile(null)
      return
    }
    setSelectedFile(file)
    try {
    const fileText = await file.text()
    const parsedRows = parseCsvPreview(fileText)
      if (!parsedRows.length) {
        setParsingError("CSV에 데이터가 없습니다.")
        return
      }
      const headers = parsedRows[0] || []
      if (!headers.length) {
        setParsingError("CSV 헤더 정보를 확인할 수 없습니다.")
        return
      }
      const normalizedHeaders = headers.map(
        (value, index) => (value?.toString().trim() || `컬럼 ${index + 1}`)
      )
      const previewData = parsedRows.slice(1, 11).map((row) => {
        const obj = {}
        normalizedHeaders.forEach((header, idx) => {
          obj[header] = row?.[idx] ?? ""
        })
        return obj
      })
      setPreviewHeaders(normalizedHeaders)
      setPreviewRows(previewData)
    } catch (error) {
      setParsingError("CSV를 읽는 중 오류가 발생했습니다.")
    }
  }, [])

  const onDrop = useCallback(
    async (acceptedFiles, fileRejections) => {
      if (fileRejections.length) {
        const message =
          fileRejections[0]?.errors?.[0]?.message || "유효하지 않은 CSV 파일입니다."
        toast({
          status: "error",
          title: "파일 업로드 실패",
          description: message,
        })
        return
      }
      if (acceptedFiles.length) {
        await handleFileSelect(acceptedFiles[0])
      }
    },
    [handleFileSelect, toast]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "text/csv": [".csv"] },
    multiple: false,
    maxSize: UPLOAD_MAX_BYTES,
  })

    const handleValidate = useCallback(async () => {
    if (!selectedFile) return
    if (parsingError) {
      toast({
        status: "error",
        title: "파일 검증 실패",
        description: parsingError,
      })
      return
    }
    setIsValidating(true)
    try {
      const formData = new FormData()
      formData.append("file", selectedFile)
      formData.append("dry_run", "true")
      const result = await importTraindata(formData)
      setValidationResult(result)
      setValidationPassed((result.failedRows ?? 0) === 0 && (result.errors?.length ?? 0) === 0)
      setUploadResult(null)
      toast({
        status: "success",
        title: "검증 완료",
        description: `${result.totalRows?.toLocaleString() || 0}건 검증을 마쳤습니다.`,
      })
    } catch (err) {
      toast({
        status: "error",
        title: "검증 실패",
        description: err.message || "검증 중 오류가 발생했습니다.",
      })
    } finally {
      setIsValidating(false)
    }
  }, [parsingError, selectedFile, toast])

  const handleUploadSubmit = useCallback(async () => {
    if (!selectedFile) return
    if (!validationPassed) {
      toast({
        status: "warning",
        title: "먼저 검증하세요",
        description: "검증이 오류 없이 완료되어야 업로드 버튼이 활성화됩니다.",
      })
      return
    }
    if (parsingError) {
      toast({
        status: "error",
        title: "파일 검증 실패",
        description: parsingError,
      })
      return
    }
    setUploading(true)
    try {
      const formData = new FormData()
      formData.append("file", selectedFile)
      formData.append("dry_run", "false")
      const result = await importTraindata(formData)
      setUploadResult(result)
      toast({
        status: "success",
        title: "업로드 완료",
        description: `${result.totalRows?.toLocaleString() || 0}건 처리가 완료되었습니다.`,
      })
    } catch (err) {
      toast({
        status: "error",
        title: "업로드 실패",
        description: err.message || "업로드 중 오류가 발생했습니다.",
      })
    } finally {
      setUploading(false)
    }
  }, [parsingError, selectedFile, toast, validationPassed])

  const handleUploadConfirm = useCallback(() => {
    uploadInfoDisclosure.onClose()
    handleUploadSubmit()
  }, [handleUploadSubmit, uploadInfoDisclosure])

  const downloadErrorCsv = useCallback(() => {
    const result = uploadResult ?? validationResult
    if (!result?.errors?.length) return
    const columns = [
      "rowNumber",
      "message",
      ...Array.from(
        new Set(
          result.errors.flatMap((err) =>
            Object.keys(err.row || {}).filter((key) => key !== "rowNumber" && key !== "message")
          )
        )
      ),
    ]
    const rows = result.errors.map((err) =>
      columns.map((column) => {
        if (column === "rowNumber") return err.rowNumber
        if (column === "message") return err.message
        return err.row?.[column] ?? ""
      })
    )
    const csvContent = [
      columns.join(","),
      ...rows.map((row) =>
        row
          .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
          .join(",")
      ),
    ].join("\n")
    const BOM = "\ufeff"
    const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    const downloadUrl = URL.createObjectURL(blob)
    link.href = downloadUrl
    const baseName = (selectedFile?.name?.replace(/\.[^.]+$/, "") || "errors").replace(/\s+/g, "_")
    link.download = `${baseName}-errors.csv`
    link.click()
    URL.revokeObjectURL(downloadUrl)
  }, [selectedFile, uploadResult, validationResult])
const REQUEST_STATUS_OPTIONS = [
  { value: "ALL", label: "전체" },
  { value: "PENDING", label: "대기" },
  { value: "RUNNING", label: "실행중" },
  { value: "SUCCEEDED", label: "성공" },
  { value: "FAILED", label: "실패" },
  { value: "REJECTED", label: "반려" },
]

const formatFilterLabel = (key) =>
  key ? key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()) : key

const onSwipeStart = (e) => {
  if (!isMobile) return;
  const t = e.touches[0];
  swipeStartRef.current = { x: t.clientX, y: t.clientY, t: Date.now() };
  swipeLockRef.current = null;
};

const onSwipeMove = (e) => {
  if (!isMobile || !swipeStartRef.current) return;
  const s = swipeStartRef.current;
  const t = e.touches[0];
  const dx = t.clientX - s.x;
  const dy = t.clientY - s.y;
  if (!swipeLockRef.current) swipeLockRef.current = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
  if (swipeLockRef.current === 'x') e.preventDefault();
};

const onSwipeEnd = (e) => {
  if (!isMobile || !swipeStartRef.current) return;
  const s = swipeStartRef.current;
  const t = e.changedTouches[0];
  const dx = t.clientX - s.x;
  const dy = t.clientY - s.y;
  const adx = Math.abs(dx), ady = Math.abs(dy);
  if (adx > 50 && adx > ady * 1.2) {
    if (dx < 0) { setSlideDir('left');  setRunTab(i => Math.min(i + 1, RUN_LAST_INDEX)); }
    else        { setSlideDir('right'); setRunTab(i => Math.max(i - 1, 0)); }
  }
  swipeStartRef.current = null;
  swipeLockRef.current = null;
};

// 애니메이션 variant
const panelVariants = {
  enter: (dir) => ({ x: dir === 'left' ? 40 : -40, opacity: 0 }),
  center: { x: 0, opacity: 1 },
  // 나가는 건 바로 사라지게(깜빡임 최소화)
  exit:  () => ({ x: 0, opacity: 0 })
};

// 컴포넌트 상단부에 추가
const isSelectingText = () =>
  typeof window !== "undefined" &&
  window.getSelection &&
  window.getSelection().toString().length > 0;

/** 모바일용 개별 정확도 카드 */
const AccRowCard = ({ r }) => {
  // 퍼센트 포맷 helper: 이미 Pct 컴포넌트가 있으면 그대로 사용
  const Field = ({ label, value, color }) => (
    <HStack justify="space-between">
      <Text fontSize="xs" color="gray.500">{label}</Text>
      <Text fontWeight="semibold" color={color}><Pct v={value} /></Text>
    </HStack>
  );

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor={border}
      rounded="xl"
      p={4}
      shadow="sm"
      _hover={{ shadow: "md" }}
      transition="all 0.2s"
    >
      {/* 헤더: 유형/프로젝트명 */}
      <VStack align="stretch" spacing={2} mb={2}>
        <HStack justify="space-between" align="center">
          <Badge colorScheme="blue" variant="subtle" rounded="full">
            {r.type || "-"}
          </Badge>
        </HStack>
        <Text
          fontWeight="semibold"
          color="gray.800"
          lineHeight="1.4"
          whiteSpace="normal"
          wordBreak="break-word"
          sx={{ overflowWrap: "anywhere" }}
          noOfLines={2}
        >
          {r.name ?? "-"}
        </Text>
        <Text fontSize="xs" color="gray.500">
          {r.received_date ? `${r.received_date} 접수` : "접수일 정보 없음"}
        </Text>
      </VStack>

      <Divider my={3} />

      <SimpleGrid columns={2} spacing={3}>
        <Field label="공사비" value={r.total_cost_per} color={getAccuracyColor(r?.total_cost_per)} />
        <Field label="건축비" value={r.building_cost_per} color={getAccuracyColor(r?.building_cost_per)}/>
        <Field label="토목" value={r.civil_cost_per} color={getAccuracyColor(r?.civil_cost_per)} />
        <Field label="전기" value={r.electrical_cost_per} color={getAccuracyColor(r?.electrical_cost_per)}/>
        <Field label="설비" value={r.facility_cost_per} color={getAccuracyColor(r?.facility_cost_per)} />
        <Field label="경상비" value={r.opex_cost_per} color={getAccuracyColor(r?.opex_cost_per)} />
        <Field label="공통" value={r.common_cost_per} color={getAccuracyColor(r?.common_cost_per)} />
        <Field label="기타" value={r.etc_cost_per} color={getAccuracyColor(r?.etc_cost_per)} />
      </SimpleGrid>
    </Box>
  );
};
  const preserveScroll = (fn) => {
    const y = window.scrollY;
    fn();
    requestAnimationFrame(() => window.scrollTo({ top: y, left: 0 }));
  };
  /** === useColorModeValue 훅: 최상단 한 번만 호출 === */
  const cardBg = useColorModeValue("white", "gray.800")
  const border = useColorModeValue("gray.200", "gray.600")
  const tableBg = useColorModeValue("gray.50", "gray.700")
  const tableHoverBg = useColorModeValue("blue.50", "blue.800")
  const tableHeaderBg = useColorModeValue("gray.50", "gray.700")
  const softBg = useColorModeValue("gray.50", "gray.700")
  const newDataRowHover = useColorModeValue("gray.100", "gray.600")
  const predRowHover = useColorModeValue("blue.50", "blue.900")
  const whiteBg = useColorModeValue("white", "gray.800")
  const mutedColor = useColorModeValue("gray.500", "gray.400")
  const paginationTextColor = useColorModeValue("gray.700", "gray.100")

  const isMobile = useBreakpointValue({ base: true, md: false })
  const paginationButtonSize = useBreakpointValue({ base: "sm", md: "xs" }) ?? "sm"
  const tip = useDisclosure()
  const newDataModal = useDisclosure()
  const {
    isOpen: isNewDataDetailOpen,
    onOpen: openNewDataDetail,
    onClose: closeNewDataDetail,
  } = useDisclosure()
  const dimensionDisclosure = useDisclosure({ defaultIsOpen: true })
  const costDisclosure = useDisclosure({ defaultIsOpen: true })
  const metaDisclosure = useDisclosure({ defaultIsOpen: true })
  const [expandedLog, setExpandedLog] = useState(null)
  const trainingDetailModal = useDisclosure()
  const [selectedTrainingRow, setSelectedTrainingRow] = useState(null)
  const handleOpenTrainingDetailModal = (row) => {
    setSelectedTrainingRow(row)
    trainingDetailModal.onOpen()
  }
  const handleCloseTrainingDetailModal = () => {
    setSelectedTrainingRow(null)
    trainingDetailModal.onClose()
  }

  const [activeSection, setActiveSection] = useState(null)
  const [navDir, setNavDir] = useState('forward');

  const modalFooterButtonSize = isMobile ? "md" : "lg"
  const modalFooterButtonHeight = isMobile ? "48px" : "58px"


  // collapse scroll target
  const trainingRef = useRef(null)
  const logsRef = useRef(null)
  const requestsRef = useRef(null)
  const reqRef = useRef(0)

  const [rows, setRows] = useState([])
  const [fetching, setFetching] = useState(false)

  const [query, setQuery] = useState({ type: "", region: "", district: "", keyword: "" })
  const [selectedTypeFilters, setSelectedTypeFilters] = useState([])
  const [trainingStatusFilter, setTrainingStatusFilter] = useState("all")
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const [requests, setRequests] = useState([])
  const [requestsLoading, setRequestsLoading] = useState(false)
  const [requestStatusFilter, setRequestStatusFilter] = useState("PENDING")
  const [selectedRequestId, setSelectedRequestId] = useState(null)
  const [selectedRequestDetail, setSelectedRequestDetail] = useState(null)
  const [myRequests, setMyRequests] = useState([])
  const [myRequestsLoading, setMyRequestsLoading] = useState(false)
  const [myRequestPage, setMyRequestPage] = useState(1)
  const myRequestPageSize = 5
  const myRequestsStats = useMemo(() => {
    const total = myRequests.length
    const pending = myRequests.filter((req) => (req.status ?? "").toUpperCase() === "PENDING").length
    const rejected = myRequests.filter((req) => (req.status ?? "").toUpperCase() === "REJECTED").length
    return { total, pending, rejected }
  }, [myRequests])
  const personalRequestHighlights = useMemo(
    () => [
      {
        label: "전체 요청",
        helper: "내가 요청한 학습",
        value: myRequestsStats.total,
      },
      {
        label: "승인 대기",
        helper: "검토 중",
        value: myRequestsStats.pending,
      },
      {
        label: "반려된 요청",
        helper: "재요청 필요",
        value: myRequestsStats.rejected,
      },
    ],
    [myRequestsStats]
  )
  const myRequestsTotalPages = Math.max(1, Math.ceil(myRequests.length / myRequestPageSize))
  useEffect(() => {
    setMyRequestPage(1)
  }, [myRequests.length])
  useEffect(() => {
    if (myRequestPage > myRequestsTotalPages) {
      setMyRequestPage(myRequestsTotalPages)
    }
  }, [myRequestPage, myRequestsTotalPages])
  const paginatedMyRequests = useMemo(() => {
    const start = (myRequestPage - 1) * myRequestPageSize
    return myRequests.slice(start, start + myRequestPageSize)
  }, [myRequests, myRequestPage, myRequestPageSize])
  const [requestNewData, setRequestNewData] = useState({ items: [], total: 0 })
  const [requestNewDataLoading, setRequestNewDataLoading] = useState(false)
  const [requestNewDataPage, setRequestNewDataPage] = useState(1)
  const requestNewDataPageSize = 20
  const [requestNewDataSearchInput, setRequestNewDataSearchInput] = useState("")
  const [requestNewDataKeyword, setRequestNewDataKeyword] = useState("")
  const [requestActionLoading, setRequestActionLoading] = useState(false)
  const [rejectReason, setRejectReason] = useState("")
  const requestNewDataTotalPages = Math.max(
    1,
    Math.ceil((requestNewData.total || 0) / requestNewDataPageSize)
  )
  const [selectedNewDataItem, setSelectedNewDataItem] = useState(null)
  const modalNewDataPageSize = 20
  const [modalNewData, setModalNewData] = useState({ items: [], total: 0 })
  const [modalNewDataLoading, setModalNewDataLoading] = useState(false)
  const [modalPage, setModalPage] = useState(1)
  const [modalSearchInput, setModalSearchInput] = useState("")
  const [modalSearch, setModalSearch] = useState("")
  const modalNewDataTotalPages = Math.max(
    1,
    Math.ceil((modalNewData.total || 0) / modalNewDataPageSize)
  )
  const requestNewDataStats = useMemo(() => {
    const normalized = normalizeRequestNewDataItems(requestNewData.items)
    if (!normalized.length) return null
    const costItems = normalized.filter((item) => typeof item.total_cost === "number")
    if (!costItems.length)
      return { normalized, highest: null, lowest: null, avg: null }
    const highest = costItems.reduce(
      (prev, curr) => (curr.total_cost > prev.total_cost ? curr : prev),
      costItems[0]
    )
    const lowest = costItems.reduce(
      (prev, curr) => (curr.total_cost < prev.total_cost ? curr : prev),
      costItems[0]
    )
    const avg =
      costItems.reduce((sum, curr) => sum + Number(curr.total_cost ?? 0), 0) / costItems.length
    return { normalized, highest, lowest, avg }
  }, [requestNewData.items])

  const normalizedRequestNewDataItems = requestNewDataStats?.normalized ?? []

  const anomalyReasonText = useMemo(() => {
    if (!requestNewDataStats?.highest) return null
    const { highest, avg } = requestNewDataStats
    if (!avg || avg === 0) {
      return `이 이상치를 보이는 이유: 총공사비 ${formatCurrency(
        highest.total_cost
      )}으로 다른 항목에 비해 유난히 큽니다.`
    }
    const diff = highest.total_cost - avg
    const pct = (diff / avg) * 100
    return `이 항목은 평균 총공사비(${formatCurrency(
      avg
    )})보다 ${pct.toFixed(1)}% 높아 기존 데이터 대비 이상치로 판단됩니다.`
  }, [requestNewDataStats])
  const fetchTrainingRequestNewData = useCallback(
    async ({ requestId, page, pageSize, keyword }) => {
      if (!requestId) {
        return { items: [], total: 0 }
      }
      const data = await listTrainingRequestNewData(requestId, {
        page,
        page_size: pageSize,
        keyword,
      })
      return {
        items: normalizeRequestNewDataItems(Array.isArray(data?.items) ? data.items : []),
        total: Number(data?.total ?? 0),
      }
    },
    []
  )

  //  선택 삭제용 상태
  const [selectedIds, setSelectedIds] = useState(new Set())
  const [deleteLoading, setDeleteLoading] = useState(false)

  // 개별 정확도 목록(traindata_run_json.rows) 검색/페이징 상태
  const [accFilter, setAccFilter] = useState({ type: "", q: "", received_from: "", received_to: "" });
  const [accPage, setAccPage] = useState(1);
  const [accPageSize, setAccPageSize] = useState(10);
  const [accSortOrder, setAccSortOrder] = useState("desc");
  const toggleAccDateSort = () => setAccSortOrder((prev) => (prev === "desc" ? "asc" : "desc"));


  const isSelected = (id) => selectedIds.has(id)
  const toggleSelect = (id) =>
    setSelectedIds((prev) => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  const clearSelection = () => setSelectedIds(new Set())

  const filteredRows = useMemo(() => {
    const baseFiltered =
      trainingStatusFilter === "all"
        ? rows
        : rows.filter((r) =>
            trainingStatusFilter === "trained"
              ? r.last_trained_run_id != null
              : r.last_trained_run_id == null
          )
    if (selectedTypeFilters.length === 0) return baseFiltered
    return baseFiltered.filter((r) => selectedTypeFilters.includes(r.type))
  }, [rows, trainingStatusFilter, selectedTypeFilters])
  const pageIds = useMemo(() => filteredRows.map((r) => r.id), [filteredRows])
  const allSelectedOnPage = useMemo(
    () => pageIds.length > 0 && pageIds.every((id) => selectedIds.has(id)),
    [pageIds, selectedIds]
  )
  const toggleSelectAllOnPage = () =>
    setSelectedIds((prev) => {
      const next = new Set(prev)
      if (allSelectedOnPage) {
        pageIds.forEach((id) => next.delete(id))
      } else {
        pageIds.forEach((id) => next.add(id))
      }
      return next
    })

  const loadRows = async () => {
    const myTurn = ++reqRef.current
    setFetching(true)
    try {
      const paramsObj = {
        ...query,
        page,
        page_size: pageSize,
      }
      if (selectedTypeFilters.length > 0) {
        paramsObj.type = selectedTypeFilters
      }
      const params = Object.fromEntries(
        Object.entries(paramsObj).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
      )

      const { items, total } = await listTraindata(params)
      if (myTurn !== reqRef.current) return
      setRows(items || [])
      setTotal(total || 0)
    } catch (e) {
      if (myTurn !== reqRef.current) return
      console.error(e)
      setRows([])
    } finally {
      if (myTurn === reqRef.current) setFetching(false)
    }
  }
  
  useEffect(() => {
    loadRows()
  }, [page, pageSize, query, selectedTypeFilters])

  useEffect(() => {
    clearSelection()
  }, [page, pageSize, query, trainingStatusFilter])

  const loadTrainingRequests = useCallback(async () => {
    if (!isSuperAdmin) return
    setRequestsLoading(true)
    try {
      const data = await listTrainingRequests({ status: requestStatusFilter })
      const list = Array.isArray(data) ? data : []
      setRequests(list)
      setSelectedRequestId((prev) => {
        if (prev && list.some((r) => r.id === prev)) return prev
        return list.length > 0 ? list[0].id : null
      })
    } catch (error) {
      console.error(error)
      toast({
        status: "error",
        title: "요청 목록 로딩 실패",
        description: getFriendlyErrorMessage(error),
      })
    } finally {
      setRequestsLoading(false)
    }
  }, [requestStatusFilter, isSuperAdmin, toast])

  const loadMyRequests = useCallback(async () => {
    if (!user?.role) {
      setMyRequests([])
      return
    }
    setMyRequestsLoading(true)
    try {
      const data = await listMyTrainingRequests()
      setMyRequests(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error(error)
      toast({
        status: "error",
        title: "내 요청 목록 로딩 실패",
        description: getFriendlyErrorMessage(error),
      })
    } finally {
      setMyRequestsLoading(false)
    }
  }, [toast, user?.role])

  const loadRequestDetail = useCallback(
    async (id) => {
      if (!id) {
        setSelectedRequestDetail(null)
        return
      }
      try {
        const detail = await getTrainingRequestDetail(id)
        setSelectedRequestDetail(detail)
        setRequestNewDataPage(1)
      } catch (error) {
        console.error(error)
        toast({
          status: "error",
          title: "요청 상세 로딩 실패",
          description: getFriendlyErrorMessage(error),
        })
        setSelectedRequestDetail(null)
      }
    },
    [toast]
  )

  const loadRequestNewData = useCallback(
    async (requestId, page) => {
      if (!requestId) {
        setRequestNewData({ items: [], total: 0 })
        return
      }
      setRequestNewDataLoading(true)
      try {
        const data = await fetchTrainingRequestNewData({
          requestId,
          page,
          pageSize: requestNewDataPageSize,
          keyword: requestNewDataKeyword || undefined,
        })
        setRequestNewData(data)
      } catch (error) {
        console.error(error)
        toast({
          status: "error",
          title: "신규 데이터 목록 로딩 실패",
          description: getFriendlyErrorMessage(error),
        })
      } finally {
        setRequestNewDataLoading(false)
      }
    },
    [fetchTrainingRequestNewData, requestNewDataPageSize, requestNewDataKeyword, toast]
  )

  const handleRequestNewDataSearch = () => {
    setRequestNewDataKeyword(requestNewDataSearchInput.trim())
    setRequestNewDataPage(1)
  }

  const handleRequestNewDataReset = () => {
    setRequestNewDataSearchInput("")
    setRequestNewDataKeyword("")
    setRequestNewDataPage(1)
  }

  const handleSelectNewDataItem = (item) => {
    if (!item) return
    setSelectedNewDataItem(item)
    openNewDataDetail()
  }

  const handleCloseNewDataDetailModal = () => {
    setSelectedNewDataItem(null)
    closeNewDataDetail()
  }

  const loadModalNewData = useCallback(
    async () => {
      if (!selectedRequestId || !newDataModal.isOpen) {
        setModalNewData({ items: [], total: 0 })
        return
      }
      setModalNewDataLoading(true)
      try {
        const data = await fetchTrainingRequestNewData({
          requestId: selectedRequestId,
          page: modalPage,
          pageSize: modalNewDataPageSize,
          keyword: modalSearch || undefined,
        })
        setModalNewData(data)
      } catch (error) {
        console.error(error)
        toast({
          status: "error",
          title: "전체 보기 목록 로딩 실패",
          description: getFriendlyErrorMessage(error),
        })
      } finally {
        setModalNewDataLoading(false)
      }
    },
    [
      selectedRequestId,
      modalPage,
      modalSearch,
      fetchTrainingRequestNewData,
      modalNewDataPageSize,
      newDataModal.isOpen,
      toast,
    ]
  )

  useEffect(() => {
    if (!newDataModal.isOpen) return
    loadModalNewData()
  }, [newDataModal.isOpen, loadModalNewData])

  useEffect(() => {
    setModalPage(1)
    setModalSearch("")
    setModalSearchInput("")
    setRequestNewDataSearchInput("")
    setRequestNewDataKeyword("")
  }, [selectedRequestId])

  const handleModalSearch = () => {
    setModalSearch(modalSearchInput.trim())
    setModalPage(1)
  }

  const handleOpenNewDataModal = () => {
    setModalPage(1)
    setModalSearch("")
    setModalSearchInput("")
    newDataModal.onOpen()
  }

  useEffect(() => {
    if (activeSection === "requests" && isSuperAdmin) {
      loadTrainingRequests()
    }
  }, [activeSection, isSuperAdmin, loadTrainingRequests, requestStatusFilter])

  useEffect(() => {
    loadMyRequests()
  }, [loadMyRequests])

  useEffect(() => {
    if (selectedRequestId) {
      loadRequestDetail(selectedRequestId)
    } else {
      setSelectedRequestDetail(null)
    }
  }, [selectedRequestId, loadRequestDetail])

  useEffect(() => {
    setSelectedNewDataItem(null)
    closeNewDataDetail()
  }, [selectedRequestId, closeNewDataDetail])

  useEffect(() => {
    if (
      selectedNewDataItem &&
      !requestNewData.items.some((item) => item.id === selectedNewDataItem.id)
    ) {
      setSelectedNewDataItem(null)
      closeNewDataDetail()
    }
  }, [requestNewData.items, selectedNewDataItem, closeNewDataDetail])

  useEffect(() => {
    if (selectedRequestId) {
      loadRequestNewData(selectedRequestId, requestNewDataPage)
    }
  }, [selectedRequestId, requestNewDataPage, loadRequestNewData])

  const handleApproveRequest = async () => {
    if (!selectedRequestDetail?.id || selectedRequestDetail?.status !== "PENDING") return
    const latestLogs = await loadLogs()
    if (hasRunningLog(latestLogs)) {
      toast({
        status: "warning",
        title: "이미 학습이 실행 중입니다.",
        description: "실행 기록에서 진행 중인 학습이 있어 새로운 학습을 시작할 수 없습니다.",
      })
      return
    }
    setRequestActionLoading(true)
    try {
      await approveTrainingRequest(selectedRequestDetail.id)
      toast({
        status: "success",
        title: "학습 실행 준비 완료",
        description:
          "학습이 백그라운드에서 실행되고 있으며 [실행 기록 > 목록]에서 상태를 확인할 수 있습니다. 해당 메뉴로 이동하며 실행중인 추가 데이터를 확인하세요.",
        duration: 4000,
      })
      setNavDir("forward")
      setActiveSection("logs")
      window?.scrollTo?.({ top: 0, behavior: "smooth" })
      await loadLogs()
      await loadTrainingRequests()
      await loadRequestDetail(selectedRequestDetail.id)
      setRequestNewDataPage(1)
      loadRequestNewData(selectedRequestDetail.id, 1)
    } catch (error) {
      console.error(error)
      toast({
        status: "error",
        title: "승인 실패",
        description: getFriendlyErrorMessage(error),
      })
    } finally {
      setRequestActionLoading(false)
    }
  }

  const handleRejectConfirm = async () => {
    if (!selectedRequestDetail?.id) return
    const reason = rejectReason.trim()
    if (!reason) {
      toast({
        status: "warning",
        title: "사유를 입력하세요.",
      })
      return
    }
    setRequestActionLoading(true)
    try {
      await rejectTrainingRequest(selectedRequestDetail.id, reason)
      toast({
        status: "success",
        title: "학습 요청 반려",
        description: "요청자에게 반려 안내가 전송됩니다.",
      })
      setRejectReason("")
      onRejectClose()
      await loadTrainingRequests()
      await loadRequestDetail(selectedRequestDetail.id)
    } catch (error) {
      console.error(error)
      toast({
        status: "error",
        title: "반려 실패",
        description: getFriendlyErrorMessage(error),
      })
    } finally {
      setRequestActionLoading(false)
    }
  }

  const [requestLoading, setRequestLoading] = useState(false)
  useEffect(() => {
    const prev = document.body.style.overflow
    const shouldLockScroll = requestLoading || (!isMobile && activeSection === null)
    if (shouldLockScroll) {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = prev
    }
  }, [requestLoading, isMobile, activeSection])

  const submitTrainingRequest = async () => {
    try {
      setRequestLoading(true)
      const payload = Object.fromEntries(
        Object.entries({
          type: query.type,
          region: query.region,
          district: query.district,
          keyword: query.keyword,
        }).filter(([_, v]) => v)
      )
      const data = await createTrainingRequest(payload)
      toast({
        status: "success",
        title: "학습 요청 완료",
        description: `시스템 관리자 검토 후 학습이 진행됩니다.
학습 > 내 학습 요청 현황에서 확인 가능합니다.
신규 데이터 ${Number(data?.newDataCount ?? 0).toLocaleString()}건이 반영 대상입니다.`,
        duration: 4000,
      })
    } catch (e) {
      console.error(e)
      toast({
        status: "error",
        title: "학습 요청 실패",
        description: getFriendlyErrorMessage(e),
      })
    } finally {
      setRequestLoading(false)
    }
  }

  //  학습 확인 모달 상태
  const {
    isOpen: isTrainConfirmOpen,
    onOpen: onTrainConfirmOpen,
    onClose: onTrainConfirmClose,
  } = useDisclosure()
  const runApproveConfirm = useDisclosure()

  const {
    isOpen: isRejectOpen,
    onOpen: onRejectOpen,
    onClose: onRejectClose,
  } = useDisclosure()

  // 모달에서 "예, 시작" 클릭 시
  const handleConfirmRequest = async () => {
    onTrainConfirmClose()
    await submitTrainingRequest()
  }

  const handleConfirmRunApprove = async () => {
    runApproveConfirm.onClose()
    await handleApproveRequest()
  }

  const [logs, setLogs] = useState([])
  const [logsLoading, setLogsLoading] = useState(false)
  const [selectedLog, setSelectedLog] = useState(null)
  const [logDetail, setLogDetail] = useState(null)
  const runningLogCount = useMemo(
    () =>
      (Array.isArray(logs) ? logs : []).filter(
        (log) => String(log?.status || "").toLowerCase() === "running"
      ).length,
    [logs]
  )

  // 실행 선택 모달(돋보기)
  const {
    isOpen: isRunPickerOpen,
    onOpen: onRunPickerOpen,
    onClose: onRunPickerClose,
  } = useDisclosure()
  const [logFilter, setLogFilter] = useState("")

  // 실행 상세(traindata_run_json) 모달
  const {
    isOpen: isRunModalOpen,
    onOpen: onRunModalOpen,
    onClose: onRunModalClose,
  } = useDisclosure()
  const mobileRequestModal = useDisclosure()
  const [runSummary, setRunSummary] = useState(null)

  const hasRunningLog = (items) =>
    (Array.isArray(items) ? items : []).some(
      (log) => (String(log?.status || "").toLowerCase() === "running")
    )

  const loadLogs = async () => {
    try {
      setLogsLoading(true)
      const data = await listRuns()
      const normalized = Array.isArray(data) ? data : []
      setLogs(normalized)
      return normalized
    } catch (e) {
      console.error(e)
      setLogs([])
      return []
    } finally {
      setLogsLoading(false)
    }
  }
  const loadLogDetail = async (runId) => {
    try {
      setSelectedLog(runId)
      const data = await getRunDetail(runId)
      setLogDetail(data)
      // traindata_run_json를 상세 모달에 연결
      setRunSummary(data?.traindata_run_json || null)
      onRunModalOpen()
    } catch (e) {
      console.error(e)
      setLogDetail(null)
      setRunSummary(null)
    }
  }
  useEffect(() => {
    loadLogs()
  }, [])
  const shouldAutoScrollRef = useRef(false);
  // scroll into view
  useEffect(() => {
    const ref =
      activeSection === "training"
        ? trainingRef
        : activeSection === "logs"
        ? logsRef
        : activeSection === "requests"
        ? requestsRef
        : null
    if (!ref?.current) return
   const t = setTimeout(() => {
     if (shouldAutoScrollRef.current) {
       ref.current.scrollIntoView({ behavior: "smooth", block: "start" })
       shouldAutoScrollRef.current = false
     }
   }, 80)
    return () => clearTimeout(t)
  }, [activeSection])

  useEffect(() => {
    if (!isMobile && mobileRequestModal.isOpen) {
      mobileRequestModal.onClose()
    }
  }, [isMobile, mobileRequestModal.isOpen])

  const statusBadge = (s) => {
    const map = { running: "yellow", succeeded: "green", failed: "red", queued: "gray" }
    return (
      <Badge colorScheme={map[s] || "gray"} variant="subtle" px={3} py={1} rounded="full">
        {s}
      </Badge>
    )
  }

  const totalPages = useMemo(() => Math.max(1, Math.ceil((total || 0) / pageSize)), [total, pageSize])

  // 전체 rows
  const accRowsAll = useMemo(
    () => Array.isArray(runSummary?.rows) ? runSummary.rows : [],
    [runSummary]
  );

  // 유형 목록(중복 제거)
  const accTypes = useMemo(
    () => Array.from(new Set(accRowsAll.map(r => r.type).filter(Boolean))),
    [accRowsAll]
  );

  // 검색/필터
  const accFiltered = useMemo(() => {
    const q = (accFilter.q || "").toLowerCase().trim();
    const ty = accFilter.type || "";
    return accRowsAll.filter(r => {
      const okType = !ty || r.type === ty;
      const okQ = !q || String(r.name || "").toLowerCase().includes(q);
      const received = typeof r.received_date === "string" ? r.received_date : null;
      const from = accFilter.received_from || "";
      const to = accFilter.received_to || "";
      const okDate =
        (!from || (received && received >= from)) &&
        (!to || (received && received <= to));
      return okType && okQ && okDate;
    });
  }, [accRowsAll, accFilter]);

  // 페이징
  const accSorted = useMemo(() => {
    const sorted = [...accFiltered];
    sorted.sort((a, b) => {
      const da = a.received_date;
      const db = b.received_date;
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      if (da === db) return 0;
      if (da < db) return accSortOrder === "desc" ? 1 : -1;
      return accSortOrder === "desc" ? -1 : 1;
    });
    return sorted;
  }, [accFiltered, accSortOrder]);

  const accTotalPages = useMemo(
    () => Math.max(1, Math.ceil(accSorted.length / accPageSize)),
    [accSorted, accPageSize]
  );
  const accPaged = useMemo(() => {
    const start = (accPage - 1) * accPageSize;
    return accSorted.slice(start, start + accPageSize);
  }, [accSorted, accPage, accPageSize]);

  // 검색조건/페이지크기 바뀌면 1페이지로
  useEffect(() => { setAccPage(1); }, [accFilter, accPageSize]);

  // runSummary.by_type: { "아파트": {count:..., total_cost_per:...}, ... } 형태 → 배열로 변환
  const byTypeArr = useMemo(() => {
    const src = runSummary?.by_type || {};
    const arr = Object.entries(src).map(([type, v]) => ({
      type,
      count: v?.count ?? 0,
      total_cost_per: v?.total_cost_per ?? null,
      building_cost_per: v?.building_cost_per ?? null,
      civil_cost_per: v?.civil_cost_per ?? null,
      electrical_cost_per: v?.electrical_cost_per ?? null,
      facility_cost_per: v?.facility_cost_per ?? null,
      opex_cost_per: v?.opex_cost_per ?? null,
      common_cost_per: v?.common_cost_per ?? null,
      etc_cost_per: v?.etc_cost_per ?? null,
    }));
    // 보기 좋게 count 내림차순 정렬 (원하면 제거 가능)
    arr.sort((a, b) => (b.count || 0) - (a.count || 0));
    return arr;
  }, [runSummary]);

  /** =========================
   *   편집 모달 (팝업 편집)
   *  ========================= */
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose
  } = useDisclosure()
  const [editRow, setEditRow] = useState(null)
  const [editForm, setEditForm] = useState({
    total_cost: "",
    building_cost: "",
    rock_ratio: "",
    civil_cost: "",
    electrical_cost: "",
    facility_cost: "",
    opex_cost: "",
    etc_cost: "",
    common_cost: "",
    // 확장: 메타/입력 필드
    type: "",
    project_name: "",
    region: "",
    district: "",
    round_label: "",
    manager: "",
    received_date: "",
    total_area_py: "",
    finish_level: "",
    household_window: "",
    structure_parking: "",
    structure_ground: "",
    structure_standard: "",
    construction_method: "",
    avg_area_py: "",
    duration_months: "",
    floors_above: "",
    floors_below: "",
    heating: "",
    external_work: "",
    households: "",
    note: "",
    // 신규 4개
    slope_type: "",
    building_count: "",
    site_area: "",
    supply_area: "",
    is_coastal: "0",
  })
  // 편집 출처(예측/학습) 표시용
  const [editSource, setEditSource] = useState(null) // "pred" | "train" | null

  const toNumOrNull = (v) => {
    if (v === "" || v === null || v === undefined) return null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
  }
  const openEditModal = (row, source = "train") => {
    setEditRow(row)
    setEditSource(source)
    const fromPred = source === "pred"
    const pick = (predKey, trainKey) => (fromPred ? row?.[predKey] : row?.[trainKey])
    const prefill = {
      total_cost: row.total_cost ?? "",
      building_cost: row.building_cost ?? "",
      rock_ratio: row.rock_ratio ?? "",
      civil_cost: row.civil_cost ?? "",
      electrical_cost: row.electrical_cost ?? "",
      facility_cost: row.facility_cost ?? "",
      opex_cost: row.opex_cost ?? "",
      etc_cost: row.etc_cost ?? "",
      common_cost: row.common_cost ?? "",
      construction_method: row.construction_method ?? "",
      // 확장 필드 프리필 (pred ↔ train alias 매핑)
      type: pick("type","type") ?? "",
      project_name: pick("project_name","project_name") ?? "",
      region: pick("region","region") ?? "",
      district: pick("district","district") ?? "",
      round_label: row.round_label ?? "",
      manager: row.manager ?? "",
      received_date: pick("received_date","received_date") || "",
      total_area_py: pick("area_pyeong","total_area_py") ?? "",
      finish_level: pick("finish_level","finish_level") ?? "",
      household_window: pick("household_window","household_window") ?? "",
      structure_parking: pick("structure_parking","structure_parking") ?? "",
      structure_ground: pick("structure_ground","structure_ground") ?? "",
      structure_standard: pick("structure_standard","structure_standard") ?? "",
      avg_area_py: pick("avg_pyeong","avg_area_py") ?? "",
      duration_months: pick("duration_month","duration_months") ?? "",
      floors_above: pick("floor_above","floors_above") ?? "",
      floors_below: pick("floor_below","floors_below") ?? "",
      heating: pick("heating","heating") ?? "",
      external_work: pick("out_of_complex","external_work") ?? "",
      households: pick("households","households") ?? "",
      note: row.note ?? "",
      slope_type: row.slope_type ?? "",
      building_count: row.building_count ?? "",
      site_area: row.site_area ?? "",
      supply_area: row.supply_area ?? "",
      is_coastal: (row.is_coastal === true || row.is_coastal === false) ? (row.is_coastal ? "1" : "0") : "0",
    }
    setEditForm(sanitizeStructureFields(prefill, prefill.type))
    onEditOpen()
  }
  const saveEditModal = async () => {
    if (!editRow) return
    try {
      const body = {
        // 비용
        total_cost: toNumOrNull(editForm.total_cost),
        building_cost: toNumOrNull(editForm.building_cost),
        rock_ratio: toNumOrNull(editForm.rock_ratio),
        civil_cost: toNumOrNull(editForm.civil_cost),
        electrical_cost: toNumOrNull(editForm.electrical_cost),
        facility_cost: toNumOrNull(editForm.facility_cost),
        opex_cost: toNumOrNull(editForm.opex_cost),
        etc_cost: toNumOrNull(editForm.etc_cost),
        common_cost: toNumOrNull(editForm.common_cost),
        // 메타/입력
        type: editForm.type || null,
        project_name: editForm.project_name || null,
        region: editForm.region || null,
        district: editForm.district || null,
        round_label: editForm.round_label || null,
        manager: editForm.manager || null,
        received_date: editForm.received_date || null,
        total_area_py: toNumOrNull(editForm.total_area_py),
        finish_level: editForm.finish_level || null,
        household_window: editForm.household_window || null,
        structure_parking: editForm.structure_parking || null,
        structure_ground: editForm.structure_ground || null,
        structure_standard: editForm.structure_standard || null,
        construction_method: editForm.construction_method || null,
        avg_area_py: toNumOrNull(editForm.avg_area_py),
        duration_months: toNumOrNull(editForm.duration_months),
        floors_above: toNumOrNull(editForm.floors_above),
        floors_below: toNumOrNull(editForm.floors_below),
        heating: editForm.heating || null,
        external_work: editForm.external_work || null,
        households: toNumOrNull(editForm.households),
        note: editForm.note || null,
        // 신규 4개
        slope_type: editForm.slope_type || null,
        building_count: toNumOrNull(editForm.building_count),
        site_area: toNumOrNull(editForm.site_area),
        supply_area: toNumOrNull(editForm.supply_area),
        is_coastal: editForm.is_coastal === "1",
      }
      await updateTraindata(editRow.id, body)
      // UI 반영
      setRows((list) => list.map((r) => (r.id === editRow.id ? { ...r, ...body } : r)))
      toast({
        status: "success",
        title: `${editSource === "pred" ? "예측 데이터" : "학습 데이터"}가 저장되었습니다.`,
      })
      onEditClose()
      setEditRow(null)
      setEditSource(null)
    } catch (e) {
      console.error(e)
      toast({
        status: "error",
        title: "저장 실패",
        description: getFriendlyErrorMessage(e),
      })
    }
  }

  /** ============== 예측 검색/적용 ============== */
  const [predSearch, setPredSearch] = useState({ run_id: "", q: "" })
  const [predList, setPredList] = useState([])
  const [predTotal, setPredTotal] = useState(0)
  const [predLoading, setPredLoading] = useState(false)
  const [predPage, setPredPage] = useState(1)
  const predPageSize = useMemo(() => (isMobile ? 3 : 10), [isMobile])
  const loadPreds = async (pageOverride) => {
    try {
      setPredLoading(true)
      const pageToUse = pageOverride || predPage || 1
      const data = await listPredictions({
        run_id: predSearch.run_id || undefined,
        q: predSearch.q || undefined,
        page: pageToUse,
        page_size: predPageSize,
      })
      const items = Array.isArray(data) ? data : (data.items || [])
      setPredList(items)
      setPredTotal(Array.isArray(data) ? items.length : (data.total || items.length || 0))
      if (pageOverride) setPredPage(pageOverride)
    } catch (e) {
      console.error(e)
      toast({
        status: "error",
        title: "예측 조회 실패",
        description: getFriendlyErrorMessage(e),
      })
      setPredList([])
      setPredTotal(0)
    } finally {
      setPredLoading(false)
    }
  }
  const applyPrediction = (p) => {
    setForm((f) => {
      const nextType = p.type ?? f.type
      const next = {
        ...f,
        type: nextType,
        project_name: p.project_name ?? f.project_name,
        region: p.region ?? f.region,
        district: p.district ?? f.district,
        received_date: (typeof p.received_date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(p.received_date)) ? p.received_date : f.received_date,
        floors_above: p.floor_above ?? f.floors_above,
        floors_below: p.floor_below ?? f.floors_below,
        heating: p.heating ?? f.heating,
        households: p.households ?? f.households,
        external_work: p.out_of_complex ?? f.external_work,
        total_area_py: p.area_pyeong ?? f.total_area_py,
        finish_level: p.finish_level ?? f.finish_level,
        household_window: p.household_window ?? f.household_window,
        structure_parking: p.structure_parking ?? f.structure_parking ?? "",
        structure_ground: p.structure_ground ?? f.structure_ground ?? "",
        structure_standard: p.structure_standard ?? f.structure_standard ?? "",
        construction_method: p.construction_method ?? f.construction_method,
        avg_area_py: p.avg_pyeong ?? f.avg_area_py,
        duration_months: p.duration_month ?? f.duration_months,
        rock_ratio: p.rock_ratio ?? f.rock_ratio,
        // 신규 4개 필드
        slope_type: (p.slope_type ?? f.slope_type) || "",
        building_count: (p.building_count ?? f.building_count) ?? "",
        site_area: (p.site_area ?? f.site_area) ?? "",
        is_coastal: (p.is_coastal === true || p.is_coastal === false)
          ? (p.is_coastal ? "1" : "0")
          : (f.is_coastal ?? "0"),
        note: "",
      }
      return sanitizeStructureFields(next, nextType)
    })
    
    toast({
      status: "info",
      title: "예측값에서 기본 정보를 채웠습니다.",
      description: (
        <>
          실제 비용(공사비·건축비·토목·전기·설비·경상비·기타·공통)은 확정 후 직접 입력해 주세요.
        </>
      )
    })
  }

  /** ============== 새 데이터 추가(기존 섹션) ============== */
  const { isOpen: isCreateOpen, onOpen: onCreateOpen, onClose: onCreateClose } = useDisclosure()
  const [createLoading, setCreateLoading] = useState(false)
  const [finishLevelOptions, setFinishLevelOptions] = useState([])
  const [householdWindowOptions, setHouseholdWindowOptions] = useState(DEFAULT_HOUSEHOLD_WINDOW_OPTIONS)
  const [structureOptions, setStructureOptions] = useState(DEFAULT_STRUCTURE_OPTIONS)
  const [structureVisibilityRules, setStructureVisibilityRules] = useState({
    default: DEFAULT_STRUCTURE_VISIBILITY,
  })
  const [structureFieldOrder, setStructureFieldOrder] = useState(STRUCTURE_FIELD_KEYS)
  const structureFieldMetaList = useMemo(
    () => structureFieldOrder
      .map((key) => {
        const meta = STRUCTURE_FIELD_META[key]
        return meta ? { key, ...meta } : null
      })
      .filter(Boolean),
    [structureFieldOrder],
  )

  useEffect(() => {
    let cancelled = false
    getPredictMeta()
      .then((meta) => {
        if (cancelled || !meta) return
        if (Array.isArray(meta.finishLevels) && meta.finishLevels.length) {
          setFinishLevelOptions(meta.finishLevels)
        }
        if (Array.isArray(meta.householdWindows) && meta.householdWindows.length) {
          setHouseholdWindowOptions(
            Array.from(new Set([...DEFAULT_HOUSEHOLD_WINDOW_OPTIONS, ...meta.householdWindows]))
          )
        }
        if (meta.structureOptions) {
          setStructureOptions((prev) => ({
            parking: meta.structureOptions.parking || prev.parking,
            ground: meta.structureOptions.ground || prev.ground,
            standard: meta.structureOptions.standard || prev.standard,
          }))
        }
        if (meta.structureVisibility) {
          setStructureVisibilityRules((prev) => ({
            ...prev,
            ...meta.structureVisibility,
          }))
        }
        if (Array.isArray(meta.structureFields) && meta.structureFields.length) {
          const normalized = meta.structureFields.filter((key) =>
            STRUCTURE_FIELD_KEYS.includes(key)
          )
          if (normalized.length) {
            setStructureFieldOrder(normalized)
          }
        }
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  const getStructureVisibilityForType = (typeValue) => {
    const key = (typeValue || "").trim()
    if (key && structureVisibilityRules[key]) {
      return structureVisibilityRules[key]
    }
    return structureVisibilityRules.default || DEFAULT_STRUCTURE_VISIBILITY
  }

  const sanitizeStructureFields = (values, typeValue) => {
    const visibility = getStructureVisibilityForType(typeValue)
    let updated = null
    for (const fieldKey of structureFieldOrder) {
      const meta = STRUCTURE_FIELD_META[fieldKey]
      if (!meta || visibility[meta.optionKey]) continue
      if (values[fieldKey]) {
        updated = updated || { ...values }
        updated[fieldKey] = ""
      }
    }
    return updated || values
  }

  const resolveStructureOptions = (optionKey) =>
    structureOptions?.[optionKey] || DEFAULT_STRUCTURE_OPTIONS[optionKey] || []

  const getVisibleStructureFields = (typeValue) =>
    structureFieldMetaList.filter((field) => getStructureVisibilityForType(typeValue)[field.optionKey])

  const renderStructureInputs = ({ values, onChange, typeValue, disabled = false }) => {
    const visibleFields = getVisibleStructureFields(typeValue)
    if (!visibleFields.length) return null
    const columnCount = Math.max(1, Math.min(visibleFields.length, 3))
    return (
      <FormControl>
        <FormLabel>구조</FormLabel>
        <SimpleGrid columns={{ base: 1, md: columnCount }} spacing={2}>
          {visibleFields.map((field) => {
            const options = Array.from(new Set(resolveStructureOptions(field.optionKey)))
            return (
              <Box key={field.key}>
                <Text fontSize="xs" color="gray.500" mb={1}>{field.label}</Text>
                <ChakraSelect
                  placeholder="선택하세요"
                  value={values[field.key] ?? ""}
                  onChange={(e) => onChange(field.key, e.target.value)}
                  isDisabled={disabled}
                >
                  {options.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </ChakraSelect>
              </Box>
            )
          })}
        </SimpleGrid>
      </FormControl>
    )
  }

  const [form, setForm] = useState({
    type: "",
    project_name: "",
    region: "",
    district: "",
    round_label: "",
    manager: "",
    received_date: "",         // "YYYY-MM-DD"
    total_area_py: "",
    finish_level: "",
    household_window: "",
    structure_parking: "",
    structure_ground: "",
    structure_standard: "",
    construction_method: "",
    avg_area_py: "",
    duration_months: "",
    floors_above: "",
    floors_below: "",
    rock_ratio: "",
    heating: "",
    external_work: "",
    households: "",
    total_cost: "",
    building_cost: "",
    civil_cost: "",
    electrical_cost: "",
    facility_cost: "",
    opex_cost: "",
    etc_cost: "",
    common_cost: "",
    note: "",
    // 신규 필드
    slope_type: "",
    building_count: "",
    site_area: "",
    is_coastal: "0",
  })
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }))
  const handleFormTypeChange = (value) => {
    setForm((prev) => sanitizeStructureFields({ ...prev, type: value }, value))
  }
  const toNullableNumber = (v) => {
    if (v === "" || v === null || v === undefined) return null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
  }

  // 필수 비용 항목
  const requiredCosts = [
    { key: "total_cost", label: "공사비" },
    { key: "building_cost", label: "건축비" },
    { key: "civil_cost", label: "토목" },
    { key: "electrical_cost", label: "전기" },
    { key: "facility_cost", label: "설비" },
    { key: "opex_cost", label: "경상비" },
    { key: "common_cost", label: "공통" },
    { key: "etc_cost", label: "기타" },
  ];

  const submitCreate = async () => {
    if (!form.project_name?.trim()) {
      toast({ status: "warning", title: "프로젝트명을 입력해 주세요." })
      return
    }
    if (!form.type?.trim()) {
      toast({ status: "warning", title: "유형을 선택해 주세요." })
      return
    }
    for (const { key, label } of requiredCosts) {
      if (form[key] === "" || form[key] === null || form[key] === undefined) {
        toast({
          status: "warning",
          title: `${label}를 입력해 주세요.`,
        });
        return;
      }
    } 

    const payload = {
      ...form,
      construction_method: form.construction_method || null,
      structure_parking: form.structure_parking || null,
      structure_ground: form.structure_ground || null,
      structure_standard: form.structure_standard || null,
      total_area_py: toNullableNumber(form.total_area_py),
      avg_area_py: toNullableNumber(form.avg_area_py),
      duration_months: toNullableNumber(form.duration_months),
      floors_above: toNullableNumber(form.floors_above),
      floors_below: toNullableNumber(form.floors_below),
      households: toNullableNumber(form.households),
      slope_type: form.slope_type || null,
      building_count: toNullableNumber(form.building_count),
      site_area: toNullableNumber(form.site_area),
      is_coastal: form.is_coastal === "1",
      total_cost: toNullableNumber(form.total_cost),
      building_cost: toNullableNumber(form.building_cost),
      civil_cost: toNullableNumber(form.civil_cost),
      electrical_cost: toNullableNumber(form.electrical_cost),
      facility_cost: toNullableNumber(form.facility_cost),
      opex_cost: toNullableNumber(form.opex_cost),
      etc_cost: toNullableNumber(form.etc_cost),
      common_cost: toNullableNumber(form.common_cost),
      rock_ratio: toNullableNumber(form.rock_ratio),
      received_date: form.received_date || null,
    }

    try {
      setCreateLoading(true)
      await createTraindata(payload)
      toast({ status: "success", title: "학습 데이터가 추가되었습니다." })
      onCreateClose()
      setForm({
        type: "",
        project_name: "",
        region: "",
        district: "",
        round_label: "",
        manager: "",
        received_date: "",
        total_area_py: "",
        finish_level: "",
        household_window: "",
        structure_parking: "",
        structure_ground: "",
        structure_standard: "",
        construction_method: "",
        avg_area_py: "",
        duration_months: "",
        floors_above: "",
        floors_below: "",
        rock_ratio: "",
        heating: "",
        external_work: "",
        households: "",
        total_cost: "",
        building_cost: "",
        civil_cost: "",
        electrical_cost: "",
        facility_cost: "",
        opex_cost: "",
        etc_cost: "",
        common_cost: "",
        note: "",
        slope_type: "",
        building_count: "",
        site_area: "",
        is_coastal: "0",
      })
      setPage(1)
      loadRows()
    } catch (e) {
      console.error(e)
      toast({
        status: "error",
        title: "추가 실패",
        description: getFriendlyErrorMessage(e),
      })
    } finally {
      setCreateLoading(false)
    }
  }

  // ===== 삭제 확인 다이얼로그 =====
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose
  } = useDisclosure()
  const cancelRef = useRef()

  // 로그 상세 모달
  const {
    isOpen: isLogOpen,
    onOpen: onLogOpen,
    onClose: onLogClose
  } = useDisclosure();

  const openLogModal = async (runId) => {
    setSelectedLog(runId);
    await loadLogDetail(runId);
    onLogOpen();
  };

  const deleteSelected = async () => {
    if (selectedIds.size === 0) return
    setDeleteLoading(true)
    try {
      for (const id of selectedIds) {
        await deleteTraindata(id)
      }
      toast({ status: "success", title: `${selectedIds.size}건 삭제 완료` })
      clearSelection()
      await loadRows()
    } catch (e) {
      console.error(e)
      toast({
        status: "error",
        title: "삭제 실패",
        description: getFriendlyErrorMessage(e),
      })
    } finally {
      setDeleteLoading(false)
      onDeleteClose()
    }
  }

  /** ======= 카드(모바일)용 학습 데이터 ======= */
/** ======= 카드(모바일)용 학습 데이터 ======= */
const TrainingDataCard = ({ r, index, isAdmin, onDetail }) => {
  const admin = !!isAdmin;
  const selected = isSelected(r.id);
  const prefersReducedMotion = usePrefersReducedMotion();
  const hasTrained = r.last_trained_run_id != null;
  const trainingBadgeBg = hasTrained ? "green.500" : "orange.200";
  const trainingBadgeColor = hasTrained ? "white" : "black";
  const completionLabel = formatDateTimeLabel(r.last_trained_run_finished_at);

  const variants = prefersReducedMotion
    ? { hidden: { opacity: 0 }, show: { opacity: 1, transition: { duration: 0.2 } } }
    : {
        hidden: { opacity: 0, y: 24, filter: "blur(2px)" },
        show: {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          transition: {
            duration: 0.5,
            delay: Math.min(index * 0.05, 0.35),
            ease: [0.22, 1, 0.36, 1],
          },
        },
      };

  return (
    <motion.div
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{
        duration: 0.45,
        delay: Math.min((index ?? 0) * 0.06, 0.4),
        ease: [0.22, 1, 0.36, 1],
      }}
      style={{ willChange: "transform, opacity" }}
    >
      <Box
        key={r.id}
        bg="white"
        border="1px solid"
        borderColor={border}
        rounded="2xl"                         // 👉 더 둥근 모서리
        overflow="hidden"
        shadow="md"                           // 👉 기본 그림자 강화
        _hover={{ shadow: "lg", transform: "translateY(-2px)" }}
        transition="all 0.2s"
        display="flex"
        flexDirection="column"
        minH={{ base: "360px", md: "420px" }} // 👉 모바일에서 높이 조금 줄임
        cursor="pointer"
        role="button"
        tabIndex={0}
        onClick={() => onDetail?.(r)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onDetail?.(r);
          }
        }}
      >
        {/* ===== 썸네일 ===== */}
        <Box position="relative">
          {selected && (
          <Badge
            position="absolute"
            top={14}
            right={2}
            colorScheme="blue"
            rounded="full"
            zIndex={1}
            px={3}
            py={1}
          >
              선택됨
            </Badge>
          )}
          {/* {r.thumbnail || r.image_url ? (
            <AspectRatio ratio={16 / 9}>
              <Image
                src={r.thumbnail || r.image_url}
                alt={r.project_name || "thumbnail"}
                objectFit="cover"
              />
            </AspectRatio>
          ) : (
            renderTypeThumb(r.type, r.project_name)
          )} */}
        </Box>

        {/* ===== 본문 ===== */}
        <Box p={4} flex="1" display="flex" flexDirection="column">
          {/* 헤더: 번호 + 타입 + 토글 */}
          <Flex justify="space-between" align="center" mb={3}>
            <HStack spacing={2}>
              {admin && (
                <Checkbox
                  isChecked={selected}
                  onChange={(e) => {
                    e.stopPropagation();
                    toggleSelect(r.id);
                  }}
                  colorScheme="blue"
                />
              )}
              <Text fontWeight="bold" color="blue.600" fontSize="md">
                #{r.id}
              </Text>
              <Badge colorScheme={getTypeBadgeColor(r.type)} variant="subtle" rounded="full">
                {r.type || "-"}
              </Badge>
              <Badge
                bg={trainingBadgeBg}
                color={trainingBadgeColor}
                fontWeight="bold"
                rounded="full"
                px={3}
                py={1}
              >
                {hasTrained ? "학습완료" : "학습필요"}
              </Badge>
            </HStack>
          </Flex>

          {/* 프로젝트명 */}
          <Tooltip
            label={r.project_name}
            hasArrow
            openDelay={300}
            placement="top"
            maxW="sm"
          >
            <Text
              fontWeight="extrabold"
              fontSize="lg"
              lineHeight={1.3}
              noOfLines={2}
              mb={2}
              whiteSpace="normal"
              wordBreak="break-word"
              sx={{ overflowWrap: "anywhere" }}
            >
              {r.project_name || "-"}
            </Text>
          </Tooltip>

          <SimpleGrid columns={2} spacing={2} mt={1} mb={1}>
            <Box>
              <Text fontSize="xs" color="gray.500">지역</Text>
              <Text fontSize="sm" color="gray.800">{r.region || "-"}</Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500">구</Text>
              <Text fontSize="sm" color="gray.800">{r.district || "-"}</Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500">연면적(평)</Text>
              <Text fontSize="sm" color="gray.800"><Num v={r.total_area_py} /></Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500">세대</Text>
              <Text fontSize="sm" color="gray.800"><Num v={r.households} /></Text>
            </Box>
          </SimpleGrid>

          {/* 접수일 */}
          <Text color="blue.600" fontSize="sm" fontWeight="medium" mb={2}>
            {r.received_date ? `${r.received_date} 접수` : "접수일 미정"}
          </Text>

          {/* ===== 액션 버튼 ===== */}
          <SimpleGrid pt={3} columns={admin ? 2 : 1} spacing={2} mt="auto">
            {admin && (
              <Button
                leftIcon={<CheckIcon />}
                variant={selected ? "solid" : "outline"}
                colorScheme="blue"
                size="md"
                h="44px"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleSelect(r.id);
                }}
              >
                {selected ? "선택 해제" : "선택"}
              </Button>
            )}
            {admin && (
              <Button
                leftIcon={<EditIcon />}
                colorScheme="blue"
                size="md"
                h="44px"
                onClick={(e) => {
                  e.stopPropagation();
                  openEditModal(r, "train");
                }}
              >
                수정
              </Button>
            )}
          </SimpleGrid>
        </Box>
      </Box>
    </motion.div>
  );
};


  /** ======= 로그 카드 ======= */
 /** ======= 로그 카드(모바일) : 확장/접기 제거, 돋보기 아이콘으로 상세 모달 오픈 ======= */
const LogCard = ({ r }) => (
  <Box
    bg={cardBg}
    border="1px solid"
    borderColor={border}
    rounded="xl"
    p={4}
    shadow="sm"
    _hover={{ shadow: "md" }}
    transition="all 0.2s"
  >
    <Flex justify="space-between" align="start" mb={2}>
      <HStack spacing={3}>
        <Text fontWeight="bold" color="blue.600" fontSize="lg">#{r.id}</Text>
        {statusBadge(r.status)}
      </HStack>

      <Button
        leftIcon={<SearchIcon />}
        size="sm"
        colorScheme="blue"
        variant="ghost"
        onClick={() => openLogModal(r.id)}
      >
        상세보기
      </Button>
    </Flex>
    <VStack align="start" spacing={2} w="full">
      {/* 공사 비용 */}
      <VStack align="start" spacing={1}>
        <Badge colorScheme="blue" variant="subtle" rounded="full" px={2}>
          학습 타겟
        </Badge>
        <Text
          fontSize={{ base: "xs", md: "sm" }}
          color="blue.600"
          fontWeight="semibold"
          whiteSpace="pre-wrap"
          wordBreak="break-word"
        >
          {Array.isArray(r.targets)
            ? r.targets.map((t) => (t === "기타비율" ? "기타비" : t)).join(", ")
            : "-"}
        </Text>
      </VStack>

      {/* 시작 시간 */}
      <HStack spacing={2}>
        <Badge colorScheme="green" variant="subtle" rounded="full" px={2}>
          시작
        </Badge>
        <Text fontSize={{ base: "xs", md: "sm" }} color="gray.600" noOfLines={1}>
          {r.started_at ?? "-"}
        </Text>
      </HStack>

      {/* 완료 시간 */}
      <HStack spacing={2}>
        <Badge colorScheme="purple" variant="subtle" rounded="full" px={2}>
          완료
        </Badge>
        <Text fontSize={{ base: "xs", md: "sm" }} color="gray.600" noOfLines={1}>
          {r.finished_at ?? "-"}
        </Text>
      </HStack>
    </VStack>
  </Box>
);

  return (
    <Box minH="100vh" bg="white">
      {/* HERO */}
      <Box w="100%">
        <AspectRatio ratio={{ base: 2.2, sm: 4, md: 5 }} w="100%">
          <Box position="relative" w="100%" h="100%">
            <Image
              src="/training.png"
              alt="데이터 관리 배너"
              w="100%"
              h="100%"
              objectFit="cover"
              draggable={false}
              userSelect="none"
            />

            <Box
              position="absolute"
              inset={0}
              bg={{
                base: "linear-gradient(90deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.22) 60%, rgba(0,0,0,0.12) 100%)",
                sm:   "linear-gradient(90deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0.10) 100%)",
              }}
            />

            <Container
              maxW="7xl"
              position="absolute"
              inset={0}
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              px={{ base: 4, sm: 6, md: 8 }}
            >
              <Flex w="full" h="full" align="center">
                <VStack
                  spacing={{ base: 2, md: 3 }}
                  align="flex-start"
                  maxW={{ base: "92%", md: "50%" }}
                  color="white"
                >
                  <HStack spacing={2} align="center">
                    <Heading
                      as="h1"
                      fontWeight="800"
                      letterSpacing="-0.01em"
                      lineHeight="1.1"
                      fontSize={{ base: "2xl", sm: "3xl", md: "4xl", lg: "5xl" }}
                    >
                      학습 관리
                    </Heading>

                    {/* {isMobile && (
                      <Tooltip
                        isOpen={tip.isOpen}
                        onClose={tip.onClose}
                        label="예측에 필요한 학습 데이터를 관리하고 모델 성능을 모니터링합니다."
                        fontSize="xs"
                        hasArrow
                        placement="top"
                        bg="blackAlpha.800"
                        color="white"
                        p={2}
                        rounded="md"
                        maxW="350px"
                        whiteSpace="nowrap"
                        closeOnScroll
                      >
                        <IconButton
                          aria-label="설명 보기"
                          icon={<InfoIcon />}
                          variant="ghost"
                          size="xs"
                          color="whiteAlpha.900"
                          onClick={tip.onToggle}
                          onTouchStart={tip.onToggle}
                          onBlur={tip.onClose}
                          _hover={{ bg: "whiteAlpha.200" }}
                          boxSize={6}
                          minW={6}
                          minH={6}
                          fontSize="18px"
                        />
                      </Tooltip>
                    )} */}
                  </HStack>

                  {!isMobile && (
                    <Text
                      fontSize={{ sm: "sm", md: "sm" }}
                      lineHeight={{ sm: "1.6", md: "1.6" }}
                      opacity={0.95}
                    >
                      예측에 필요한 학습 데이터를 관리하고 모델 성능을 모니터링합니다.
                    </Text>
                  )}
                </VStack>
              </Flex>
            </Container>
          </Box>
        </AspectRatio>
      </Box>


      {/* BODY */}
      <Container maxW="7xl" py={12} px={{ base: 4, md: 8 }}>
        <VStack spacing={0} align="stretch">
          {/* <Box textAlign="center" mb={8}>
            <Heading size="lg" color="gray.700" mb={4}>관리 메뉴</Heading>
            <Text color="gray.500" fontSize="md">원하는 기능을 선택하여 시작하세요.</Text>
          </Box> */}
          <AnimatePresence initial={false} mode="wait" custom={slideDir}>
            {activeSection === null && (
              <motion.div
                key="route-menu"
                custom={navDir}
                initial={{ x: navDir === 'forward' ? 0 : '-100%', opacity: 1 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: navDir === 'forward' ? '-100%' : '100%', opacity: 0 }}
                transition={{ duration: 0.28, ease: 'easeInOut' }}
                style={{ width: '100%' }}
              >
              <SimpleGrid columns={{ base: 1, md: isAdmin ? 3 : 2 }} spacing={8} pb={{ base: "120px", md: "140px" }}>
                <Box
                  bg="linear-gradient(135deg, #4299e1 0%, #3182ce 100%)"
                  rounded="3xl"
                  p={8}
                  shadow="2xl"
                  cursor="pointer"
                  transform="scale(1)"
                  _hover={{ transform: "scale(1.02) translateY(-4px)", shadow: "3xl" }}
                  transition="all 0.3s ease"
                  onClick={() => {
                    setNavDir(activeSection === "training" ? 'back' : 'forward');
                    setActiveSection(activeSection === "training" ? null : "training");
                  }}
                  position="relative"
                  overflow="hidden"
                >
                  <Box position="absolute" top="-50%" right="-50%" w="200%" h="200%" bg="rgba(255, 255, 255, 0.1)" rounded="full" transform="rotate(45deg)" />
                  <VStack spacing={4} align="start" position="relative" zIndex={1}>
                    <Box fontSize="4xl">📊</Box>
                    <Heading size="lg" color="white" fontWeight="bold">데이터 관리</Heading>
                    <Text color="white" opacity={0.9} fontSize="md" lineHeight="1.6">
                      학습에 사용되는 데이터를 조회하고 편집할 수 있습니다. 총 {total.toLocaleString()}건의 데이터가 등록되어 있습니다.
                    </Text>
                    <HStack spacing={2} mt={4}>
                      <Badge colorScheme="whiteAlpha" variant="solid" rounded="full" px={3}>학습 및 예측 데이터 편집</Badge>
                      <Badge colorScheme="whiteAlpha" variant="solid" rounded="full" px={3}>모델 학습</Badge>
                    </HStack>
                  </VStack>
                </Box>

                <Box
                  bg="linear-gradient(135deg, #805ad5 0%, #6b46c1 100%)"
                  rounded="3xl"
                  p={8}
                  shadow="2xl"
                  cursor="pointer"
                  transform="scale(1)"
                  _hover={{ transform: "scale(1.02) translateY(-4px)", shadow: "3xl" }}
                  transition="all 0.3s ease"
                  onClick={() => {
                    setNavDir(activeSection === "logs" ? 'back' : 'forward');
                    setActiveSection(activeSection === "logs" ? null : "logs");
                  }}
                  position="relative"
                  overflow="hidden"
                >
                  <Box position="absolute" top="-50%" right="-50%" w="200%" h="200%" bg="rgba(255, 255, 255, 0.1)" rounded="full" transform="rotate(45deg)" />
                  <VStack spacing={4} align="start" position="relative" zIndex={1}>
                    <Box fontSize="4xl">📈</Box>
                    <Heading size="lg" color="white" fontWeight="bold">실행 기록</Heading>
                    <Text color="white" opacity={0.9} fontSize="md" lineHeight="1.6">
                      모델 학습 과정과 결과를 확인할 수 있습니다. 성능 지표와 실행 상태를 모니터링하세요.
                    </Text>
                    <HStack spacing={2} mt={4}>
                      <Badge colorScheme="whiteAlpha" variant="solid" rounded="full" px={3}>학습 실행 기록</Badge>
                      <Badge colorScheme="whiteAlpha" variant="solid" rounded="full" px={3}>학습 성능 지표</Badge>
                    </HStack>
                  </VStack>
                </Box>
                {isAdmin && (
                <Box
                  bg="linear-gradient(135deg, #f97316 0%, #ef4444 100%)"
                  rounded="3xl"
                  p={8}
                  shadow="2xl"
                  cursor="pointer"
                  transform="scale(1)"
                  _hover={{ transform: "scale(1.02) translateY(-4px)", shadow: "3xl" }}
                  transition="all 0.3s ease"
                  onClick={() => {
                    setNavDir(activeSection === "requests" ? "back" : "forward")
                    setActiveSection(activeSection === "requests" ? null : "requests")
                  }}
                  position="relative"
                  overflow="hidden"
                >
                  <Box
                    position="absolute"
                    top="-50%"
                    right="-50%"
                    w="200%"
                    h="200%"
                    bg="rgba(255, 255, 255, 0.1)"
                    rounded="full"
                    transform="rotate(45deg)"
                  />
                  <VStack spacing={4} align="start" position="relative" zIndex={1}>
                    <Box fontSize="4xl">📬</Box>
                    <Heading size="lg" color="white" fontWeight="bold">
                      {isSuperAdmin ? "학습 요청 관리" : "내 학습 요청 현황"}
                    </Heading>
                    <Text color="white" opacity="0.9" fontSize="md" lineHeight="1.6">
                      {isSuperAdmin
                        ? "추가된 신규 데이터를 기반으로 요청을 승인하거나 반려하고 실시간 현황을 모니터링합니다."
                        : "내가 요청한 학습 현황과 신규 데이터를 편리하게 확인할 수 있습니다."}
                    </Text>
                    {isSuperAdmin ? (
                      <HStack spacing={2} mt={4}>
                        <Badge colorScheme="whiteAlpha" variant="solid" rounded="full" px={3}>
                          승인 & 실행
                        </Badge>
                        <Badge colorScheme="whiteAlpha" variant="solid" rounded="full" px={3}>
                          반려 & 안내
                        </Badge>
                      </HStack>
                    ) : (
                      <HStack spacing={6} mt={4} w="100%" justify="space-between">
                        {personalRequestHighlights.map((item) => (
                          <VStack key={item.label} spacing={0} align="start">
                            <Text fontSize="xs" color="whiteAlpha.700">
                              {item.label}
                            </Text>
                            <Text fontSize="2xl" fontWeight="bold" color="white">
                              {myRequestsLoading ? "…" : item.value.toLocaleString() + "건"}
                            </Text>
                            <Text fontSize="xs" color="whiteAlpha.700">
                              {item.helper}
                            </Text>
                          </VStack>
                        ))}
                      </HStack>
                    )}
                  </VStack>
                </Box>
                )}
              </SimpleGrid>
            </motion.div>
          )}
          </AnimatePresence>
          {/* TRAINING SECTION */}
          <Collapse in={activeSection === "training"}>
            {/* 검색/필터 바 – 앱 스타일 카드 + 칩 유형 (전체 포함) */}
            <Box
              position="sticky"
              top={{ base: "0px", md: "0px" }} 
              zIndex={20}
              mb={6}
              bg="transparent"
            >
            {/* 추가: 뒤로가기 버튼 */}
            <SectionBackButton
              onClick={() => {
                setNavDir("back");
                setActiveSection(null);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
              <Box
                p={{ base: 3, md: 4 }}
                bg="white"
                border="1px solid"
                borderColor={border}
                rounded="2xl"
                shadow="sm"
              >
                {/* 카드 헤더 */}
                <HStack justify="space-between" align="center" mb={3}>
                  <HStack spacing={2}>
                    {/* <SearchIcon />
                    <Text fontWeight="700" fontSize={{ base: "md", md: "lg" }}>검색</Text> */}
                  </HStack>
                  <Badge
                    rounded="full"
                    px={3}
                    py={1}
                    colorScheme="blue"
                    variant="subtle"
                    display={{ base: "none", md: "inline-flex" }}
                  >
                    실시간 필터
                  </Badge>
                </HStack>

                {/* 아이콘 + 밑줄형 인풋 (스크린샷 스타일) */}
                <Flex
                  flexDirection={{ base: "column", md: "row" }}
                  alignItems="center"
                  gap={3}
                  pb={2}
                  borderBottom="1px solid"
                  borderColor="gray.300"
                >
                  <HStack
                    spacing={3}
                    flex={1}
                    order={{ base: 2, md: 1 }}
                    width="100%"
                    _focusWithin={{ borderColor: "blue.400" }}
                  >
                    <SearchIcon color="gray.500" />
                    <Input
                      flex={1}
                      variant="unstyled"
                      placeholder="검색어를 입력하세요"
                      value={query.keyword}
                      onChange={(e) => {
                        setQuery((q) => ({ ...q, keyword: e.target.value }))
                        setPage(1)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setPage(1)
                          loadRows()
                        }
                      }}
                    />
                  </HStack>
                  <HStack
                    spacing={2}
                    order={{ base: 1, md: 2 }}
                    alignItems="center"
                    width={{ base: "100%", md: "auto" }}
                    justifyContent="flex-end"
                  >
                    <Text fontSize="sm" color="gray.600" whiteSpace="nowrap">
                      학습 상태
                    </Text>
                    <Select
                      size="sm"
                      w="140px"
                      value={trainingStatusFilter}
                      onChange={(e) => setTrainingStatusFilter(e.target.value)}
                    >
                      <option value="all">전체</option>
                      <option value="trained">학습완료</option>
                      <option value="untrained">학습필요</option>
                    </Select>
                  </HStack>
                </Flex>

                {/* 유형 칩 (전체 포함) – 더보기 토글 */}
                <Wrap spacing={2} mt={5} align="center" minH="60px" py={2}>
                  {["전체", ...Object.keys(TYPE_THUMBS)]
                    .slice(0, showAll ? undefined : VISIBLE_COUNT)
                    .map((label) => {
                      const active =
                        label === "전체"
                          ? selectedTypeFilters.length === 0
                          : selectedTypeFilters.includes(label);
                      return (
                        <WrapItem key={label} h="40px">
                          <Button
                            size="md"
                            variant="ghost"
                            rounded="full"
                            px={4}
                            h="40px"
                            leftIcon={label !== "전체" ? <Text as="span">{TYPE_THUMBS[label]?.emoji}</Text> : undefined}
                            border="1px solid"
                            borderColor={active ? "blue.300" : "gray.200"}
                            bg={active ? "blue.50" : "white"}
                            color={active ? "blue.700" : "gray.700"}
                            _hover={{ transform: "translateY(-1px)", shadow: "sm" }}
                            onClick={() => {
                              if (label === "전체") {
                                setSelectedTypeFilters([])
                                setQuery((q) => ({ ...q, type: "" }))
                              } else {
                                setSelectedTypeFilters((prev) => {
                                  const next = prev.includes(label)
                                    ? prev.filter((item) => item !== label)
                                    : [...prev, label]
                                  setQuery((q) => ({
                                    ...q,
                                    type: next[next.length - 1] || "",
                                  }))
                                  return next
                                })
                              }
                              setPage(1)
                            }}
                          >
                            <Text noOfLines={1}>{label}</Text>
                          </Button>
                        </WrapItem>
                      );
                    })}

                  {/* 더보기/접기 토글 버튼 */}
                  {Object.keys(TYPE_THUMBS).length > VISIBLE_COUNT && (
                    <WrapItem>
                      <Button
                        size="sm"
                        variant="outline"
                        rounded="full"
                        px={3}
                        h="32px"
                        onClick={() => setShowAll(prev => !prev)}
                      >
                        {showAll ? "접기" : "더보기"}
                      </Button>
                    </WrapItem>
                  )}
                </Wrap>

                {/* 필요하면 초기화 버튼 유지 */}
                <HStack spacing={3} mt={3} justify="flex-end">
                  <Button
                    size="sm"
                    variant="outline"
                    rounded="full"
                    onClick={() => { setQuery({ type: "", region: "", district: "", keyword: "" }); setPage(1); loadRows(); }}
                  >
                    초기화
                  </Button>
                </HStack>
              </Box>
            </Box>


            <Box
              ref={trainingRef}
              bg="white"
              shadow="2xl"
              rounded="3xl"
              p={{ base: 6, md: 10 }}
              border="1px solid"
              borderColor={border}
              mt={8}
              animation="slideInUp 0.5s ease-out"
              sx={{
                "@keyframes slideInUp": {
                  "0%": { opacity: 0, transform: "translateY(30px)" },
                  "100%": { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <Flex justify="space-between" align="center" mb={6} gap={4} wrap="wrap" direction={{ base: "column", md: "row" }}>
                <HStack>
                 
                  <VStack align={{ base: "center", md: "start" }} spacing={1}>
                    <Heading size={{ base: "lg", md: "xl" }} color="gray.700">📊 데이터 관리</Heading>
                    <Text color="gray.500" fontSize="md">총 {total.toLocaleString()}건의 데이터</Text>
                  </VStack>
                </HStack>
                {/* <VStack align={{ base: "center", md: "start" }} spacing={1}>
                  <Heading size={{ base: "lg", md: "xl" }} color="gray.700">📊 학습 데이터 관리</Heading>
                  <Text color="gray.500" fontSize="md">총 {total.toLocaleString()}건의 데이터</Text>
                </VStack> */}
                {(isAdmin || isSuperAdmin) && (
                <HStack spacing={3} w={{ base: "full", md: "auto" }} justify={{ base: "stretch", md: "flex-end" }}>
                  {isAdmin && (
                  <Button
                    leftIcon={<EditIcon />}
                    colorScheme="blue"
                    size={{ base: "md", md: "lg" }}
                    onClick={onCreateOpen}
                    shadow="md"
                    _hover={{ transform: "translateY(-2px)", shadow: "lg" }}
                    transition="all 0.2s"
                    w={{ base: "full", md: "auto" }}
                    rounded="xl"
                  >
                    데이터 추가
                  </Button>
                  )}
                  <Button
                    leftIcon={<RepeatIcon />}
                    colorScheme="blue"
                    size={{ base: "md", md: "lg" }}
                    onClick={onTrainConfirmOpen}
                    isLoading={requestLoading}
                    shadow="md"
                    _hover={{ transform: "translateY(-2px)", shadow: "lg" }}
                    transition="all 0.2s"
                    w={{ base: "full", md: "auto" }}
                    rounded="xl"
                  >
                    학습 요청
                  </Button>
                </HStack>
                )}
              </Flex>

              
              {/*  선택 툴바 */}
              {isAdmin && (
                <Flex
                  align="center"
                  justify="space-between"
                  mb={3}
                  p={3}
                  bg={softBg}
                  border="1px solid"
                  borderColor={border}
                  rounded="xl"
                  wrap="wrap"
                  gap={3}
                >
                  <Text fontSize="sm" color="gray.600">
                    선택됨: <b>{selectedIds.size}</b>건
                  </Text>
                  <HStack>
                    <Button size="sm" variant="outline" onClick={clearSelection} isDisabled={selectedIds.size === 0}>
                      선택 해제
                    </Button>
                    <Button size="sm" colorScheme="red" onClick={onDeleteOpen} isDisabled={selectedIds.size === 0}>
                      선택 삭제
                    </Button>
                  </HStack>
                </Flex>
              )}
              {/* TABLE */}
              {isMobile ? (
                <VStack spacing={4} align="stretch">
                  {fetching && (
                    <Box textAlign="center" py={8}>
                      <VStack spacing={3}>
                        <Spinner size="lg" color="blue.500" />
                        <Text color="gray.500">데이터를 불러오는 중...</Text>
                      </VStack>
                    </Box>
                  )}
                  {!fetching && filteredRows.length === 0 && (
                    <Box textAlign="center" py={8}>
                      <Text color="gray.500" fontSize="lg">📭 데이터가 없습니다.</Text>
                    </Box>
                  )}
                  {filteredRows.map((r, index) => (
                    <TrainingDataCard
                      key={r.id}
                      r={r}
                      index={index}
                      isAdmin={isAdmin}
                      onDetail={() => handleOpenTrainingDetailModal(r)}
                    />
                  ))}
                </VStack>
              ) : (
                <Box border="2px solid" borderColor={border} rounded="2xl" overflow="hidden" shadow="sm">
                  <Box overflowX="auto" overflowY="auto" maxH={{ base: "75vh", md: "calc(500vh - 320px)" }}>
                    {/* ===== GALLERY VIEW (Table 대체) ===== */}
                    <Box>
                      {/* 로딩 상태 */}
                      {fetching && (
                        <Flex py={12} align="center" justify="center" bg="white" rounded="lg">
                          <VStack spacing={3}>
                            <Spinner size="lg" color="blue.500" />
                            <Text color="gray.500">데이터를 불러오는 중...</Text>
                          </VStack>
                        </Flex>
                      )}

                      {/* 빈 상태 */}
                      {!fetching && filteredRows.length === 0 && (
                        <Flex py={12} align="center" justify="center" bg="white" rounded="lg">
                          <Text color="gray.500" fontSize="lg">📭 데이터가 없습니다.</Text>
                        </Flex>
                      )}

                      {/* 갤러리 그리드 */}
                      {!fetching && filteredRows.length > 0 && (
                        <SimpleGrid
                          columns={{ base: 1, sm: 2, md: 2, lg: 3, xl: 4 }}
                          spacing={4}
                        >
                          {filteredRows.map((r) => {
                            const selected = isSelected(r.id);
                            const costDetails = getCostDetails(r);
                            const hasTrained = r.last_trained_run_id != null;
                            const trainingBadgeBg = hasTrained ? "green.500" : "orange.200";
                            const trainingBadgeColor = hasTrained ? "white" : "black";
                            const completionLabel = formatDateTimeLabel(r.last_trained_run_finished_at);
                            return (
                              <Box
                                  key={r.id}
                                  bg="white"
                                  border="1px solid"
                                  borderColor={selected ? "blue.400" : tableBg}
                                  boxShadow={selected ? "0 0 0 3px rgba(66,153,225,0.35)" : "sm"}
                                  _hover={{ bg: tableHoverBg, transform: "translateY(-2px)" }}
                                  transition="all 0.15s ease"
                                  rounded="xl"
                                  overflow="hidden"
                                  display="flex"
                                  flexDirection="column"
                                  cursor="pointer"                      
                                  role="button"                         
                                  tabIndex={0}                          
                                  onClick={(e) => {
                                    if (isSelectingText()) return;
                                    handleOpenTrainingDetailModal(r);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                      e.preventDefault();
                                      handleOpenTrainingDetailModal(r);
                                    }
                                  }}
                                >
                                {/* ─────────────────────────────────────────
                                    데스크탑: 토글 전환 (앞/뒤 중 하나만 렌더)
                                    ───────────────────────────────────────── */}
                                <Box display={{ base: "none", md: "block" }}>
                                  {/* inline 상세 뷰는 모달로 이전되어 해당 코드는 주석 처리됨 */}
                                  <VStack align="stretch" spacing={0}>
                                    <Box position="relative">
                                      {selected && (
                                        <Badge
                                          position="absolute"
                                          top={6}
                                          right={2}
                                          colorScheme="blue"
                                          rounded="full"
                                          zIndex={1}
                                          px={3}
                                          py={1}
                                        >
                                          선택됨
                                        </Badge>
                                      )}
                                    </Box>
                                    <VStack align="stretch" spacing={2} p={4}>
                                      <HStack spacing={3}>
                                        <Badge colorScheme={getTypeBadgeColor(r.type)} variant="subtle" rounded="full">
                                          {r.type || "-"}
                                        </Badge>
                                        <Text fontSize="sm" color="blue.600" fontWeight="semibold">
                                          #{r.id}
                                        </Text>
                                        {/* <Badge
                                          bg={trainingBadgeBg}
                                          color={trainingBadgeColor}
                                          fontWeight="bold"
                                          rounded="full"
                                          px={3}
                                          py={1}
                                        >
                                          {hasTrained ? "학습완료" : "학습필요"}
                                        </Badge> */}
                                      </HStack>
                                      <Tooltip
                                        label={r.project_name}
                                        hasArrow
                                        openDelay={300}
                                        placement="top"
                                        maxW="sm"
                                      >
                                        <Text
                                          fontWeight="semibold"
                                          fontSize={getTitleFontSize(r.project_name)}
                                          lineHeight="1"
                                          noOfLines={1}
                                          h="1em"
                                          whiteSpace="normal"
                                          wordBreak="break-word"
                                          sx={{ overflowWrap: "anywhere" }}
                                        >
                                          {r.project_name || "-"}
                                        </Text>
                                      </Tooltip>
                                      <SimpleGrid columns={2} spacing={2} mt={1}>
                                        <Box>
                                          <Text fontSize="xs" color="gray.500">지역</Text>
                                          <Text fontSize="sm" color="gray.800">{r.region || "-"}</Text>
                                        </Box>
                                        <Box>
                                          <Text fontSize="xs" color="gray.500">구</Text>
                                          <Text fontSize="sm" color="gray.800">{r.district || "-"}</Text>
                                        </Box>
                                        <Box>
                                          <Text fontSize="xs" color="gray.500">연면적(평)</Text>
                                          <Text fontSize="sm" color="gray.800"><Num v={r.total_area_py} /></Text>
                                        </Box>
                                        <Box>
                                          <Text fontSize="xs" color="gray.500">세대</Text>
                                          <Text fontSize="sm" color="gray.800"><Num v={r.households} /></Text>
                                        </Box>
                                        <Box>
                                          <VStack align="flex-start" spacing={1}>
                                            <Text fontSize="xs" color="gray.500">접수일</Text>
                                            <Text fontSize="sm" color="gray.700">{r.received_date || "-"}</Text>
                                          </VStack>
                                        </Box>
                                        <Box>
                                          <VStack align="flex-start" spacing={1}>
                                            <Text fontSize="xs" color="gray.500">학습상태</Text>
                                            <Badge
                                              bg={trainingBadgeBg}
                                              color={trainingBadgeColor}
                                              fontWeight="bold"
                                              rounded="full"
                                              px={3}
                                              py={1}
                                            >
                                              {hasTrained ? "학습완료" : "학습필요"}
                                            </Badge>
                                          </VStack>
                                        </Box>
                                        <Box gridColumn="1 / span 2">
                                          <VStack align="flex-start" spacing={0}>
                                            <Text fontSize="xs" color="gray.500">학습일시</Text>
                                            <Text fontSize="sm" color="gray.700">{completionLabel}</Text>
                                          </VStack>
                                        </Box>
                                      </SimpleGrid>
                                      <Text fontSize="xs" color="gray.500" mt={2}>
                                        카드를 눌러 상세 정보를 확인하세요.
                                      </Text>
                                    </VStack>
                                  </VStack>
                                </Box>

                                {/* ─────────────────────────────────────────
                                    모바일: 기존 Collapse 유지
                                    ───────────────────────────────────────── */}
                                <Box display={{ base: "block", md: "none" }}>
                                  {/* 상단 썸네일 */}
                                  <Box position="relative">
                                    {selected && (
                                      <Badge
                                        position="absolute"
                                        top={2}
                                        right={2}
                                        colorScheme="blue"
                                        rounded="full"
                                        zIndex={1}
                                      >
                                        선택됨
                                      </Badge>
                                    )}

                                    {/* {r.thumbnail || r.image_url ? (
                                      <AspectRatio ratio={16 / 9}>
                                        <Image
                                          src={r.thumbnail || r.image_url}
                                          alt={r.project_name || "thumbnail"}
                                          objectFit="cover"
                                        />
                                      </AspectRatio>
                                    ) : (
                                      renderTypeThumb(r.type, r.project_name)
                                    )} */}
                                  </Box>

                                  {/* 카드 본문 */}
                                  <VStack align="stretch" spacing={2} p={4}>
                                    {/* 헤더: 유형/ID + 토글 */}
                                    <Flex align="center" mb={2}>
                                        <HStack spacing={3}>
                                          <Badge colorScheme={getTypeBadgeColor(r.type)} variant="subtle" rounded="full">
                                            {r.type || "-"}
                                          </Badge>
                                          <Text fontSize="sm" color="blue.600" fontWeight="semibold">
                                            #{r.id}
                                          </Text>
                                          <Badge
                                            bg={trainingBadgeBg}
                                            color={trainingBadgeColor}
                                            fontWeight="bold"
                                            rounded="full"
                                            px={3}
                                            py={1}
                                          >
                                            {hasTrained ? "학습완료" : "학습필요"}
                                          </Badge>
                                        </HStack>
                                    </Flex>

                                    {/* 프로젝트명 */}
                                    <Tooltip
                                      label={r.project_name}
                                      hasArrow
                                      openDelay={300}
                                      placement="top"
                                      maxW="sm"
                                    >
                                      <Text
                                        fontWeight="semibold"
                                        fontSize={getTitleFontSize(r.project_name)}
                                        lineHeight="1"
                                        noOfLines={1}
                                        h="1em"
                                        whiteSpace="normal"
                                        wordBreak="break-word"
                                        sx={{ overflowWrap: "anywhere" }}
                                      >
                                        {r.project_name || "-"}
                                      </Text>
                                    </Tooltip>

                                    {/* 기본 정보 */}
                                    <SimpleGrid columns={2} spacing={2} mt={1}>
                                      <Box>
                                        <Text fontSize="xs" color="gray.500">지역</Text>
                                        <Text fontSize="sm" color="gray.800">{r.region || "-"}</Text>
                                      </Box>
                                      <Box>
                                        <Text fontSize="xs" color="gray.500">구</Text>
                                        <Text fontSize="sm" color="gray.800">{r.district || "-"}</Text>
                                      </Box>
                                      <Box>
                                        <Text fontSize="xs" color="gray.500">연면적(평)</Text>
                                        <Text fontSize="sm" color="gray.800"><Num v={r.total_area_py} /></Text>
                                      </Box>
                                      <Box>
                                        <Text fontSize="xs" color="gray.500">세대</Text>
                                        <Text fontSize="sm" color="gray.800"><Num v={r.households} /></Text>
                                      </Box>
                                      <Box>
                                        <VStack align="flex-start" spacing={1}>
                                          <Text fontSize="xs" color="gray.500">접수일</Text>
                                          <Text fontSize="sm" color="gray.800">{r.received_date || "-"}</Text>
                                          <Text fontSize="xs" color="gray.500" mt={1}>학습일시</Text>
                                          <Text fontSize="sm" color="gray.700">{completionLabel}</Text>
                                        </VStack>
                                      </Box>
                                      <Box>
                                        <VStack align="flex-start" spacing={1}>
                                          <Text fontSize="xs" color="gray.500">학습상태</Text>
                                          <Badge
                                            bg={trainingBadgeBg}
                                            color={trainingBadgeColor}
                                            fontWeight="bold"
                                            rounded="full"
                                            px={3}
                                            py={1}
                                          >
                                            {hasTrained ? "학습완료" : "학습필요"}
                                          </Badge>
                                        </VStack>
                                      </Box>
                                    </SimpleGrid>

            {/* 상세 뷰는 모달로 이동했습니다. 상세 정보를 보려면 카드를 눌러주세요. */}
          </VStack>
        </Box>

                                {/* 액션: 선택 / 수정 (분리 버튼) */}
                                <SimpleGrid pt={2} px={4} pb={4} columns={isAdmin ? 2 : 1} spacing={2}>
                                  {isAdmin && (
                                    <Button
                                      leftIcon={<CheckIcon />}
                                      variant={selected ? "solid" : "outline"}
                                      colorScheme="blue"
                                      size="sm"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleSelect(r.id);
                                      }}
                                    >
                                      {selected ? "해제" : "선택"}
                                    </Button>
                                  )}
                                  {isAdmin && (
                                    <Button
                                      leftIcon={<EditIcon />}
                                      colorScheme="blue"
                                      size="sm"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openEditModal(r, "train");
                                      }}
                                    >
                                      수정
                                    </Button>
                                  )}
                                </SimpleGrid>
                              </Box>
                            );
                          })}
                        </SimpleGrid>
                      )}
                    </Box>
                  </Box>
                </Box>

              )}

              {/* pagination */}
              <Flex
                justify="space-between"
                align="center"
                mt={6}
                wrap="wrap"
                gap={4}
                p={4}
                bg={tableBg}
                rounded="xl"
              >
                <Text fontSize="sm" color={mutedColor} fontWeight="500">
                  총 {total.toLocaleString()}건의 데이터
                </Text>
                <HStack spacing={3}>
                  <Button
                    size={paginationButtonSize}
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    isDisabled={page === 1}
                    variant="outline"
                    borderColor={border}
                    color={paginationTextColor}
                    borderRadius="md"
                  >
                    이전
                  </Button>
                  <Box
                    fontSize="sm"
                    minW="100px"
                    textAlign="center"
                    fontWeight="600"
                    color="black.600"
                    px={3}
                    py={1}
                    bg="white"
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    {page} / {totalPages}
                  </Box>
                  <Button
                    size={paginationButtonSize}
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    isDisabled={page >= totalPages}
                    variant="outline"
                    borderColor={border}
                    color={paginationTextColor}
                    borderRadius="md"
                  >
                    다음
                  </Button>
                </HStack>
              </Flex>
              {/* === 데이터 추가 모달 === */}
              <Modal
                isOpen={isCreateOpen}
                onClose={handleCreateCloseWithReset}
                size={isMobile ? "full" : "4xl"}
                scrollBehavior="inside"
                isCentered
                blockScrollOnMount={true}
                trapFocus={true}
                motionPreset="slideInBottom"
              >
                <ModalOverlay />
                <ModalContent
                  maxH="100vh"
                  display="flex"
                  flexDirection="column"
                  h={isMobile ? "100vh" : "auto"}
                  sx={{ overscrollBehaviorY: "contain" }}
                >
                  <ModalHeader>
                    {addMode === "upload"
                      ? "파일로 한번에 올리기"
                      : addMode === "predict"
                        ? "예측에서 데이터 추가하기"
                        : "학습 데이터 추가"}
                  </ModalHeader>
                  <ModalBody
                    flex="1"
                    minH={0}
                    maxH={{ base: "calc(100vh - 140px)", md: "80vh" }}
                    overflowY="auto"
                    sx={{ overscrollBehaviorY: "contain" }}
                    onWheel={(e) => { e.stopPropagation(); }}
                    onTouchMove={(e) => { e.stopPropagation(); }}
                  >
                    {!addMode && (
                      <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        spacing={6}
                        mb={4}
                        justifyItems="center"
                        w="100%"
                        maxW="840px"
                        mx="auto"
                      >
                        {[
                          {
                            mode: "predict",
                            title: "예측에서 데이터 추가하기😃",
                            description: "기존 예측값을 활용해 주요 필드를 채우고 검증된 한 행을 추가합니다.",
                            icon: FiFilePlus,
                            buttonLabel: "추가하기",
                            buttonColor: "blue",
                          },
                          {
                            mode: "upload",
                            title: "파일로 한번에 올리기🚀",
                            description: "CSV를 기반으로 학습 데이터를 대량 등록할 수 있는 업로드 화면입니다.",
                            icon: FiUpload,
                            buttonLabel: "업로드하기",
                            buttonColor: "teal",
                          },
                        ].map((card) => (
                          <Box
                            key={card.mode}
                            role="button"
                            w={{ base: "min(90vw, 420px)", md: "420px" }}
                            p={5}
                            borderRadius="2xl"
                            cursor="pointer"
                            onClick={() => setAddMode(card.mode)}
                            border="1px solid"
                            borderColor={border}
                            bg="white"
                            boxShadow="md"
                            _hover={{
                              transform: "translateY(-3px)",
                              shadow: "lg",
                            }}
                            transition="all 0.2s"
                            position="relative"
                          >
                            <Flex align="center" justify="space-between" mb={3}>
                              <Box>
                                <Text fontSize="xs" color="gray.500" textTransform="uppercase" letterSpacing="wide">
                                  {card.mode === "predict" ? "추천" : "업로드"}
                                </Text>
                                <Heading size="md" mt={1}>
                                  {card.title}
                                </Heading>
                              </Box>
                              <Circle size="48px" bg={`${card.buttonColor}.100`}>
                                <Icon as={card.icon} boxSize={6} color={`${card.buttonColor}.600`} />
                              </Circle>
                            </Flex>
                            <Text fontSize="sm" color="gray.600" mb={4} noOfLines={3}>
                              {card.description}
                            </Text>
                            <Button
                              mt="auto"
                              size="sm"
                              variant="solid"
                              colorScheme={card.buttonColor}
                              onClick={(e) => {
                                e.stopPropagation();
                                setAddMode(card.mode);
                              }}
                            >
                              {card.buttonLabel}
                            </Button>
                          </Box>
                        ))}
                      </SimpleGrid>
                    )}
                    {addMode && (
                      <Flex justify="space-between" align="center" mb={4}>
                        <Button variant="ghost" onClick={() => setAddMode(null)}>
                          ← 이전
                        </Button>
                        <Text fontSize="sm" color="gray.500">
                          {addMode === "upload" ? "CSV 업로드로 다량 등록" : "예측에서 항목을 검색하여 추가"}
                        </Text>
                      </Flex>
                    )}
                    {addMode === "upload" && (
                  <Box mb={5} p={4} border="1px solid" borderColor={border} rounded="lg" bg={softBg}>
                    <VStack align="stretch" spacing={4}>
                      <Box
                        {...getRootProps()}
                        border="2px dashed"
                        borderColor={isDragActive ? "teal.400" : "gray.200"}
                        rounded="xl"
                        bg={isDragActive ? "teal.50" : "gray.50"}
                        cursor="pointer"
                        textAlign="center"
                        px={4}
                        py={6}
                      >
                        <input {...getInputProps()} />
                        <Text fontWeight="600">CSV 파일을 드래그하거나 클릭하여 업로드</Text>
                        <Text fontSize="sm" color="gray.500">
                          최대 {formatFileSize(UPLOAD_MAX_BYTES)} · UTF-8 인코딩 권장
                        </Text>
                      </Box>
                      <HStack justify="flex-end">
                        <Button
                          variant="ghost"
                          size="sm"
                          leftIcon={<DownloadIcon />}
                          onClick={handleDownloadTemplate}
                          isLoading={templateDownloading}
                        >
                          파일 양식 받기
                        </Button>
                      </HStack>
                      {selectedFile && (
                        <HStack spacing={2} justify="space-between">
                          <Text fontWeight="600">{selectedFile.name}</Text>
                          <Text fontSize="sm" color="gray.500">
                            {formatFileSize(selectedFile.size)}
                          </Text>
                        </HStack>
                      )}
                      {parsingError && (
                        <Text fontSize="sm" color="red.500">
                          {parsingError}
                        </Text>
                      )}
                      {previewHeaders.length > 0 && (
                        <Box>
                          <Text fontWeight="600" mb={2}>
                            헤더 미리보기
                          </Text>
                          <Wrap spacing={2}>
                            {previewHeaders.slice(0, HEADER_CHIP_LIMIT).map((header) => (
                              <WrapItem key={header}>
                                <Tag size="sm" variant="solid" colorScheme="blue">
                                  <TagLabel>{header}</TagLabel>
                                </Tag>
                              </WrapItem>
                            ))}
                            {previewHeaders.length > HEADER_CHIP_LIMIT && (
                              <WrapItem>
                                <Tag size="sm" variant="outline">
                                  +{previewHeaders.length - HEADER_CHIP_LIMIT}
                                </Tag>
                              </WrapItem>
                            )}
                          </Wrap>
                        </Box>
                      )}
                      {previewRows.length > 0 && (
                        <Box
                          border="1px solid"
                          borderColor="gray.200"
                          rounded="lg"
                          overflowX="auto"
                          bg="white"
                          maxH="280px"
                          overflowY="auto"
                        >
                          <Table size="sm">
                            <Thead bg="gray.100">
                              <Tr>
                                {previewHeaders.map((header) => (
                                  <Th key={header}>{header}</Th>
                                ))}
                              </Tr>
                            </Thead>
                            <Tbody>
                              {previewRows.map((row, index) => (
                                <Tr key={`preview-${index}`}>
                                  {previewHeaders.map((header) => (
                                    <Td key={`${header}-${index}`} maxW="160px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                                      {row?.[header] ?? "-"}
                                    </Td>
                                  ))}
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                          <Box px={3} py={2} fontSize="xs" color="gray.500">
                            상위 {previewRows.length.toLocaleString()}개 행만 미리보기로 표시됩니다.
                          </Box>
                        </Box>
                      )}
                      <Text fontSize="sm" color="gray.600">
                        먼저 <strong>검증하기</strong> 버튼을 눌러 데이터 검증을 진행하고, 오류가 없을 때만 업로드 버튼이 활성화됩니다.
                      </Text>
                      {uploading && (
                        <Box>
                          <Progress size="sm" colorScheme="teal" isIndeterminate />
                          <Text fontSize="sm" color="gray.500" mt={2}>
                            업로드 및 처리 중입니다...
                          </Text>
                        </Box>
                      )}
                      {resultToDisplay && (
                        <Box>
                          <Flex justify="space-between" align="center" mb={2}>
                            <Text fontWeight="600">{resultLabel ?? "처리 결과"}</Text>
                            {resultToDisplay.dryRun && (
                              <Badge colorScheme="green" variant="subtle">
                                검증 완료
                              </Badge>
                            )}
                          </Flex>
                          <SimpleGrid columns={{ base: 2, md: 5 }} spacing={3}>
                            <Stat p={3} border="1px solid" borderColor="gray.200" rounded="md">
                              <StatLabel>총 rows</StatLabel>
                              <StatNumber>{formatNumber(resultToDisplay.totalRows)}</StatNumber>
                            </Stat>
                            <Stat p={3} border="1px solid" borderColor="gray.200" rounded="md">
                              <StatLabel>삽입 rows</StatLabel>
                              <StatNumber>{formatNumber(resultToDisplay.insertedRows)}</StatNumber>
                            </Stat>
                            <Stat p={3} border="1px solid" borderColor="gray.200" rounded="md">
                              <StatLabel>업데이트 rows</StatLabel>
                              <StatNumber>{formatNumber(resultToDisplay.updatedRows ?? 0)}</StatNumber>
                            </Stat>
                            <Stat p={3} border="1px solid" borderColor="gray.200" rounded="md">
                              <StatLabel>스킵 rows</StatLabel>
                              <StatNumber>{formatNumber(resultToDisplay.skippedRows)}</StatNumber>
                            </Stat>
                            <Stat p={3} border="1px solid" borderColor="gray.200" rounded="md">
                              <StatLabel>실패 rows</StatLabel>
                              <StatNumber>{formatNumber(resultToDisplay.failedRows)}</StatNumber>
                            </Stat>
                          </SimpleGrid>
                          {resultToDisplay.errors?.length > 0 && (
                            <Box mt={4} p={3} border="1px solid" borderColor="red.100" bg="red.50" rounded="lg">
                              <Flex justify="space-between" align="center" mb={2}>
                                <Text fontWeight="600">오류 rows ({resultToDisplay.errors.length.toLocaleString()}건)</Text>
                                <Button size="xs" variant="outline" onClick={downloadErrorCsv}>
                                  오류 CSV 다운로드
                                </Button>
                              </Flex>
                              <List spacing={2}>
                                {resultToDisplay.errors.slice(0, 5).map((err) => (
                                  <ListItem key={`${err.rowNumber}-${err.message}`}>
                                    <Text fontSize="sm" fontWeight="semibold">
                                      Row {err.rowNumber}: {err.message}
                                    </Text>
                                    {err.row && (
                                      <Text fontSize="xs" color="gray.600">
                                        {Object.entries(err.row)
                                          .slice(0, 3)
                                          .map(([key, value]) => `${key}: ${value}`)
                                          .join("  ·  ")}
                                        {Object.keys(err.row || {}).length > 3 && " …"}
                                      </Text>
                                    )}
                                  </ListItem>
                                ))}
                                {resultToDisplay.errors.length > 5 && (
                                  <Text fontSize="xs" color="gray.600">
                                    외 {resultToDisplay.errors.length - 5}건
                                  </Text>
                                )}
                              </List>
                            </Box>
                          )}
                        </Box>
                      )}
                      <HStack spacing={3} w="100%">
                        <Button
                          colorScheme="blue"
                          onClick={handleValidate}
                          isLoading={isValidating}
                          isDisabled={!selectedFile || isValidating || uploading || Boolean(parsingError)}
                          w={{ base: "100%", md: "unset" }}
                          flex={1}
                        >
                          검증하기
                        </Button>
                        <Button
                          colorScheme="teal"
                          onClick={uploadInfoDisclosure.onOpen}
                          isLoading={uploading}
                          isDisabled={
                            !selectedFile ||
                            uploading ||
                            Boolean(parsingError) ||
                            !validationPassed
                          }
                          w={{ base: "100%", md: "unset" }}
                          flex={1}
                        >
                          업로드 실행
                        </Button>
                      </HStack>
                      <AlertDialog
                        isOpen={uploadInfoDisclosure.isOpen}
                        leastDestructiveRef={uploadInfoCancelRef}
                        onClose={uploadInfoDisclosure.onClose}
                        isCentered
                      >
                        <AlertDialogOverlay />
                        <AlertDialogContent>
                          <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            업로드 안내
                          </AlertDialogHeader>
                          <AlertDialogBody>
                            <VStack align="stretch" spacing={3}>
                              <Text>
                                동일한 프로젝트명은 기존 행을 덮어쓰는 방식으로 업데이트하고, 새로운 프로젝트명은 새로운 행으로 삽입됩니다.
                              </Text>
                              <Text>
                                완전 일치하는 내용(암반비율, 비용 등)이 이미 존재하면 자동으로 스킵됩니다.
                              </Text>
                              <Text color="gray.600" fontSize="sm">
                                예) rock_ratio는 '%'·',' 없이 숫자만 입력, is_coastal는 1/0 또는 true/false/Y/N으로 표시하세요.
                              </Text>
                            </VStack>
                          </AlertDialogBody>
                          <AlertDialogFooter>
                            <Button ref={uploadInfoCancelRef} onClick={uploadInfoDisclosure.onClose}>
                              취소
                            </Button>
                            <Button
                              colorScheme="teal"
                              onClick={handleUploadConfirm}
                              isLoading={uploading}
                              isDisabled={!selectedFile || uploading || Boolean(parsingError)}
                              ml={3}
                            >
                              안내 확인 및 업로드
                            </Button>
                          </AlertDialogFooter>
                        </AlertDialogContent>
                      </AlertDialog>
                    </VStack>
                  </Box>
                    )}
                    {addMode === "predict" && (
                      <>
                    <Box mb={5} p={4} border="1px solid" borderColor={border} rounded="lg" bg={softBg}>
                      <Heading size="sm" color="gray.700" mb={3}>예측에서 불러오기 (선택)</Heading>
                      <Box as="form" onSubmit={(e) => { e.preventDefault(); loadPreds(); }} w="100%" mb={3}>
                        <Stack direction={{ base: "column", md: "row" }} spacing={{ base: 2, md: 3 }} align={{ base: "stretch", md: "center" }} justify="space-between" w="100%">
                          <Stack direction={{ base: "column", md: "row" }} spacing={{ base: 2, md: 3 }} flex="1" minW={0}>
                            <Input
                              size="sm"
                              placeholder="run_id"
                              value={predSearch.run_id}
                              onChange={(e) => setPredSearch((s) => ({ ...s, run_id: e.target.value }))}
                              w={{ base: "100%", md: "140px" }}
                              bg="white"
                              flexShrink={0}
                            />
                            <Input
                              size="sm"
                              placeholder="프로젝트명 검색"
                              value={predSearch.q}
                              onChange={(e) => setPredSearch((s) => ({ ...s, q: e.target.value }))}
                              w={{ base: "100%", md: "260px" }}
                              bg="white"
                              minW={0}
                            />
                          </Stack>
                          <Button
                            size="sm"
                            onClick={() => loadPreds(1)}
                            isLoading={predLoading}
                            leftIcon={<SearchIcon />}
                            w={{ base: "100%", md: "auto" }}
                            flexShrink={0}
                          >
                            검색
                          </Button>
                        </Stack>
                      </Box>

                      {/* 예측 결과 목록 */}
                      {isMobile ? (
                        <Box>
                          <VStack align="stretch" spacing={3}>
                            {predLoading && (<Box py={6} textAlign="center"><Spinner /></Box>)}
                            {!predLoading && predList.length === 0 && (
                              <Box py={6} textAlign="center" color="gray.500">검색 결과가 없습니다.</Box>
                            )}
                            {!predLoading && predList.map((p, i) => (
                              <PredictionCardMobile key={p.id || i} p={p} onApply={applyPrediction} onOpenEdit={openEditModal} isAdmin={isAdmin} />
                            ))}
                            <HStack justify="space-between" align="center" pt={2}>
                              <Button size="sm" variant="outline" onClick={() => loadPreds(Math.max(1, predPage - 1))} isDisabled={predPage <= 1}>이전</Button>
                              <Text fontSize="xs" color="gray.600">{predPage} / {Math.max(1, Math.ceil((predTotal||0)/predPageSize))}</Text>
                              <Button size="sm" variant="outline" onClick={() => loadPreds(Math.min(Math.max(1, Math.ceil((predTotal||0)/predPageSize)), predPage + 1))} isDisabled={predPage >= Math.max(1, Math.ceil((predTotal||0)/predPageSize))}>다음</Button>
                            </HStack>
                          </VStack>
                          <Box px={1} py={2} fontSize="xs" color="gray.500" mt={2}>
                            총 {predTotal}건
                            <Text as="span" ml={2}>
                              <br/> * 필드는 채워지지만, <b>공사비, 건축비 등 8개 비용은 직접 입력</b> 후 저장됩니다.
                            </Text>
                          </Box>
                        </Box>
                      ) : (
                        <Box border="1px solid" borderColor={border} rounded="md" overflow="hidden" bg="white">
                          <Box maxH="240px" overflowY="auto">
                            <Table size="sm">
                              <Thead bg="gray.100">
                                <Tr>
                                  <Th>#</Th>
                                  <Th>프로젝트</Th>
                                  <Th>유형</Th>
                                  <Th isNumeric>연면적(평)</Th>
                                  <Th>층수(지상/지하)</Th>
                                  <Th isNumeric>세대</Th>
                                  <Th>불러오기</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {predLoading && (
                                  <Tr><Td colSpan={7} py={6} textAlign="center"><Spinner /></Td></Tr>
                                )}
                                {!predLoading && predList.length === 0 && (
                                  <Tr><Td colSpan={7} py={6} textAlign="center" color="gray.500">검색 결과가 없습니다.</Td></Tr>
                                )}
                                {predList.map((p, i) => (
                                  <Tr key={p.id || i} _hover={{ bg: predRowHover }}>
                                    <Td>{p.id}</Td>
                                    <Td maxW="260px" whiteSpace="normal">
                                      <Button
                                        variant="link"
                                        colorScheme="blue"
                                        onClick={() => openEditModal(p, "pred")}
                                        p={0}
                                        h="auto"
                                        justifyContent="flex-start"
                                        display="inline-block"
                                        textAlign="left"
                                        sx={{
                                          textDecoration: "underline",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",   // 단어 기준 줄바꿈
                                          overflowWrap: "anywhere",  // 긴 문자열 강제 줄바꿈
                                          lineHeight: "1.35",
                                        }}
                                      >
                                        {p.project_name}
                                      </Button>
                                    </Td>
                                    <Td>{p.type}</Td>
                                    <Td isNumeric><Num v={p.area_pyeong} /></Td>
                                    <Td>{p.floor_above ?? "-"} / {p.floor_below ?? "-"}</Td>
                                    <Td isNumeric><Num v={p.households} /></Td>
                                    <Td>
                                      <Button size="xs" colorScheme="blue" onClick={() => applyPrediction(p)}>
                                        적용
                                      </Button>
                                    </Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          </Box>
                          <HStack justify="space-between" align="center" pt={2} px={3}>
                            <Button size="sm" variant="outline" onClick={() => loadPreds(Math.max(1, predPage - 1))} isDisabled={predPage <= 1}>이전</Button>
                            <Text fontSize="xs" color="gray.600">{predPage} / {Math.max(1, Math.ceil((predTotal||0)/predPageSize))}</Text>
                            <Button size="sm" variant="outline" onClick={() => loadPreds(Math.min(Math.max(1, Math.ceil((predTotal||0)/predPageSize)), predPage + 1))} isDisabled={predPage >= Math.max(1, Math.ceil((predTotal||0)/predPageSize))}>다음</Button>
                          </HStack>
                          <Box px={3} py={2} fontSize="xs" color="gray.500">
                            총 {predTotal}건
                            <Text as="span" ml={2}>* 필드는 채워지지만, <span style={{ color: '#E53E3E' }}>각 세부 비용은 직접 입력</span> 후 저장됩니다.</Text>
                          </Box>
                        </Box>
                      )}
                    </Box>

                    {/* 입력 폼 */}
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <FormControl>
                        <FormLabel>유형 *</FormLabel>
                        <ChakraSelect
                          placeholder="선택"
                          value={form.type}
                          onChange={(e) => handleFormTypeChange(e.target.value)}
                        >
                          <option value="아파트">아파트</option>
                          <option value="오피스텔">오피스텔</option>
                          <option value="주상복합">주상복합</option>
                          <option value="도시형생활주택">도시형생활주택</option>
                          <option value="문화시설">문화시설</option>
                          <option value="물류센터">물류센터</option>
                          <option value="생활형숙박시설">생활형숙박시설</option>
                          <option value="업무시설">업무시설</option>
                          <option value="지식산업센터">지식산업센터</option>
                          <option value="테라스">테라스</option>
                        </ChakraSelect>
                      </FormControl>

                      <FormControl>
                        <FormLabel>프로젝트명 *</FormLabel>
                        <Input value={form.project_name} onChange={(e) => setField("project_name", e.target.value)} />
                      </FormControl>

                      <FormControl>
                        <FormLabel>지역</FormLabel>
                        <Input value={form.region} onChange={(e) => setField("region", e.target.value)} />
                      </FormControl>
                      <FormControl>
                        <FormLabel>구/군</FormLabel>
                        <Input value={form.district} onChange={(e) => setField("district", e.target.value)} />
                      </FormControl>
                      <FormControl>
                        <FormLabel>회차 라벨</FormLabel>
                        <Input value={form.round_label} onChange={(e) => setField("round_label", e.target.value)} />
                      </FormControl>
                      <FormControl>
                        <FormLabel>담당자</FormLabel>
                        <Input value={form.manager} onChange={(e) => setField("manager", e.target.value)} />
                      </FormControl>
                      <FormControl>
                        <FormLabel>접수일</FormLabel>
                        <Input type="date" value={form.received_date} onChange={(e) => setField("received_date", e.target.value)} />
                      </FormControl>

                      <FormControl>
                        <FormLabel>연면적(평)</FormLabel>
                        <NumberInput value={form.total_area_py} onChange={(v) => setField("total_area_py", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>마감수준</FormLabel>
                        <ChakraSelect
                          placeholder="선택하세요"
                          value={form.finish_level}
                          onChange={(e) => setField("finish_level", e.target.value)}
                        >
                          {finishLevelOptions.map((opt) => (
                            <option key={opt} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </ChakraSelect>
                      </FormControl>
                      <FormControl>
                        <FormLabel>세대 창호</FormLabel>
                        <ChakraSelect
                          placeholder="선택하세요"
                          value={form.household_window}
                          onChange={(e) => setField("household_window", e.target.value)}
                        >
                          {householdWindowOptions.map((opt) => (
                            <option key={opt} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </ChakraSelect>
                      </FormControl>
                      {renderStructureInputs({ values: form, onChange: setField, typeValue: form.type })}
                      <FormControl>
                        <FormLabel>지하공법</FormLabel>
                        <ChakraSelect
                          placeholder="선택하세요"
                          value={form.construction_method}
                          onChange={(e) => setField("construction_method", e.target.value)}
                        >
                          {["순타","역타"].map((o) => (
                            <option key={o} value={o}>
                              {o}
                            </option>
                          ))}
                        </ChakraSelect>
                      </FormControl>
                      <FormControl>
                        <FormLabel>평균평형</FormLabel>
                        <NumberInput value={form.avg_area_py} onChange={(v) => setField("avg_area_py", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>공기(개월)</FormLabel>
                        <NumberInput value={form.duration_months} onChange={(v) => setField("duration_months", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>지상층수</FormLabel>
                        <NumberInput value={form.floors_above} onChange={(v) => setField("floors_above", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>지하층수</FormLabel>
                        <NumberInput value={form.floors_below} onChange={(v) => setField("floors_below", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>암반비율</FormLabel>
                        <NumberInput value={form.rock_ratio} onChange={(v) => setField("rock_ratio", v)}>
                          <NumberInputField placeholder="예: 15 (15%)" />
                        </NumberInput>
                        <Text fontSize="xs" color="gray.500" mt={1}>
                          풍화암 기준으로 입력하세요.
                        </Text>
                      </FormControl>
                      <FormControl>
                        <FormLabel>대지 조건</FormLabel>
                        <ChakraSelect
                          placeholder="선택하세요"
                          value={form.slope_type}
                          onChange={(e) => setField("slope_type", e.target.value)}
                        >
                          {Object.entries(SLOPE_OPTION_LABELS).map(([value, label]) => (
                            <option key={value} value={value}>
                              {label}
                            </option>
                          ))}
                        </ChakraSelect>
                      </FormControl>
                      <FormControl>
                        <FormLabel>동수</FormLabel>
                        <NumberInput value={form.building_count} onChange={(v) => setField("building_count", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>대지면적(㎡)</FormLabel>
                        <NumberInput value={form.site_area} onChange={(v) => setField("site_area", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>수변 여부</FormLabel>
                        <RadioGroup value={form.is_coastal} onChange={(v) => setField("is_coastal", v)}>
                          <HStack spacing={4}>
                            <Radio value="1">예</Radio>
                            <Radio value="0">아니오</Radio>
                          </HStack>
                        </RadioGroup>
                      </FormControl>
                      <FormControl>
                        <FormLabel>난방</FormLabel>
                        <ChakraSelect
                          placeholder="선택하세요"
                          value={form.heating}
                          onChange={(e) => setField("heating", e.target.value)}
                        >
                          {["개별","중앙","지역"].map((o) => (
                            <option key={o} value={o}>
                              {o}
                            </option>
                          ))}
                        </ChakraSelect>
                      </FormControl>
                      <FormControl>
                        <FormLabel>단지외공사</FormLabel>
                        <ChakraSelect
                          placeholder="선택하세요"
                          value={form.external_work}
                          onChange={(e) => setField("external_work", e.target.value)}
                        >
                          {["제외","포함"].map((o) => (
                            <option key={o} value={o}>
                              {o}
                            </option>
                          ))}
                        </ChakraSelect>
                      </FormControl>
                      <FormControl>
                        <FormLabel>세대수</FormLabel>
                        <NumberInput value={form.households} onChange={(v) => setField("households", v)}>
                          <NumberInputField />
                        </NumberInput>
                      </FormControl>

                      {/* 비용 입력 */}
                      <FormControl>
                        <FormLabel>공사비</FormLabel>
                        <NumberInput value={form.total_cost} onChange={(v) => setField("total_cost", v)}>
                          <NumberInputField placeholder="예: 12000" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>건축비</FormLabel>
                        <NumberInput value={form.building_cost} onChange={(v) => setField("building_cost", v)}>
                          <NumberInputField placeholder="예: 8000000" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>토목</FormLabel>
                        <NumberInput value={form.civil_cost} onChange={(v) => setField("civil_cost", v)}>
                          <NumberInputField placeholder="예: 1000" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>전기</FormLabel>
                        <NumberInput value={form.electrical_cost} onChange={(v) => setField("electrical_cost", v)}>
                          <NumberInputField placeholder="예: 800" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>설비</FormLabel>
                        <NumberInput value={form.facility_cost} onChange={(v) => setField("facility_cost", v)}>
                          <NumberInputField placeholder="예: 900" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>경상비</FormLabel>
                        <NumberInput value={form.opex_cost} onChange={(v) => setField("opex_cost", v)}>
                          <NumberInputField placeholder="예: 300" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>기타</FormLabel>
                        <NumberInput value={form.etc_cost} onChange={(v) => setField("etc_cost", v)}>
                          <NumberInputField placeholder="예: 120" />
                        </NumberInput>
                      </FormControl>
                      <FormControl>
                        <FormLabel>공통</FormLabel>
                        <NumberInput value={form.common_cost} onChange={(v) => setField("common_cost", v)}>
                          <NumberInputField placeholder="예: 500" />
                        </NumberInput>
                      </FormControl>
                    </SimpleGrid>

                    <FormControl mt={4}>
                      <FormLabel>비고</FormLabel>
                      <Textarea value={form.note} onChange={(e) => setField("note", e.target.value)} rows={4} />
                    </FormControl>
                      </>
                    )}
                  </ModalBody>

          <ModalFooter
            position={isMobile ? "relative" : "sticky"}
            bottom={isMobile ? undefined : 0}
            mt={isMobile ? "auto" : 0}
            bg="white"
            borderTop="1px solid"
            borderColor={border}
            zIndex={isMobile ? 1 : 1}
            h={modalFooterButtonHeight}
            minH={modalFooterButtonHeight}
            p={0}
            w="100%"
          >
            {addMode === "predict" ? (
              <HStack spacing={isMobile ? 2 : 3} w="100%" h="100%" align="stretch">
                <Button
                  variant="ghost"
                  onClick={handleCreateCloseWithReset}
                  size={modalFooterButtonSize}
                  h={modalFooterButtonHeight}
                  flex={1}
                  borderRadius={0}
                >
                  취소
                </Button>
                <Button
                  colorScheme="blue"
                  onClick={submitCreate}
                  isLoading={createLoading}
                  size={modalFooterButtonSize}
                  h={modalFooterButtonHeight}
                  flex={1}
                  borderRadius={0}
                >
                  저장
                </Button>
              </HStack>
            ) : (
              <Button
                variant="ghost"
                w="100%"
                h="100%"
                onClick={handleCreateCloseWithReset}
                borderRadius={0}
              >
                닫기
              </Button>
            )}
          </ModalFooter>
              </ModalContent>
            </Modal>
            <Modal
              isOpen={trainingDetailModal.isOpen}
              onClose={handleCloseTrainingDetailModal}
              size={isMobile ? "full" : "6xl"}
              isCentered={!isMobile}
              scrollBehavior="inside"
            >
              <ModalOverlay />
              <ModalContent
                maxW={{ base: "100vw", md: "1200px" }}
                minW={{ base: "100vw", md: "900px" }}
                minH={isMobile ? "100vh" : undefined}
                borderRadius={isMobile ? 0 : "2xl"}
                overflow="hidden"
              >
                <ModalHeader>
                  <Flex justify="space-between" align="center">
                    <Text fontWeight="600">학습 데이터 상세</Text>
                    <IconButton
                      aria-label="닫기"
                      icon={<CloseIcon />}
                      size="sm"
                      variant="ghost"
                      onClick={handleCloseTrainingDetailModal}
                    />
                  </Flex>
                </ModalHeader>
                <ModalBody
                  px={4}
                  py={3}
                  minH={0}
                  flex="1"
                  maxH={isMobile ? "calc(100vh - 88px)" : undefined}
                  display="flex"
                  flexDirection="column"
                  overflow="hidden"
                >
                  <Box
                    flex="1"
                    minH={0}
                    overflowY="auto"
                    sx={{ WebkitOverflowScrolling: "touch", overscrollBehavior: "contain" }}
                    pb={isMobile ? 10 : 6}
                    touchAction="auto"
                    onWheel={(e) => e.stopPropagation()}
                    onTouchMove={(e) => e.stopPropagation()}
                  >
                    {selectedTrainingRow ? (
                      <NewDataDetailCard
                        item={selectedTrainingRow}
                        borderColor={border}
                        bgColor={whiteBg}
                        collapseOnMobile={Boolean(isMobile)}
                      />
                    ) : (
                      <Text color="gray.500" textAlign="center" py={6}>
                        선택된 데이터가 없습니다.
                      </Text>
                    )}
                  </Box>
                </ModalBody>
                {!isMobile && (
                  <ModalFooter>
                    <Button onClick={handleCloseTrainingDetailModal}>닫기</Button>
                  </ModalFooter>
                )}
              </ModalContent>
            </Modal>
            <Modal
              isOpen={mobileRequestModal.isOpen && isMobile}
              onClose={mobileRequestModal.onClose}
              size="full"
              scrollBehavior="inside"
            >
              <ModalOverlay />
              <ModalContent
                maxH="100vh"
                display="flex"
                flexDirection="column"
              >
                <ModalHeader>
                  <Flex justify="space-between" align="center">
                    <Heading size="md">요청 상세</Heading>
                    <IconButton aria-label="닫기" icon={<CloseIcon />} variant="ghost" onClick={mobileRequestModal.onClose} />
                  </Flex>
                </ModalHeader>
                <ModalBody
                  px={4}
                  py={3}
                  overflowY="auto"
                  flex="1"
                  maxH="100vh"
                  minH={0}
                  sx={{ WebkitOverflowScrolling: "touch" }}
                >
                  <VStack align="stretch" spacing={6}>
                    <Box border="1px solid" borderColor={border} rounded="xl" p={4} bg={whiteBg}>
                      <Flex justify="space-between" align="center">
                        <VStack align="start" spacing={1}>
                          <Badge
                            colorScheme={STATUS_COLOR[selectedRequestDetail?.status] || "gray"}
                            variant="subtle"
                            rounded="full"
                          >
                            {STATUS_LABEL_KO[selectedRequestDetail?.status] ||
                              selectedRequestDetail?.status ||
                              "선택된 요청 없음"}
                          </Badge>
                          <Heading size="md">요청 상세</Heading>
                        </VStack>
                        <Text fontSize="sm" color="gray.500">
                          {selectedRequestDetail?.requestedAt
                            ? new Date(selectedRequestDetail.requestedAt).toLocaleString()
                            : "-"}
                        </Text>
                      </Flex>
                      {selectedRequestDetail ? (
                        <>
                          <Text fontSize="sm" color="gray.600">
                            요약: {selectedRequestDetail.summary || "없음"}
                          </Text>
                          <Wrap spacing={2} mt={2}>
                            {Object.entries(selectedRequestDetail.filter || {}).map(
                              ([key, value]) =>
                                value && (
                                  <WrapItem key={key}>
                                    <Badge variant="subtle" colorScheme="gray">
                                      {formatFilterLabel(key)}: {value}
                                    </Badge>
                                  </WrapItem>
                                )
                            )}
                          </Wrap>
                          <VStack align="stretch" spacing={2} mt={3}>
                            <Text fontSize="sm" color="gray.500">
                              현재 기준 신규 데이터: {Number(selectedRequestDetail.newDataCount || 0).toLocaleString()}건
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              최신 성공 run ID: {selectedRequestDetail.latestSucceededRunId || "없음"}
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              연결된 학습 run ID: {selectedRequestDetail.trainingRunId || "없음"}
                            </Text>
                          </VStack>
                          <HStack spacing={3} mt={4}>
                            <Button
                              flex={1}
                              colorScheme="blue"
                              onClick={runApproveConfirm.onOpen}
                              isDisabled={selectedRequestDetail.status !== "PENDING"}
                              isLoading={requestActionLoading}
                            >
                              학습하기
                            </Button>
                            <Button
                              flex={1}
                              colorScheme="red"
                              variant="outline"
                              onClick={() => {
                                setRejectReason("")
                                onRejectOpen()
                              }}
                              isDisabled={selectedRequestDetail.status !== "PENDING"}
                            >
                              반려
                            </Button>
                          </HStack>
                        </>
                      ) : (
                        <Text color="gray.500">요청을 선택해 상세 정보를 확인하세요.</Text>
                      )}
                    </Box>
                    <Box border="1px solid" borderColor={border} rounded="xl" p={4} bg={whiteBg}>
                      <Flex
                        justify="space-between"
                        align="center"
                        flexWrap="wrap"
                        gap={2}
                        mb={3}
                      >
                        <Heading size="sm">신규 데이터 목록</Heading>
                        <Text fontSize="xs" color="gray.500">
                          총 {Number(requestNewData.total || 0).toLocaleString()}건
                        </Text>
                      </Flex>
                      <VStack align="stretch" spacing={3}>
                        <InputGroup>
                          <InputLeftElement pointerEvents="none">
                            <SearchIcon color="gray.400" />
                          </InputLeftElement>
                          <Input
                            placeholder="프로젝트명 / 지역 검색"
                            size="sm"
                            background={whiteBg}
                            borderColor={border}
                            value={requestNewDataSearchInput}
                            onChange={(e) => setRequestNewDataSearchInput(e.target.value)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                handleRequestNewDataSearch()
                              }
                            }}
                            paddingLeft="32px"
                          />
                        </InputGroup>
                        <HStack spacing={2} flexWrap="wrap">
                          <Button
                            size="sm"
                            colorScheme="blue"
                            flex={{ base: 1, md: "initial" }}
                            minW={0}
                            onClick={handleRequestNewDataSearch}
                          >
                            검색
                          </Button>
                          <Button
                            size="sm"
                            variant="outline"
                            flex={{ base: 1, md: "initial" }}
                            minW={0}
                            onClick={handleRequestNewDataReset}
                          >
                            초기화
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            flex={{ base: 1, md: "initial" }}
                            minW={0}
                            onClick={handleOpenNewDataModal}
                            display={{ base: "none", md: "inline-flex" }}
                          >
                            전체 보기
                          </Button>
                        </HStack>
                        {requestNewDataLoading ? (
                          <Flex align="center" justify="center" py={6}>
                            <Spinner colorScheme="orange" />
                          </Flex>
                        ) : normalizedRequestNewDataItems.length === 0 ? (
                          <Flex align="center" justify="center" py={6}>
                            <Text color="gray.500">신규 데이터가 없습니다.</Text>
                          </Flex>
                        ) : (
                          <List spacing={0}>
                            {normalizedRequestNewDataItems.map((item, index) => {
                              const selected = selectedNewDataItem?.id === item.id
                              return (
                                <ListItem
                                  key={`mobile-${item.id}-${index}`}
                                  borderBottomWidth={
                                    index === normalizedRequestNewDataItems.length - 1 ? 0 : 1
                                  }
                                  borderColor={selected ? "blue.200" : border}
                                  px={2}
                                  py={3}
                                  bg={selected ? "blue.50" : "transparent"}
                                  cursor="pointer"
                                  onClick={() => handleSelectNewDataItem(item)}
                                >
                                  <Flex justify="space-between" align="flex-start" gap={3}>
                                    <VStack align="start" spacing={1}>
                                      <Text fontWeight="semibold" noOfLines={2}>
                                        {item.project_name || "프로젝트명 없음"}
                                      </Text>
                                      <HStack spacing={2}>
                                        <Badge variant="subtle" colorScheme="purple" rounded="full">
                                          {item.district || item.region || "지역 미정"}
                                        </Badge>
                                        <Text fontSize="xs" color="gray.500">
                                          ID {item.id}
                                        </Text>
                                      </HStack>
                                      <Text fontSize="xs" color="gray.500">
                                        접수일 {item.received_date || "-"}
                                      </Text>
                                    </VStack>
                                    <VStack align="flex-end" spacing={1}>
                                      <Text fontSize="xs" color="gray.500">
                                        총공사비
                                      </Text>
                                      <Text fontWeight="600">
                                        {item.total_cost
                                          ? `${Number(item.total_cost).toLocaleString()}원`
                                          : "-"}
                                      </Text>
                                    </VStack>
                                  </Flex>
                                </ListItem>
                              )
                            })}
                          </List>
                        )}
                        <Flex
                          align="center"
                          justify="space-between"
                          wrap="wrap"
                          gap={3}
                          p={3}
                          bg={tableBg}
                          borderRadius="xl"
                          border="1px solid"
                          borderColor={border}
                        >
                          <Text fontSize="sm" color={paginationTextColor} fontWeight="500">
                            총 {Number(requestNewData.total || 0).toLocaleString()}건
                          </Text>
                          <HStack spacing={2}>
                            <Button
                              size={paginationButtonSize}
                              variant="outline"
                              borderColor={border}
                              color={paginationTextColor}
                              borderRadius="md"
                              onClick={() => setRequestNewDataPage((prev) => Math.max(prev - 1, 1))}
                              isDisabled={requestNewDataPage === 1}
                            >
                              이전
                            </Button>
                            <Box
                              fontSize="sm"
                              minW="90px"
                              textAlign="center"
                              fontWeight="600"
                              color={paginationTextColor}
                              px={3}
                              py={1}
                              bg="white"
                              border="1px solid"
                              borderColor="gray.200"
                              borderRadius="md"
                            >
                              {requestNewDataPage} / {requestNewDataTotalPages}
                            </Box>
                            <Button
                              size={paginationButtonSize}
                              variant="outline"
                              borderColor={border}
                              color={paginationTextColor}
                              borderRadius="md"
                              onClick={() =>
                                setRequestNewDataPage((prev) =>
                                  prev < requestNewDataTotalPages ? prev + 1 : prev
                                )
                              }
                              isDisabled={requestNewDataPage >= requestNewDataTotalPages}
                            >
                              다음
                            </Button>
                          </HStack>
                        </Flex>
                    </VStack>
                  </Box>
                  </VStack>
                </ModalBody>
              </ModalContent>
            </Modal>

              {/* 삭제 확인 다이얼로그 */}
              <AlertDialog isOpen={isDeleteOpen} leastDestructiveRef={cancelRef} onClose={onDeleteClose}>
                <AlertDialogOverlay>
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">선택 항목 삭제</AlertDialogHeader>
                    <AlertDialogBody>
                      총 <b>{selectedIds.size}</b>건을 삭제합니다. 이 작업은 되돌릴 수 없습니다. 진행할까요?
                    </AlertDialogBody>
                    <AlertDialogFooter>
                      <Button ref={cancelRef} onClick={onDeleteClose} variant="ghost">취소</Button>
                      <Button colorScheme="red" onClick={deleteSelected} isLoading={deleteLoading} ml={3}>삭제</Button>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
            </Box>
          </Collapse>

          {isAdmin && (
            <Collapse in={activeSection === "requests"}>
              <SectionBackButton
                onClick={() => {
                  setNavDir("back")
                  setActiveSection(null)
                  window.scrollTo({ top: 0, behavior: "smooth" })
                }}
              />
              {isSuperAdmin ? (
                <Box
                  ref={requestsRef}
                  bg="white"
                  shadow="2xl"
                  rounded="3xl"
                  border="1px solid"
                  borderColor={border}
                  p={{ base: 6, md: 10 }}
                  mt={8}
                >
              <Flex align="center" justify="space-between" mb={6} flexWrap="wrap" gap={4}>
                <VStack align="start" spacing={1}>
                  <Heading size={{ base: "lg", md: "xl" }}>📝 학습 요청 관리</Heading>
                  <Text color="gray.500">새로운 데이터 요청을 승인하거나 반려하고, 실시간 요청 현황을 모니터링하세요.</Text>
                </VStack>
                <HStack spacing={3}>
                  <ChakraSelect
                    size="md"
                    value={requestStatusFilter}
                    onChange={(e) => setRequestStatusFilter(e.target.value)}
                  >
                    {REQUEST_STATUS_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </ChakraSelect>
                  <Button
                    variant="outline"
                    colorScheme="gray"
                    leftIcon={<RepeatIcon />}
                    onClick={loadTrainingRequests}
                    isLoading={requestsLoading}
                  >
                    새로고침
                  </Button>
                </HStack>
              </Flex>
              <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
                <Box
                  border="1px solid"
                  borderColor={border}
                  rounded="2xl"
                  overflow="hidden"
                  minH="320px"
                >
                  <Box
                    bg={softBg}
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor={border}
                  >
                    <Text fontWeight="600">요청 목록</Text>
                  </Box>
                  <Box maxH="360px" overflowY="auto">
                    {requestsLoading ? (
                      <Flex align="center" justify="center" py={12}>
                        <Spinner colorScheme="orange" />
                      </Flex>
                    ) : requests.length === 0 ? (
                      <Flex align="center" justify="center" py={16}>
                        <Text color="gray.500">요청이 없습니다.</Text>
                      </Flex>
                    ) : isMobile ? (
                          <VStack spacing={3} align="stretch" py={3} px={4}>
                        {requests.map((req) => {
                          const isSelected = req.id === selectedRequestId
                          return (
                            <Box
                              key={req.id}
                              cursor="pointer"
                              border="1px solid"
                              borderColor={isSelected ? "blue.300" : border}
                              rounded="xl"
                              p={3}
                              bg={isSelected ? "blue.50" : whiteBg}
                              onClick={() => {
                                setSelectedRequestId(req.id)
                                if (isMobile) mobileRequestModal.onOpen()
                              }}
                            >
                              <Flex justify="space-between" align="center" flexWrap="wrap" gap={2}>
                                <Text fontWeight="semibold">요청 #{req.id}</Text>
                                <Badge variant="subtle" colorScheme={STATUS_COLOR[req.status] || "gray"}>
                                  {STATUS_LABEL_KO[req.status] || req.status}
                                </Badge>
                              </Flex>
                              <Text fontSize="sm" color={mutedColor}>
                                요청자: {req.requestedBy?.name || "미정"}
                              </Text>
                              <Text fontSize="sm" color={mutedColor}>
                                신규 {Number(req.newDataCount || 0).toLocaleString()}건
                              </Text>
                            </Box>
                          )
                        })}
                      </VStack>
                    ) : (
                      <Table variant="simple" size="sm">
                        <Thead bg={tableHeaderBg}>
                          <Tr>
                            <Th>ID</Th>
                            <Th>요청자</Th>
                            <Th>상태</Th>
                            <Th isNumeric>신규</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {requests.map((req) => {
                            const isSelected = req.id === selectedRequestId
                            return (
                              <Tr
                                key={req.id}
                                cursor="pointer"
                                bg={isSelected ? "blue.50" : "transparent"}
                                onClick={() => setSelectedRequestId(req.id)}
                                _hover={{ bg: "blue.100" }}
                                transition="background 0.2s"
                              >
                                <Td>{req.id}</Td>
                                <Td>{req.requestedBy?.name || "미정"}</Td>
                                <Td>
                                  <Badge variant="subtle" colorScheme={STATUS_COLOR[req.status] || "gray"}>
                                    {STATUS_LABEL_KO[req.status] || req.status}
                                  </Badge>
                                </Td>
                                <Td isNumeric>{Number(req.newDataCount || 0).toLocaleString()}</Td>
                              </Tr>
                            )
                          })}
                        </Tbody>
                      </Table>
                    )}
                  </Box>
                </Box>
                <Box
                  display={{ base: "none", md: "block" }}
                  border="1px solid"
                  borderColor={border}
                  rounded="2xl"
                  p={5}
                  bg="white"
                  shadow="sm"
                >
                  <Stack spacing={4}>
                    <Flex justify="space-between" align="center">
                      <VStack align="start" spacing={1}>
                        <Badge
                          colorScheme={STATUS_COLOR[selectedRequestDetail?.status] || "gray"}
                          variant="subtle"
                          rounded="full"
                        >
                          {STATUS_LABEL_KO[selectedRequestDetail?.status] ||
                            selectedRequestDetail?.status ||
                            "선택된 요청 없음"}
                        </Badge>
                        <Heading size="md">요청 상세</Heading>
                      </VStack>
                      <Text fontSize="sm" color="gray.500">
                        {selectedRequestDetail?.requestedAt
                          ? new Date(selectedRequestDetail.requestedAt).toLocaleString()
                          : "-"}
                      </Text>
                    </Flex>
                    {selectedRequestDetail ? (
                      <>
                        <Text fontSize="sm" color="gray.600">
                          요약: {selectedRequestDetail.summary || "없음"}
                        </Text>
                        <Wrap spacing={2}>
                          {Object.entries(selectedRequestDetail.filter || {}).map(
                            ([key, value]) =>
                              value && (
                                <WrapItem key={key}>
                                  <Badge variant="subtle" colorScheme="gray">
                                    {formatFilterLabel(key)}: {value}
                                  </Badge>
                                </WrapItem>
                              )
                          )}
                        </Wrap>
                        <VStack align="stretch" spacing={2}>
                          <Text fontSize="sm" color="gray.500">
                            현재 기준 신규 데이터: {Number(selectedRequestDetail.newDataCount || 0).toLocaleString()}건
                          </Text>
                          <Text fontSize="sm" color="gray.500">
                            최신 성공 run ID: {selectedRequestDetail.latestSucceededRunId || "없음"}
                          </Text>
                          <Text fontSize="sm" color="gray.500">
                            연결된 학습 run ID: {selectedRequestDetail.trainingRunId || "없음"}
                          </Text>
                        </VStack>
                        <Stack direction={{ base: "column", sm: "row" }} spacing={3} width="100%">
                          <Button
                            colorScheme="blue"
                            width="100%"
                            onClick={runApproveConfirm.onOpen}
                            isDisabled={selectedRequestDetail.status !== "PENDING"}
                            isLoading={requestActionLoading}
                            fontSize={{ base: "sm", md: "md" }}
                          >
                            학습하기
                          </Button>
                          <Button
                            colorScheme="red"
                            width="100%"
                            variant="outline"
                            onClick={() => {
                              setRejectReason("")
                              onRejectOpen()
                            }}
                            isDisabled={selectedRequestDetail.status !== "PENDING"}
                            fontSize={{ base: "sm", md: "md" }}
                          >
                            반려
                          </Button>
                        </Stack>
                      </>
                    ) : (
                      <Text color="gray.500">요청을 선택해 상세 정보를 확인하세요.</Text>
                    )}
                  </Stack>
                </Box>
              </SimpleGrid>
              <Box
                mt={6}
                borderTop="1px solid"
                borderColor={border}
                pt={5}
                display={{ base: "none", md: "block" }}
              >
              <Flex
                justify="space-between"
                align="center"
                mb={3}
                flexDirection={{ base: "column", md: "row" }}
                gap={3}
              >
                <Text fontWeight="600" whiteSpace="nowrap">
                  신규 데이터 목록
                </Text>
                <Stack
                  ml={{ base: 0, md: "auto" }}
                  align="center"
                  spacing={3}
                  flexDirection={{ base: "column", md: "row" }}
                  flexWrap="wrap"
                  width="100%"
                  justify={{ base: "flex-start", md: "flex-end" }}
                >
                  
                  <HStack spacing={2} flexWrap="wrap" align="center">
                    <InputGroup
                    flex={{ base: "1 1 auto", md: "0 0 320px" }}
                    minW="220px"
                    maxW={{ base: "100%", md: "320px" }}
                  >
                    <InputLeftElement pointerEvents="none">
                      <SearchIcon color="gray.400" />
                    </InputLeftElement>
                    <Input
                      placeholder="프로젝트명 / 지역 검색"
                      size="sm"
                      background={whiteBg}
                      borderColor={border}
                      value={requestNewDataSearchInput}
                      onChange={(e) => setRequestNewDataSearchInput(e.target.value)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleRequestNewDataSearch()
                        }
                      }}
                      paddingLeft="32px"
                    />
                  </InputGroup>
                    <Button size="sm" colorScheme="blue" onClick={handleRequestNewDataSearch}>
                      검색
                    </Button>
                    <Button size="sm" variant="ghost" onClick={handleRequestNewDataReset}>
                      초기화
                    </Button>
                    <Button size="sm" variant="outline" onClick={handleOpenNewDataModal}>
                      전체 보기
                    </Button>
                    <Text fontSize="sm" color="gray.500">
                      총 {Number(requestNewData.total).toLocaleString()}건
                    </Text>
                  </HStack>
                </Stack>
              </Flex>
              <Box
                border="1px solid"
                borderColor={border}
                rounded="xl"
                bg={softBg}
                p={4}
                mb={4}
              >
                <Text fontSize="sm" fontWeight="600">
                  신규 {Number(selectedRequestDetail?.newDataCount ?? requestNewData.total ?? 0).toLocaleString()}건의 학습 데이터가 추가되었습니다.
                </Text>
                <Text fontSize="xs" color="gray.600">
                  이전 성공한 학습 run #{selectedRequestDetail?.latestSucceededRunId ?? "없음"} 기준으로 새로 수집된 데이터입니다.
                </Text>
                {/* {requestNewDataStats?.highest && (
                  <Text fontSize="xs" color="red.500">
                    이상치 후보: 총공사비 {formatCurrency(requestNewDataStats.highest.total_cost)} (ID {requestNewDataStats.highest.id}, {requestNewDataStats.highest.project_name || "프로젝트명 없음"})
                  </Text>
                )} 
                {anomalyReasonText && (
                  <Text fontSize="xs" color="red.600">
                    {anomalyReasonText}
                  </Text>
                )}*/}
              </Box>
                <Box border="1px solid" borderColor={border} rounded="2xl" overflow="hidden">
                  {requestNewDataLoading ? (
                    <Flex align="center" justify="center" py={12}>
                      <Spinner colorScheme="orange" />
                    </Flex>
                  ) : requestNewData.items.length === 0 ? (
                    <Flex align="center" justify="center" py={12}>
                      <Text color="gray.500">신규 데이터가 없습니다.</Text>
                    </Flex>
                  ) : isMobile ? (
                    <VStack spacing={3} align="stretch" p={4}>
                      {requestNewData.items.map((item) => (
                        <Box
                          key={item.id}
                          border="1px solid"
                          borderColor={border}
                          rounded="xl"
                          p={3}
                          pt={{ base: 9, md: 4 }}
                          bg={whiteBg}
                          transition="all 0.2s ease"
                          _hover={{
                            borderColor: "blue.300",
                            boxShadow: "md",
                            transform: "translateY(-1px)",
                          }}
                          position="relative"
                          overflow="hidden"
                        >
                          <Badge
                            position="absolute"
                            top={3}
                            right={3}
                            colorScheme="purple"
                            variant="solid"
                            fontSize="xs"
                            borderRadius="full"
                          >
                            {item.district || item.region || "지역 미정"}
                          </Badge>
                          <Box mt={{ base: 11, md: 4 }}>
                            <Text
                              fontWeight="semibold"
                              noOfLines={2}
                              wordBreak="break-word"
                              lineHeight={1.3}
                            >
                              {item.project_name || "프로젝트명 없음"}
                            </Text>
                          </Box>
                          <Text fontSize="sm" color={mutedColor}>
                            접수일: {item.received_date || "-"}
                          </Text>
                          <Text fontSize="sm" color={mutedColor}>
                            총공사비: {item.total_cost ? Number(item.total_cost).toLocaleString() + "원" : "-"}
                          </Text>
                          <Text fontSize="xs" color="gray.400">
                            ID: {item.id}
                          </Text>
                        </Box>
                      ))}
                    </VStack>
                  ) : (
                    <>
                      <Table variant="simple" size="sm">
                        <Thead bg={tableHeaderBg}>
                          <Tr>
                            <Th>ID</Th>
                            <Th>공사명</Th>
                            <Th>지역</Th>
                            <Th>접수일</Th>
                            <Th isNumeric>공사비</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {requestNewData.items.map((item) => {
                            const selected = selectedNewDataItem?.id === item.id
                            return (
                              <Tr
                                key={item.id}
                                cursor="pointer"
                                bg={selected ? "blue.50" : "transparent"}
                                _hover={{ bg: newDataRowHover }}
                                transition="background 0.2s"
                                onClick={() => handleSelectNewDataItem(item)}
                              >
                                <Td>{item.id}</Td>
                                <Td>
                                  <Text fontWeight="semibold">{item.project_name || "프로젝트명 없음"}</Text>
                                </Td>
                                <Td>{item.district || item.region || "-"}</Td>
                                <Td>{item.received_date || "-"}</Td>
                                <Td isNumeric>
                                  {item.total_cost ? Number(item.total_cost).toLocaleString() : "-"}
                                </Td>
                              </Tr>
                            )
                          })}
                        </Tbody>
                      </Table>
                    </>
                  )}
                  {myRequests.length > 0 && (
                    null
                  )}
                </Box>
                <Flex
                  mt={3}
                  align="center"
                  justify="space-between"
                  wrap="wrap"
                  gap={3}
                  p={3}
                  bg={tableBg}
                  borderRadius="xl"
                  border="1px solid"
                  borderColor={border}
                >
                  <Text fontSize="sm" color={paginationTextColor} fontWeight="500">
                    총 {Number(requestNewData.total).toLocaleString()}건
                  </Text>
                  <HStack spacing={2}>
                    <Button
                      size={paginationButtonSize}
                      variant="outline"
                      borderColor={border}
                      color={paginationTextColor}
                      borderRadius="md"
                      onClick={() => setRequestNewDataPage((prev) => Math.max(prev - 1, 1))}
                      isDisabled={requestNewDataPage === 1}
                    >
                      이전
                    </Button>
                    <Box
                      fontSize="sm"
                      minW="90px"
                      textAlign="center"
                      fontWeight="600"
                      color={paginationTextColor}
                      px={3}
                      py={1}
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="md"
                    >
                      {requestNewDataPage} / {requestNewDataTotalPages}
                    </Box>
                    <Button
                      size={paginationButtonSize}
                      variant="outline"
                      borderColor={border}
                      color={paginationTextColor}
                      borderRadius="md"
                      onClick={() =>
                        setRequestNewDataPage((prev) =>
                          prev < requestNewDataTotalPages ? prev + 1 : prev
                        )
                      }
                      isDisabled={requestNewDataPage >= requestNewDataTotalPages}
                    >
                      다음
                    </Button>
                  </HStack>
                </Flex>
              </Box>
              <Modal
                isOpen={newDataModal.isOpen}
                onClose={newDataModal.onClose}
                size={isMobile ? "full" : "4xl"}
                isCentered={!isMobile}
                scrollBehavior="inside"
              >
                <ModalOverlay />
                <ModalContent
                  maxW={{ base: "100vw", md: "1200px" }}
                  minW={{ base: "100vw", md: "900px" }}
                  minH={isMobile ? "100vh" : undefined}
                  borderRadius={isMobile ? 0 : "2xl"}
                  borderBottomRadius={isMobile ? 0 : undefined}
                  maxH={{ base: "100vh", md: "calc(100vh - 88px)" }}
                  my={{ base: 0, md: 6 }}
                  overflow="hidden"
                >
                  <ModalHeader position="relative" pb={0}>
                    <Text fontWeight="600">신규 데이터 전체 보기</Text>
                    <IconButton
                      aria-label="닫기"
                      icon={<CloseIcon />}
                      size="sm"
                      variant="ghost"
                      position="absolute"
                      top={3}
                      right={3}
                      onClick={newDataModal.onClose}
                    />
                  </ModalHeader>
                <ModalBody
                  px={4}
                  py={3}
                  display="flex"
                  flexDirection="column"
                  gap={3}
                  maxH={isMobile ? "calc(100vh - 120px)" : "calc(80vh - 150px)"}
                  overflowY="auto"
                  minH={0}
                  sx={{ WebkitOverflowScrolling: "touch" }}
                >
                    <HStack spacing={2}>
                      <Input
                        placeholder="프로젝트명/지역 검색"
                        value={modalSearchInput}
                        onChange={(e) => setModalSearchInput(e.target.value)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            handleModalSearch()
                          }
                        }}
                      />
                      <Button
                        size="sm"
                        colorScheme="blue"
                        leftIcon={<SearchIcon />}
                        onClick={handleModalSearch}
                      >
                        검색
                      </Button>
                    </HStack>
                  <Box
                    flex="1"
                    minH={0}
                    overflowY="auto"
                    border="1px solid"
                    borderColor={border}
                    rounded="xl"
                    p={3}
                  >
                      {modalNewDataLoading ? (
                        <Flex align="center" justify="center" py={6}>
                          <Spinner colorScheme="orange" />
                        </Flex>
                      ) : modalNewData.items.length === 0 ? (
                        <Flex align="center" justify="center" py={6}>
                          <Text color="gray.500">검색 결과가 없습니다.</Text>
                        </Flex>
                      ) : (
                        <VStack spacing={4} align="stretch">
                        {modalNewData.items.map((item) => (
                          <Box
                            key={`modal-${item.id}`}
                            border="1px solid"
                            borderColor={border}
                            rounded="2xl"
                            p={5}
                            bg={whiteBg}
                            shadow="md"
                            transition="all 0.2s ease"
                            _hover={{
                              borderColor: "blue.300",
                              boxShadow: "lg",
                              transform: "translateY(-1px)",
                            }}
                          >
                              <Flex justify="space-between" align="center" flexWrap="wrap" gap={2}>
                                <VStack align="start" spacing={0}>
                                  <Text fontWeight="bold" fontSize="lg">
                                    {item.project_name || "프로젝트명 없음"}
                                  </Text>
                                  <Text fontSize="xs" color="gray.500">
                                    ID {item.id}
                                  </Text>
                                </VStack>
                                <Badge colorScheme="blue" variant="subtle">
                                  {item.type || "-"}
                                </Badge>
                              </Flex>
                              <Divider my={3} />
                              <Text fontSize="sm" fontWeight="600">
                                기본 정보
                              </Text>
                              {renderFieldsGrid(GENERAL_INFO_FIELDS, item)}
                              <Divider my={3} />
                              <Flex justify="space-between" align="center" flexWrap="wrap">
                                <Text fontSize="sm" fontWeight="600">
                                  면적/구조 정보
                                </Text>
                                <Button
                                  size="xs"
                                  variant="ghost"
                                  rightIcon={
                                    dimensionDisclosure.isOpen ? (
                                      <ChevronUpIcon />
                                    ) : (
                                      <ChevronDownIcon />
                                    )
                                  }
                                  onClick={dimensionDisclosure.onToggle}
                                >
                                  {dimensionDisclosure.isOpen ? "접기" : "펼치기"}
                                </Button>
                              </Flex>
                              <Collapse in={dimensionDisclosure.isOpen}>
                                {renderFieldsGrid(DIMENSION_FIELDS, item)}
                              </Collapse>
                              <Divider my={3} />
                              <Flex justify="space-between" align="center" flexWrap="wrap">
                                <Text fontSize="sm" fontWeight="600">
                                  비용 내역
                                </Text>
                                <Button
                                  size="xs"
                                  variant="ghost"
                                  rightIcon={
                                    costDisclosure.isOpen ? (
                                      <ChevronUpIcon />
                                    ) : (
                                      <ChevronDownIcon />
                                    )
                                  }
                                  onClick={costDisclosure.onToggle}
                                >
                                  {costDisclosure.isOpen ? "접기" : "펼치기"}
                                </Button>
                              </Flex>
                              <Collapse in={costDisclosure.isOpen}>
                                {renderFieldsGrid(COST_FIELDS, item)}
                              </Collapse>
                              <Divider my={3} />
                              <Flex justify="space-between" align="center" flexWrap="wrap">
                                <Text fontSize="sm" fontWeight="600">
                                  기타 메타
                                </Text>
                                <Button
                                  size="xs"
                                  variant="ghost"
                                  rightIcon={
                                    metaDisclosure.isOpen ? (
                                      <ChevronUpIcon />
                                    ) : (
                                      <ChevronDownIcon />
                                    )
                                  }
                                  onClick={metaDisclosure.onToggle}
                                >
                                  {metaDisclosure.isOpen ? "접기" : "펼치기"}
                                </Button>
                              </Flex>
                              <Collapse in={metaDisclosure.isOpen}>
                                {renderFieldsGrid(META_FIELDS, item)}
                              </Collapse>
                            </Box>
                          ))}
                        </VStack>
                      )}
                    </Box>
                  </ModalBody>
                <ModalFooter
                  flexDirection="column"
                  gap={3}
                  px={4}
                  py={3}
                  position={isMobile ? "sticky" : undefined}
                  bottom={isMobile ? 0 : undefined}
                  bg={isMobile ? whiteBg : undefined}
                  borderTop="1px solid"
                  borderColor={border}
                >
                    <Flex
                      align="center"
                      justify="space-between"
                      width="100%"
                      flexWrap="wrap"
                      gap={3}
                      p={3}
                      bg={tableBg}
                      borderRadius="xl"
                      border="1px solid"
                      borderColor={border}
                    >
                      <Text fontSize="sm" color={paginationTextColor} fontWeight="500">
                        총 {Number(modalNewData.total || 0).toLocaleString()}건
                      </Text>
                      <HStack spacing={2}>
                        <Button
                          size={paginationButtonSize}
                          variant="outline"
                          borderColor={border}
                          color={paginationTextColor}
                          borderRadius="md"
                          onClick={() => setModalPage((prev) => Math.max(prev - 1, 1))}
                          isDisabled={modalPage === 1}
                        >
                          이전
                        </Button>
                        <Box
                          fontSize="sm"
                          minW="90px"
                          textAlign="center"
                          fontWeight="600"
                          color={paginationTextColor}
                          px={3}
                          py={1}
                          bg="white"
                          border="1px solid"
                          borderColor="gray.200"
                          borderRadius="md"
                        >
                          {modalPage} / {modalNewDataTotalPages}
                        </Box>
                        <Button
                          size={paginationButtonSize}
                          variant="outline"
                          borderColor={border}
                          color={paginationTextColor}
                          borderRadius="md"
                          onClick={() =>
                            setModalPage((prev) =>
                              prev < modalNewDataTotalPages ? prev + 1 : prev
                            )
                          }
                          isDisabled={modalPage >= modalNewDataTotalPages}
                        >
                          다음
                        </Button>
                      </HStack>
                    </Flex>
                    <Button onClick={newDataModal.onClose} size="sm" alignSelf="flex-end">
                      닫기
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isNewDataDetailOpen}
                onClose={handleCloseNewDataDetailModal}
                size={isMobile ? "full" : "2xl"}
                isCentered={!isMobile}
                motionPreset="scale"
                scrollBehavior="inside"
              >
                <ModalOverlay />
                <ModalContent
                  maxW={{ base: "100vw", md: "960px" }}
                  minH={{ base: "100vh", md: "auto" }}
                  h={isMobile ? "100vh" : "auto"}
                  borderRadius={{ base: "0", md: "2xl" }}
                  display="flex"
                  flexDirection="column"
                  maxH={isMobile ? "100vh" : "calc(100vh - 96px)"}
                  my={{ base: 0, md: 6 }}
                  overflow="hidden"
                  sx={{ WebkitOverflowScrolling: "touch", overscrollBehavior: "contain" }}
                >
                  <ModalHeader>
                    <Flex justify="space-between" align="center">
                      <Heading size="md">신규 데이터 상세</Heading>
                      <IconButton
                        aria-label="닫기"
                        icon={<CloseIcon />}
                        variant="ghost"
                        onClick={handleCloseNewDataDetailModal}
                      />
                    </Flex>
                  </ModalHeader>
                  <ModalBody
                    px={4}
                    py={3}
                    minH={0}
                    flex="1"
                    maxH={isMobile ? "calc(100vh - 88px)" : undefined}
                    display="flex"
                    flexDirection="column"
                    overflow="hidden"
                  >
                    <Box
                      flex="1"
                      minH={0}
                      overflowY="auto"
                      sx={{ WebkitOverflowScrolling: "touch", overscrollBehavior: "contain" }}
                      pb={isMobile ? 10 : 6}
                      touchAction="auto"
                      onWheel={(e) => e.stopPropagation()}
                      onTouchMove={(e) => e.stopPropagation()}
                    >
                    {selectedNewDataItem ? (
                      <NewDataDetailCard
                        item={selectedNewDataItem}
                        borderColor={border}
                        bgColor={whiteBg}
                        collapseOnMobile={Boolean(isMobile)}
                      />
                    ) : (
                      <Text color="gray.500" textAlign="center" py={6}>
                        선택된 신규 데이터가 없습니다.
                      </Text>
                    )}
                  </Box>
                </ModalBody>
                  {!isMobile && (
                    <ModalFooter>
                      <Button onClick={handleCloseNewDataDetailModal}>닫기</Button>
                    </ModalFooter>
                  )}
                </ModalContent>
              </Modal>
            </Box>
              ) : (
                <Box
                  bg="white"
                  shadow="lg"
                  rounded="3xl"
                  border="1px solid"
                  borderColor={border}
                  p={{ base: 6, md: 10 }}
                  mt={8}
                >
                  <Flex justify="space-between" align="center" mb={4} flexWrap="wrap" gap={2}>
                    <VStack align="start" spacing={1}>
                      <Heading size="lg">📝 내 학습 요청 현황</Heading>
                      <Text color="gray.500">내가 등록한 학습 요청을 언제든 확인하고 관리할 수 있습니다.</Text>
                    </VStack>
                    <Button
                      size="sm"
                      variant="outline"
                      colorScheme="blue"
                      leftIcon={<RepeatIcon />}
                      onClick={loadMyRequests}
                      isLoading={myRequestsLoading}
                    >
                      새로고침
                    </Button>
                  </Flex>
                  {myRequestsLoading ? (
                    <Flex align="center" justify="center" py={6}>
                      <Spinner colorScheme="orange" />
                    </Flex>
                  ) : myRequests.length === 0 ? (
                    <Flex align="center" justify="center" py={6}>
                      <Text color="gray.500">등록된 요청이 없습니다.</Text>
                    </Flex>
                  ) : (
                    <VStack spacing={3} align="stretch">
                      {paginatedMyRequests.map((req) => (
                        <Box
                          key={req.id}
                          border="1px solid"
                          borderColor={border}
                          rounded="2xl"
                          p={4}
                          bg={whiteBg}
                          _hover={{ borderColor: "blue.300", boxShadow: "sm" }}
                        >
                          <Flex justify="space-between" align="center" flexWrap="wrap" gap={2}>
                            <Text fontWeight="600">요청 #{req.id}</Text>
                            <Badge variant="subtle" colorScheme={STATUS_COLOR[req.status] || "gray"}>
                              {STATUS_LABEL_KO[req.status] || req.status}
                            </Badge>
                          </Flex>
                          <Text fontSize="sm" color="gray.500">
                            요청일시: {req.requestedAt ? new Date(req.requestedAt).toLocaleString() : "-"}
                          </Text>
                          <Text fontSize="sm" color="gray.500">
                            신규 데이터: {Number(req.newDataCount || 0).toLocaleString()}건
                          </Text>
                          <Text fontSize="xs" color="gray.600">
                            요약: {req.summary || "없음"}
                          </Text>
                          {req.status === "REJECTED" && req.rejectReason && (
                            <Text fontSize="xs" color="red.400" mt={1}>
                              반려 사유: {req.rejectReason}
                            </Text>
                          )}
                        </Box>
                      ))}
                    </VStack>
                  )}
                </Box>
              )}
            </Collapse>
          )}

          {/* LOGS SECTION */}
          <Collapse in={activeSection === "logs"}>
          {/* 검색/필터 바 – 앱 스타일 카드 + 칩 유형 (전체 포함) */}
            <Box
              position="sticky"
              top={{ base: "0px", md: "0px" }} 
              zIndex={20}
              mb={6}
              bg="transparent"
            >
            {/* 추가: 뒤로가기 버튼 */}
            <SectionBackButton
              onClick={() => {
                setNavDir("back");
                setActiveSection(null);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
            </Box>
            <Box ref={logsRef} bg="white" shadow="2xl" rounded="3xl" p={{ base: 6, md: 10 }} border="1px solid" borderColor={border} mt={8}>
              <Flex justify="space-between" align="center" mb={8} direction={{ base: "column", md: "row" }} gap={4}>
                <HStack>
                  <VStack align={{ base: "center", md: "start" }} spacing={2}>
                    <Heading size={{ base: "lg", md: "xl" }} color="gray.700">📈 실행 기록</Heading>
                    <Text color="gray.500" fontSize="md">모델 학습 과정과 결과를 확인할 수 있습니다</Text>
                    {/* <Text fontSize="sm" color="blue.500">
                      실행 중인 추가 데이터 {runningLogCount.toLocaleString()}건을 실행 기록에서 확인하세요.
                    </Text> */}
                  </VStack>
                </HStack>

                <HStack>
                  <Button
                    leftIcon={<SearchIcon />}
                    onClick={onRunPickerOpen}
                    variant="outline"
                    colorScheme="blue"
                    size={{ base: "md", md: "lg" }}
                    rounded="xl"
                  >
                    실행 선택
                  </Button>
                  <Button leftIcon={<RepeatIcon />} onClick={loadLogs} isLoading={logsLoading} colorScheme="blue" size={{ base: "md", md: "lg" }} shadow="md" rounded="xl">
                    새로고침
                  </Button>
                </HStack>
              </Flex>

              {/* 목록 (카드) */}
              <VStack spacing={4} align="stretch">
                {logsLoading && (
                  <Box textAlign="center" py={8}>
                    <VStack spacing={3}><Spinner size="lg" color="blue.500" /><Text color="gray.500">로그를 불러오는 중...</Text></VStack>
                  </Box>
                )}
                {!logsLoading && logs.length === 0 && (
                  <Box textAlign="center" py={8}><Text color="gray.500" fontSize="lg">📋 실행 기록이 없습니다.</Text></Box>
                )}
                {logs.map((r, index) => (<LogCard key={r.id} r={r} index={index} />))}
              </VStack>
            </Box>
          </Collapse>
        </VStack>
      </Container>
      {/*  학습 로딩 중 전체 화면 오버레이 */}
      {requestLoading && (
        <FullscreenLoader message="학습 요청을 생성 중입니다." />
      )}

      {/* 편집 모달 (프로젝트 클릭 시) */}
      <Modal
        isOpen={isEditOpen}
        onClose={() => { onEditClose(); setEditRow(null); setEditSource(null) }}
        size={isMobile ? "full" : "lg"}
        scrollBehavior="inside"
        blockScrollOnMount={true}
        trapFocus={true}
        motionPreset="slideInBottom"
      >
        <ModalOverlay />
        <ModalContent
          maxH={isMobile ? "100vh" : "90vh"}
          borderRadius={isMobile ? 0 : "2xl"}
          borderBottomRadius={0}
          display="flex"
          flexDirection="column"
          h={isMobile ? "100vh" : undefined}
          sx={{ overscrollBehaviorY: "contain" }}
        >
          <ModalHeader>
            <HStack justify="space-between">
              <Heading size="md">데이터 편집</Heading>
              {editSource && (
                <Badge
                  colorScheme={editSource === "pred" ? "purple" : "blue"}
                  variant="solid"
                  rounded="full"
                  px={3}
                  py={1}
                >
                  {editSource === "pred" ? "예측 데이터 편집" : "학습 데이터 편집"}
                </Badge>
              )}
            </HStack>
          </ModalHeader>
          <ModalBody
            flex="1"
            minH={0}
            overflowY="auto"
            sx={{ overscrollBehaviorY: "contain" }}
            onWheel={(e) => { e.stopPropagation(); }}
            onTouchMove={(e) => { e.stopPropagation(); }}
          >
            {editRow && (
              <>
                {/* 클릭한 기본 정보 표시 (읽기전용) */}
                <Box mb={4} p={3} border="1px solid" borderColor={border} rounded="md" bg={whiteBg}>
                  <SimpleGrid columns={2} spacing={3}>
                    <Box>
                      <Text fontSize="xs" color="gray.500">ID</Text>
                      <Text fontWeight="semibold">#{editRow.id}</Text>
                    </Box>
                    <Box>
                      <Text fontSize="xs" color="gray.500">유형</Text>
                      <Text>{editRow.type ?? "-"}</Text>
                    </Box>
                    <Box gridColumn="1 / -1">
                      <Text fontSize="xs" color="gray.500">프로젝트</Text>
                      <Text noOfLines={1} fontWeight="semibold">{editRow.project_name ?? "-"}</Text>
                    </Box>
                    <Box>
                      <Text fontSize="xs" color="gray.500">지역</Text>
                      <Text>{[editRow.region, editRow.district].filter(Boolean).join(" ") || "-"}</Text>
                    </Box>
                    <Box>
                      <Text fontSize="xs" color="gray.500">접수일</Text>
                      <Text>{editRow.received_date ?? "-"}</Text>
                    </Box>
                  </SimpleGrid>
                </Box>

                {/* 기본/신규 변수 편집 폼 */}
                <SimpleGrid columns={{ base: 2, md: 2 }} spacing={4} mb={4}>
                  
                  <FormControl>
                    <FormLabel>접수일</FormLabel>
                    <Input type="date" isReadOnly={!canEdit} value={editForm.received_date} onChange={(e)=>setEditForm((f)=>({ ...f, received_date: e.target.value }))} />
                  </FormControl>
                  <FormControl>
                    <FormLabel>연면적(평)</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.total_area_py} onChange={(v)=>setEditForm((f)=>({ ...f, total_area_py: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>마감수준</FormLabel>
                    <ChakraSelect
                      placeholder="선택하세요"
                      isDisabled={!canEdit}
                      value={editForm.finish_level}
                      onChange={(e)=>setEditForm((f)=>({ ...f, finish_level: e.target.value }))}
                    >
                      {finishLevelOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </ChakraSelect>
                  </FormControl>
                  <FormControl>
                    <FormLabel>세대 창호</FormLabel>
                    <ChakraSelect
                      placeholder="선택하세요"
                      isDisabled={!canEdit}
                      value={editForm.household_window}
                      onChange={(e)=>setEditForm((f)=>({ ...f, household_window: e.target.value }))}
                    >
                      {householdWindowOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </ChakraSelect>
                  </FormControl>
                  {renderStructureInputs({
                    values: editForm,
                    onChange: (key, value) => setEditForm((prev) => ({ ...prev, [key]: value })),
                    typeValue: editForm.type,
                    disabled: !canEdit,
                  })}
                  <FormControl>
                    <FormLabel>지하공법</FormLabel>
                    <ChakraSelect
                      placeholder="선택하세요"
                      isDisabled={!canEdit}
                      value={editForm.construction_method}
                      onChange={(e)=>setEditForm((f)=>({ ...f, construction_method: e.target.value }))}
                    >
                      {["순타","역타"].map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </ChakraSelect>
                  </FormControl>
                  <FormControl>
                    <FormLabel>평균평형</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.avg_area_py} onChange={(v)=>setEditForm((f)=>({ ...f, avg_area_py: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>공기(개월)</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.duration_months} onChange={(v)=>setEditForm((f)=>({ ...f, duration_months: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>지상층수</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.floors_above} onChange={(v)=>setEditForm((f)=>({ ...f, floors_above: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>지하층수</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.floors_below} onChange={(v)=>setEditForm((f)=>({ ...f, floors_below: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>암반비율</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.rock_ratio} onChange={(v)=>setEditForm((f)=>({ ...f, rock_ratio: v }))}>
                      <NumberInputField placeholder="예: 15 (15%)" />
                    </NumberInput>
                    <Text fontSize="xs" color="gray.500" mt={1}>
                      풍화암 기준으로 입력하세요.
                    </Text>
                  </FormControl>
                  <FormControl>
                    <FormLabel>대지 조건</FormLabel>
                    <ChakraSelect
                      placeholder="선택하세요"
                      isDisabled={!canEdit}
                      value={editForm.slope_type}
                      onChange={(e)=>setEditForm((f)=>({ ...f, slope_type: e.target.value }))}
                    >
                      {Object.entries(SLOPE_OPTION_LABELS).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </ChakraSelect>
                  </FormControl>
                  <FormControl>
                    <FormLabel>동수</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.building_count} onChange={(v)=>setEditForm((f)=>({ ...f, building_count: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>대지면적(㎡)</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.site_area} onChange={(v)=>setEditForm((f)=>({ ...f, site_area: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>공급면적(㎡)</FormLabel>
                    <NumberInput isReadOnly={!canEdit} value={editForm.supply_area} onChange={(v)=>setEditForm((f)=>({ ...f, supply_area: v }))}>
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel>수변 여부</FormLabel>
                    <RadioGroup
                      isDisabled={!canEdit}
                      value={editForm.is_coastal}
                      onChange={(v)=>setEditForm((f)=>({ ...f, is_coastal: v }))}
                    >
                      <HStack spacing={4}>
                        <Radio value="1">예</Radio>
                        <Radio value="0">아니오</Radio>
                      </HStack>
                    </RadioGroup>
                  </FormControl>
                </SimpleGrid>

                {/* 숫자형 편집 폼 */}
                <SimpleGrid columns={{ base: 3, md: 2 }} spacing={4}>
                  <FormControl>
                    <FormLabel>공사비</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.total_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, total_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 12000" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>건축비</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.building_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, building_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 8000000" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>암반비율</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.rock_ratio}
                      onChange={(v) => setEditForm((f) => ({ ...f, rock_ratio: v }))}
                    >
                      <NumberInputField placeholder="예: 15 (15%)" />
                    </NumberInput>
                    <Text fontSize="xs" color="gray.500" mt={1}>
                      풍화암 기준으로 입력하세요.
                    </Text>
                  </FormControl>

                  <FormControl>
                    <FormLabel>토목</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.civil_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, civil_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 1000" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>전기</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.electrical_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, electrical_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 800" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>설비</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.facility_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, facility_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 900" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>경상비</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.opex_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, opex_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 300" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>기타</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.etc_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, etc_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 120" />
                    </NumberInput>
                  </FormControl>

                  <FormControl>
                    <FormLabel>공통</FormLabel>
                    <NumberInput
                      isReadOnly={!canEdit}
                      value={editForm.common_cost}
                      onChange={(v) => setEditForm((f) => ({ ...f, common_cost: v }))}
                    >
                      <NumberInputField placeholder="예: 500" />
                    </NumberInput>
                  </FormControl>
                </SimpleGrid>
              </>
            )}
          </ModalBody>
          <ModalFooter
            position={isMobile ? "relative" : "static"}
            mt={isMobile ? "auto" : 0}
            h={modalFooterButtonHeight}
            minH={modalFooterButtonHeight}
            p={0}
            w="100%"
          >
            <HStack spacing={isMobile ? 2 : 3} w="100%" h="100%" align="stretch">
              <Button
                variant="ghost"
                onClick={() => { onEditClose(); setEditRow(null); setEditSource(null) }}
                size={modalFooterButtonSize}
                h={modalFooterButtonHeight}
                flex={1}
                borderRadius={0}
              >
                닫기
              </Button>
              {isAdmin && (
                <Button
                  colorScheme={editSource === "pred" ? "purple" : "blue"}
                  onClick={saveEditModal}
                  size={modalFooterButtonSize}
                  h={modalFooterButtonHeight}
                  flex={1}
                  borderRadius={0}
                >
                  수정
                </Button>
              )}
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* 학습 실행 확인 모달 */}
      <Modal isOpen={isTrainConfirmOpen} onClose={onTrainConfirmClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>학습 요청을 제출할까요?</ModalHeader>
            <ModalBody>
              입력하신 필터 조건으로 학습 요청이 생성됩니다.<br />
              <b>시스템 관리자 확인 후 학습이 실행</b>되며, 완료 알림을 받게 됩니다. 진행하시겠습니까?
            </ModalBody>
            <ModalFooter>
              <HStack spacing={3}>
                <Button variant="ghost" onClick={onTrainConfirmClose}>취소</Button>
                <Button colorScheme="blue" onClick={handleConfirmRequest} isLoading={requestLoading}>
                  요청하기
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* 학습 실행 팝업 */}
        <Modal isOpen={runApproveConfirm.isOpen} onClose={runApproveConfirm.onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>학습 실행</ModalHeader>
            <ModalBody>
              학습을 실행하겠습니까?
            </ModalBody>
            <ModalFooter>
              <HStack spacing={3}>
                <Button variant="ghost" onClick={runApproveConfirm.onClose}>취소</Button>
                <Button colorScheme="blue" onClick={handleConfirmRunApprove} isLoading={requestActionLoading}>
                  실행하기
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal isOpen={isRejectOpen} onClose={onRejectClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>학습 요청 반려</ModalHeader>
            <ModalBody>
              <FormControl>
                <FormLabel>반려 사유</FormLabel>
                <Textarea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="반려 이유를 구체적으로 입력하세요."
                  size="md"
                />
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <HStack spacing={3} w="100%" justify="flex-end">
                <Button variant="ghost" onClick={() => { setRejectReason(""); onRejectClose(); }}>취소</Button>
                <Button
                  colorScheme="red"
                  onClick={handleRejectConfirm}
                  isLoading={requestActionLoading}
                >
                  반려하기
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      
      {/* 실행 선택(돋보기) 모달 */}
      <Modal isOpen={isRunPickerOpen} onClose={onRunPickerClose} size="4xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>실행 선택</ModalHeader>
          <ModalBody>
            <HStack mb={3}>
              <Input
                placeholder="ID, 타깃, 상태로 필터링"
                value={logFilter}
                onChange={(e) => setLogFilter(e.target.value)}
                bg="white"
              />
              <Button onClick={loadLogs} leftIcon={<RepeatIcon />} variant="outline">새로고침</Button>
            </HStack>

            {/* 목록: 데스크탑=테이블 / 모바일=카드 리스트 */}
            {(() => {
              const filtered = (logs || []).filter((r) => {
                const q = (logFilter || "").trim().toLowerCase()
                if (!q) return true
                const tgt = Array.isArray(r.targets) ? r.targets.join(",") : ""
                return String(r.id).includes(q)
                  || (r.status || "").toLowerCase().includes(q)
                  || tgt.toLowerCase().includes(q)
              })

              // 모바일용 카드
              const RunCard = ({ r }) => (
                <Box
                  key={r.id}
                  bg="white"
                  border="1px solid"
                  borderColor={border}
                  rounded="lg"
                  p={4}
                  shadow="sm"
                  _hover={{ shadow: "md" }}
                  transition="all 0.2s"
                >
                  <Flex justify="space-between" align="center" mb={2}>
                    <HStack spacing={3}>
                      <Text fontWeight="bold" color="blue.600">#{r.id}</Text>
                      {statusBadge(r.status)}
                    </HStack>
                    <Button
                      size="sm"
                      colorScheme="blue"
                      onClick={async () => {
                        await loadLogDetail(r.id)
                        onRunPickerClose()
                      }}
                    >
                      상세보기
                    </Button>
                  </Flex>

                  <VStack align="start" spacing={3}>
                    <VStack align="start" spacing={1} w="full">
                      <Badge colorScheme="blue" variant="subtle" rounded="full" px={2}>
                        공사 비용
                      </Badge>
                      <Text
                        fontSize="xs"
                        color="blue.600"
                        fontWeight="semibold"
                        whiteSpace="pre-wrap"
                        wordBreak="break-word"
                      >
                        {Array.isArray(r.targets)
                          ? r.targets.map((t) => (t === "기타비율" ? "기타비" : t)).join(", ")
                          : "-"}
                      </Text>
                    </VStack>

                    <HStack spacing={2}>
                      <Badge colorScheme="green" variant="subtle" rounded="full" px={2}>
                        시작
                      </Badge>
                      <Text fontSize="xs" color="gray.600">{r.started_at ?? "-"}</Text>
                    </HStack>

                    <HStack spacing={2}>
                      <Badge colorScheme="purple" variant="subtle" rounded="full" px={2}>
                        완료
                      </Badge>
                      <Text fontSize="xs" color="gray.600">{r.finished_at ?? "-"}</Text>
                    </HStack>
                  </VStack>
                </Box>
              )

              if (isMobile) {
                return (
                  <Box>
                    <Box maxH="420px" overflowY="auto">
                      <VStack spacing={3} align="stretch">
                        {logsLoading && (
                          <Box py={6} textAlign="center"><Spinner /></Box>
                        )}
                        {!logsLoading && filtered.length === 0 && (
                          <Box py={6} textAlign="center" color="gray.500">
                            실행 기록이 없습니다.
                          </Box>
                        )}
                        {!logsLoading && filtered.map((r) => <RunCard key={r.id} r={r} />)}
                      </VStack>
                    </Box>
                  </Box>
                )
              }

              // 데스크탑: 기존 테이블
              return (
                <Box border="1px solid" borderColor={border} rounded="lg" overflow="hidden" bg="white">
                  <Box maxH="420px" overflow="auto">
                    <Table size="sm" minW="720px">
                      <Thead bg="gray.50">
                        <Tr>
                          <Th>ID</Th>
                          <Th>상태</Th>
                          <Th>시작</Th>
                          <Th>종료</Th>
                          <Th>타겟</Th>
                          <Th>열기</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {logsLoading && (
                          <Tr><Td colSpan={6} py={6} textAlign="center"><Spinner /></Td></Tr>
                        )}
                        {!logsLoading && filtered.map((r) => (
                          <Tr key={r.id}>
                            <Td color="blue.600" fontWeight="semibold">{r.id}</Td>
                            <Td>{statusBadge(r.status)}</Td>
                            <Td>{r.started_at ?? "-"}</Td>
                            <Td>{r.finished_at ?? "-"}</Td>
                            <Td>
                              <Text fontSize="sm" color="blue.600">
                                {Array.isArray(r.targets) ? r.targets.join(", ") : ""}
                              </Text>
                            </Td>
                            <Td>
                              <Button
                                size="xs"
                                colorScheme="blue"
                                onClick={async () => {
                                  await loadLogDetail(r.id)
                                  onRunPickerClose()
                                }}
                              >
                                상세보기
                              </Button>
                            </Td>
                          </Tr>
                        ))}
                        {!logsLoading && logs.length === 0 && (
                          <Tr><Td colSpan={6} py={6} textAlign="center" color="gray.500">실행 기록이 없습니다.</Td></Tr>
                        )}
                      </Tbody>
                    </Table>
                  </Box>
                </Box>
              )
            })()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onRunPickerClose}>닫기</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* 실행 상세(traindata_run_json) 모달 */}
      <Modal isOpen={isRunModalOpen} onClose={onRunModalClose} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <HStack justify="space-between" w="full">
              <Heading size="md">실행 상세 요약 {selectedLog ? `(ID: ${selectedLog})` : ""}</Heading>
              <HStack>
                {logDetail?.status && statusBadge(logDetail.status)}
                <Button size="sm" onClick={() => selectedLog && loadLogDetail(selectedLog)} leftIcon={<RepeatIcon />} variant="outline">
                  새로고침
                </Button>
              </HStack>
            </HStack>
          </ModalHeader>
          <ModalBody>
            {/* 중앙 메시지 (모바일만 1회 노출, 자동 숨김) */}
            {isMobile && (
            <CenterBodyOverlayMessage
              message="쓸어 넘겨 보세요"
              sub="좌우 스와이프로 다음 내용을 볼 수 있어요."
              duration={2200}
            />
            )}
            {!runSummary && (
              <Box py={8} textAlign="center" color="gray.500">
                데이터가 없습니다.
              </Box>
            )}

            {runSummary && (
              <VStack align="stretch" spacing={6}>
                {/* 탭으로 3구역 분리 (모바일: 탭 제거 + < > + 스와이프 / 데스크탑: 탭 유지) */}
                <Tabs
                  variant="enclosed"
                  size="sm"
                  colorScheme="blue"
                  isFitted
                  index={runTab}
                  onChange={(i) => {
                    // 데스크탑에서 탭 클릭 시 애니 방향 추정
                    setSlideDir(i > runTab ? 'left' : 'right');
                    setRunTab(i);
                  }}
                >
                  {/* 🖥 데스크탑 전용 TabList (모바일에서는 렌더링 안 함) */}
                  {!isMobile && (
                    <TabList
                      position="sticky"
                      top={0}
                      zIndex={2}
                      bg="white"
                      m={0}
                      borderTopRadius={0}
                      boxShadow="sm"
                    >
                      <Tab>총 평균 정확도</Tab>
                      <Tab>유형별 평균 정확도</Tab>
                      <Tab>개별 데이터 정확도</Tab>
                    </TabList>
                  )}

                  {/* ===== 컨텐츠 + 모바일 화살표/스와이프/애니메이션 ===== */}
                  <Box
                    position="relative"
                    // 스와이프
                    onTouchStart={onSwipeStart}
                    onTouchMove={onSwipeMove}
                    onTouchEnd={onSwipeEnd}
                    sx={{ overscrollBehavior: "contain" }}
                    style={{ touchAction: "pan-y" }}
                  >
                    {/* 모바일: 좌/우 중앙 화살표 (상단 바 없음) */}
                    {/* {isMobile && (
                      <>
                        <IconButton
                          aria-label="이전"
                          icon={<ChevronLeftIcon />}
                          variant="ghost"
                          position="absolute"
                          top="50%"
                          left="4px"
                          transform="translateY(-50%)"
                          onClick={prevRunTab}
                          isDisabled={runTab === 0}
                          zIndex={2}
                          rounded="full"
                          bg="whiteAlpha.800"
                          _hover={{ bg: "white" }}
                        />
                        <IconButton
                          aria-label="다음"
                          icon={<ChevronRightIcon />}
                          variant="ghost"
                          position="absolute"
                          top="50%"
                          right="4px"
                          transform="translateY(-50%)"
                          onClick={nextRunTab}
                          isDisabled={runTab === RUN_LAST_INDEX}
                          zIndex={2}
                          rounded="full"
                          bg="whiteAlpha.800"
                          _hover={{ bg: "white" }}
                        />
                      </>
                    )} */}

                    {/* 패널 슬라이드 애니메이션 */}
                    <AnimatePresence initial={false} custom={slideDir} mode="wait">
                      <motion.div
                        key={runTab}
                        custom={slideDir}
                        variants={panelVariants}
                        initial="enter"
                        animate="center"
                      transition={{
                        type: "spring",
                        stiffness: 120,   // 강도 (낮추면 더 부드럽게)
                        damping: 20       // 감쇠 (높이면 덜 튕김)
                      }}
                      >
                      <TabPanels>
                        {/* 총 평균 정확도 */}
                        <TabPanel px={{ base: 0, md: 2 }}>
                          <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
                            {/* 한 줄 전체: 모바일 2칸, 데스크탑 3칸 */}
                            <GridItem colSpan={{ base: 2, md: 4 }} minW={0}>
                              <CountAndTypesCard
                                counts={byTypeArr}
                                total={runSummary?.total_cnt ?? 0}
                              />
                              {/* 필요 시 아래 섹션도 함께 배치 */}
                              {/* <TypeCountsSection counts={byTypeArr} total={runSummary?.total_cnt} /> */}
                            </GridItem>

                            {/* 이하 링 카드들은 1칸씩 */}
                            <RingStat label="공사비 평균 정확도" color={getAccuracyColor(runSummary?.all_total_cost_per)} value={runSummary?.all_total_cost_per} />
                            <RingStat label="건축비 평균 정확도" color={getAccuracyColor(runSummary?.all_building_cost_per)}   value={runSummary?.all_building_cost_per} />
                            <RingStat label="토목 평균 정확도"   color={getAccuracyColor(runSummary?.all_civil_cost_per)} value={runSummary?.all_civil_cost_per} />
                            <RingStat label="전기 평균 정확도"   color={getAccuracyColor(runSummary?.all_electrical_cost_per)}  value={runSummary?.all_electrical_cost_per} />
                            <RingStat label="설비 평균 정확도"   color={getAccuracyColor(runSummary?.all_facility_cost_per)}  value={runSummary?.all_facility_cost_per} />
                            <RingStat label="경상비 평균 정확도" color={getAccuracyColor(runSummary?.all_opex_cost_per)}  value={runSummary?.all_opex_cost_per} />
                            <RingStat label="공통 평균 정확도"   color={getAccuracyColor(runSummary?.all_common_cost_per)}   value={runSummary?.all_common_cost_per} />
                           </SimpleGrid>
                        </TabPanel>

                        {/* 유형별 평균 정확도 */}
                        <TabPanel px={{ base: 0, md: 2 }}>
                          {byTypeArr.length > 0 ? (
                            <Box p={4} border="1px solid" borderColor={border} rounded="xl" bg={softBg}>
                              <Heading size="sm" mb={3} color="gray.700">유형별 평균 정확도</Heading>

                              {isMobile ? (
                                <VStack align="stretch" spacing={3}>
                                  {byTypeArr.map((t) => (
                                    <Box
                                      key={t.type}
                                      bg="white"
                                      border="1px solid"
                                      borderColor={border}
                                      rounded="lg"
                                      p={4}
                                      shadow="sm"
                                    >
                                      <HStack justify="space-between" align="center" mb={2}>
                                        <HStack spacing={2}>
                                          <Heading size="sm" color="blue.600">{t.type || "-"}</Heading>
                                          <Badge variant="subtle" colorScheme="gray" rounded="full">총 {t.count ?? 0}건</Badge>
                                        </HStack>
                                      </HStack>

                                      <SimpleGrid columns={2} spacing={3}>
                                        <Box><Text fontSize="xs" color="gray.500">공사비</Text><Text fontWeight="semibold" color={getAccuracyColor(t.total_cost_per)}><Pct v={t.total_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">건축비</Text><Text fontWeight="semibold" color={getAccuracyColor(t.building_cost_per)}><Pct v={t.building_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">토목</Text><Text fontWeight="semibold" color={getAccuracyColor(t.civil_cost_per)}><Pct v={t.civil_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">전기</Text><Text fontWeight="semibold" color={getAccuracyColor(t.electrical_cost_per)}><Pct v={t.electrical_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">설비</Text><Text fontWeight="semibold" color={getAccuracyColor(t.facility_cost_per)}><Pct v={t.facility_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">경상비</Text><Text fontWeight="semibold" color={getAccuracyColor(t.opex_cost_per)}><Pct v={t.opex_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">공통</Text><Text fontWeight="semibold" color={getAccuracyColor(t.common_cost_per)}><Pct v={t.common_cost_per} /></Text></Box>
                                        <Box><Text fontSize="xs" color="gray.500">기타</Text><Text fontWeight="semibold" color={getAccuracyColor(t.etc_cost_per)}><Pct v={t.etc_cost_per} /></Text></Box>
                                      </SimpleGrid>
                                    </Box>
                                  ))}
                                </VStack>
                              ) : (
                                <Box border="1px solid" borderColor={border} rounded="xl" overflow="hidden" bg="white">
                                  <Box overflowX="auto">
                                    <Table size="sm" minW="900px">
                                      <Thead bg="gray.100">
                                        <Tr>
                                          <Th>유형</Th>
                                          <Th isNumeric>건수</Th>
                                          <Th isNumeric>공사비</Th>
                                          <Th isNumeric>건축비</Th>
                                          <Th isNumeric>토목</Th>
                                          <Th isNumeric>전기</Th>
                                          <Th isNumeric>설비</Th>
                                          <Th isNumeric>경상비</Th>
                                          <Th isNumeric>공통</Th>
                                          <Th isNumeric>기타</Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {byTypeArr.map((t) => (
                                          <Tr key={t.type}>
                                            <Td>{t.type || "-"}</Td>
                                            <Td>{t.count}</Td>
                                            <Td isNumeric color={getAccuracyColor(t.total_cost_per)}>
                                              <b><Pct v={t.total_cost_per} /></b>
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.building_cost_per)}>
                                              <Pct v={t.building_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.civil_cost_per)}>
                                              <Pct v={t.civil_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.electrical_cost_per)}>
                                              <Pct v={t.electrical_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.facility_cost_per)}>
                                              <Pct v={t.facility_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.opex_cost_per)}>
                                              <Pct v={t.opex_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.common_cost_per)}>
                                              <Pct v={t.common_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(t.etc_cost_per)}>
                                              <Pct v={t.etc_cost_per} />
                                            </Td>
                                          </Tr>
                                        ))}
                                      </Tbody>
                                    </Table>
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          ) : (
                            <Box py={8} textAlign="center" color="gray.500">유형별 데이터가 없습니다.</Box>
                          )}
                        </TabPanel>

                        {/* 개별 데이터 정확도 */}
                        <TabPanel px={{ base: 0, md: 2 }}>
                          <Box p={4} border="1px solid" borderColor={border} rounded="xl" bg={softBg}>
                            <Heading size="sm" mb={3} color="gray.700">개별 정확도 목록</Heading>

                            {/* 검색/필터 */}
                            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3} mb={3}>
                              <ChakraSelect
                                placeholder="유형 전체"
                                value={accFilter.type}
                                onChange={(e) => setAccFilter((s) => ({ ...s, type: e.target.value }))}
                                bg="white"
                              >
                                {accTypes.map((t) => <option key={t} value={t}>{t}</option>)}
                              </ChakraSelect>

                              <Input
                                placeholder="키워드 (프로젝트명)"
                                value={accFilter.q}
                                onChange={(e) => setAccFilter((s) => ({ ...s, q: e.target.value }))}
                                bg="white"
                              />

                              <HStack display={{ base: "none", md: "flex" }}>
                              <Button leftIcon={<SearchIcon />} onClick={() => setAccPage(1)} colorScheme="blue" w={{ base: "full", md: "auto" }}>
                                검색
                              </Button>
                              <Button variant="outline" onClick={() => { setAccFilter({ type: "", q: "", received_from: "", received_to: "" }); setAccPage(1); }} w={{ base: "full", md: "auto" }}>
                                초기화
                              </Button>
                            </HStack>
                          </SimpleGrid>
                          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3} mb={3}>
                            <FormControl>
                              <FormLabel fontSize="xs" mb={1}>접수일 (시작)</FormLabel>
                              <Input
                                type="date"
                                value={accFilter.received_from}
                                onChange={(e) => setAccFilter((s) => ({ ...s, received_from: e.target.value }))}
                                bg="white"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel fontSize="xs" mb={1}>접수일 (종료)</FormLabel>
                              <Input
                                type="date"
                                value={accFilter.received_to}
                                onChange={(e) => setAccFilter((s) => ({ ...s, received_to: e.target.value }))}
                                bg="white"
                              />
                            </FormControl>
                          </SimpleGrid>
                          <HStack display={{ base: "flex", md: "none" }} spacing={3} mb={3}>
                            <Button leftIcon={<SearchIcon />} onClick={() => setAccPage(1)} colorScheme="blue" w="100%">
                              검색
                            </Button>
                            <Button variant="outline" onClick={() => { setAccFilter({ type: "", q: "", received_from: "", received_to: "" }); setAccPage(1); }} w="100%">
                              초기화
                            </Button>
                          </HStack>

                            {/* 목록 */}
                            <Box border="1px solid" borderColor={border} rounded="xl" overflow="hidden" bg="white">
                              {isMobile ? (
                                <Box p={3} bg="white">
                                  {accPaged.length === 0 ? (
                                    <Box textAlign="center" py={6} color="gray.500">결과가 없습니다.</Box>
                                  ) : (
                                    <VStack spacing={3} align="stretch">
                                      {accPaged.map((r, i) => (<AccRowCard key={`${r.type}-${r.name}-${i}`} r={r} />))}
                                    </VStack>
                                  )}
                                </Box>
                              ) : (
                                <Box overflowX="auto">
                                  <Table size="sm" minW="900px">
                                    <Thead bg="gray.100">
                                      <Tr>
                                        <Th>유형</Th>
                                        <Th>프로젝트</Th>
                                        <Th cursor="pointer" onClick={toggleAccDateSort}>
                                          <HStack spacing={1}>
                                            <Text>접수일</Text>
                                            {accSortOrder === "desc" ? (
                                              <ChevronDownIcon w={3} h={3} />
                                            ) : (
                                              <ChevronUpIcon w={3} h={3} />
                                            )}
                                          </HStack>
                                        </Th>
                                        <Th isNumeric>공사비</Th>
                                        <Th isNumeric>건축비</Th>
                                        <Th isNumeric>토목</Th>
                                        <Th isNumeric>전기</Th>
                                        <Th isNumeric>설비</Th>
                                        <Th isNumeric>경상비</Th>
                                        <Th isNumeric>공통</Th>
                                        <Th isNumeric>기타</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {accPaged.length === 0 ? (
                                        <Tr>
                                          <Td colSpan={10} textAlign="center" py={6} color="gray.500">결과가 없습니다.</Td>
                                        </Tr>
                                      ) : (
                                        accPaged.map((r, i) => (
                                          <Tr key={`${r.type}-${r.name}-${i}`}>
                                            <Td>{r.type ?? "-"}</Td>
                                            <Td maxW="360px"><Text noOfLines={2}>{r.name ?? "-"}</Text></Td>
                                            <Td>{r.received_date || "-"}</Td>
                                            <Td isNumeric color={getAccuracyColor(r.total_cost_per)}>
                                              <b><Pct v={r.total_cost_per} /></b>
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.building_cost_per)}>
                                              <Pct v={r.building_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.civil_cost_per)}>
                                              <Pct v={r.civil_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.electrical_cost_per)}>
                                              <Pct v={r.electrical_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.facility_cost_per)}>
                                              <Pct v={r.facility_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.opex_cost_per)}>
                                              <Pct v={r.opex_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.common_cost_per)}>
                                              <Pct v={r.common_cost_per} />
                                            </Td>
                                            <Td isNumeric color={getAccuracyColor(r.etc_cost_per)}>
                                              <Pct v={r.etc_cost_per} />
                                            </Td>
                                          </Tr>
                                        ))
                                      )}
                                    </Tbody>
                                  </Table>
                                </Box>
                              )}

                              {/* 페이징 */}
                              <Flex align="center" justify="space-between" p={3} bg={tableBg} wrap="wrap" gap={3}>
                                <Text fontSize="sm" color="gray.600">총 {accFiltered.length.toLocaleString()}건</Text>
                                <HStack>
                                  <Button size="sm" variant="outline" onClick={() => setAccPage((p) => Math.max(1, p - 1))} isDisabled={accPage === 1}>
                                    이전
                                  </Button>
                                  <Box fontWeight="semibold" color="blue.600" minW="88px" textAlign="center">
                                    {accPage} / {accTotalPages}
                                  </Box>
                                  <Button size="sm" variant="outline" onClick={() => setAccPage((p) => Math.min(accTotalPages, p + 1))} isDisabled={accPage >= accTotalPages}>
                                    다음
                                  </Button>
                                  <ChakraSelect
                                    size="sm"
                                    w="80px"
                                    value={accPageSize}
                                    onChange={(e) => setAccPageSize(Number(e.target.value))}
                                    bg="white"
                                  >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                  </ChakraSelect>
                                </HStack>
                              </Flex>
                            </Box>
                          </Box>
                        </TabPanel>
                      </TabPanels>
                    </motion.div>
                  </AnimatePresence>
                </Box>
              </Tabs>
            </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onRunModalClose}>닫기</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
